const getTemplatePreviewHint = (name: string) =>
    `Content will be rendered from the "${name}" template when sent.`

const getTemplatePreviewIframeTitle = (name: string) =>
    `Preview of the "${name}" template`

const getTestEmailSentMessage = (email: string) => `Test email sent to ${email}`

const PHONE_NUMBER_LABEL = "Phone Number"
const BULK_ACTION_CANNOT_BE_UNDONE = "This action cannot be undone."

const COPY_CONSTANTS = {
    SELECT_DURATION: "Select duration",
    MEET_THE_TEAM: "Meet the Team",
    GROUP: "Group",
    SELECT_EVENT_TO_GROUP: "Select event to group",
    WEEK_OF_PREFIX: "Week of",
    BOOKINGS_TO_GROUP: "Bookings to Group",
    AND: "and",
    CREATE_BOOKING_GROUP: "Create Booking Group",
    SELECT_BOOKINGS_TO_GROUP: "Select Bookings to Group",
    CREATE_EVENT_GROUP: "Create Event Group",
    SELECT_EVENTS_TO_GROUP: "Select Events to Group",
    NO_EVENTS: "No events to group",
    VIEW_RESERVATION: "View Reservation",
    QUOTE: "Send Quote",
    VIEW_TEMPLATE: "View Template",
    WORKFLOWS: "Workflows",
    WORKFLOW: "Workflow",
    SYSTEM: "System",
    VIEW_BOOKING_DETAILS: "View Booking Details",
    LEAVE_REVIEW: "Leave review",
    BASIC: "Basic",
    INCLUDE: "Include",
    FEATURES: "Features",
    GUIDES: "Guides",
    CONTACT_LIST_CREATED: "Contact list created successfully!",
    CONTACT_LIST_UPDATED: "Contact list updated successfully!",
    CONTACT_UPDATED_SUCCESSFULLY: "Contact updated successfully!",
    CREATE_AUCTION_SUCCESS: "Auction created successfully!",
    UPDATE_AUCTION_SUCCESS: "Auction updated successfully!",
    ACCEPT_AUCTION_BIDS_SUCCESS: "Auction bids accepted successfully!",
    SEND_AWARDED_ITEM_SUCCESS: "Awarded item sent successfully!",
    SUBMIT_BID_SUCCESS: "Bid submitted successfully!",
    ENTER_EMAIL: "Enter email:",
    ENTER_WINNER_EMAIL: "Enter winner's email",
    AT_LEAST_ONE_CONDITION: "At least one condition is required",
    CONTACT: "Contact",
    MEALS: "Meals",
    CONDITION: "Condition",
    NO_CONTACTS_TO_SHOW: "No contacts to show",
    ADJUST_PROPERTIES_OR_VALUES:
        "Adjust the properties or values to see matching contacts here.",
    ADD_CONTACT_LIST: "Add Contact List",
    ADD_CONTACT_LIST_FROM_FILTERS: "Build list with filters",
    ADD_CONTACT_LIST_SELECT_PEOPLE: "Select people manually",
    AT_LEAST_ONE_CONTACT_SELECTED: "Select at least one contact",
    CONTACT_LIST_SELECTION_PREVIEW_HINT:
        "Select contacts from the list to preview them here.",
    CONTACT_LIST_DETAILS: "Contact List Details",
    CONTACT_LIST_FILTERS: "Contact List Filters",
    SYSTEM_LIST_INFO_TITLE: "System List",
    SYSTEM_LIST_INFO_DESCRIPTION:
        "This list is automatically managed by the system and cannot be edited or deleted.",
    SAVE_CONTACT_LIST_FILTERS_TOOLTIP: "Save changes to this list's filters",
    SAVE_MANUAL_LIST_SELECTIONS_TOOLTIP: "Save selected people to this list",
    CLOSE_MANUAL_LIST_ADD_PANEL_TOOLTIP: "Close and discard unsaved selections",
    CONTACT_LIST_NAME_REQUIRED: "Contact list name is required",
    CONTACT_LIST_NAME_MIN_LENGTH: "Name must be at least 1 character",
    CONTACT_LIST_NAME_MAX_LENGTH: "Name must be less than 255 characters",
    CONTACT_LIST_NAME_LABEL: "Name",
    CONTACT_LIST_NAME_PLACEHOLDER: "Enter Name",
    CONTACT_LIST_SELECT_CONTACTS_LABEL: "Select contacts",
    ADD_CONTACTS_TO_MANUAL_LIST: "Add people",
    ADD_CONTACTS_TO_MANUAL_LIST_MODAL_TITLE: "Add people to this list",
    CONTACTS_ADDED_TO_MANUAL_LIST: "People added to list",
    CONTACT_REMOVED_FROM_MANUAL_LIST: "Person removed from list",
    REMOVE_FROM_MANUAL_LIST_ARIA: "Remove from list",
    OPERATOR_EQUALS: "is equal to",
    OPERATOR_NOT_EQUALS: "is not equal to",
    OPERATOR_GREATER_THAN: "is greater than",
    OPERATOR_GREATER_THAN_OR_EQUAL: "is greater than or equal to",
    OPERATOR_LESS_THAN: "is less than",
    OPERATOR_LESS_THAN_OR_EQUAL: "is less than or equal to",
    PREVIEW: "Preview",
    PREVIEW_FORM: "Preview form",
    PROPERTY_KEY_REQUIRED: "Property is required",
    PROPERTY_TYPE_REQUIRED: "Property type is required",
    CONDITION_VALUE_REQUIRED: "Value is required",
    OPERATOR_REQUIRED: "Operator is required",
    SELECT_PROPERTY: "Select Property",
    SELECT_OPERATOR: "Select Operator",
    ENTER_VALUE: "Enter Value",
    ADD_CONDITION: "Add Condition",
    YES_NO: "Yes/No",
    PEOPLE: "people",
    FIELD_CANNOT_BE_EMPTY: "Field cannot be empty",
    ENTITY_TYPE: "Entity Type",
    DIGEST_PAGE_TITLE: "Here's What Happened This Week",
    DIGEST_PAGE_ENTITY_LABEL: "Category",
    DIGEST_PAGE_UNREAD_LABEL: "Unread",
    DIGEST_PAGE_UPCOMING_BOOKINGS_TITLE: "Upcoming Bookings",
    DIGEST_PAGE_NO_UPCOMING_BOOKINGS: "No bookings coming up",
    IS_SYSTEM_PROPERTY: "Is System Property",
    CUSTOM_PROPERTY_BANNER_TITLE_LINE:
        "Custom properties can't be edited after creation. To make changes, archive the current property and create a new one.",
    ENTER_DESCRIPTION: "Enter description",
    ENTER_TITLE: "Enter title",
    ENTER_SUBTITLE: "Enter subtitle",
    SELECT_PROPERTY_TYPE_REQUIRED: "Property type is required",
    PROPERTY_LABEL_REQUIRED: "Property label is required",
    ENTER_PROPERTY_LABEL: "Enter property label",
    SELECT_PROPERTY_TYPE: "Select property type",
    CUSTOM_PROPERTIES: "Custom Properties",
    PROPERTY_LABEL: "Property Label",
    PROPERTY_TYPE: "Property Type",
    CUSTOM_PROPERTY: "Custom Property",
    ADD_NEW_CUSTOM_PROPERTY: "Add Property",
    NO_CUSTOM_PROPERTIES: "No custom properties set",
    SAVE_CUSTOM_PROPERTY: "Save Custom Property",
    EDIT_CUSTOM_PROPERTIES: "Edit Custom Properties",
    SET_ENTITY_CUSTOM_PROPERTIES_SUCCESS:
        "Custom properties updated successfully",
    CREATE_OUTFITTER_CUSTOM_PROPERTY_SUCCESS:
        "Custom property created successfully",
    SELECT_CONTACT: "Select Contact",
    PAUSE_META_AD: "Pause Ad",
    ACTIVATE_META_AD: "Activate Ad",
    SYNCING: "Syncing...",
    AD_ACCOUNT: "Ad Account",
    ADVANCED_FILTERS: "Advanced Filters",
    HOW_SOON_ARE_YOU_LOOKING_TO_BOOK: "How soon are you looking to book?",
    INTEGRATION_SOURCE: "Integration Source",
    TRIP_AMOUNT: "Trip Amount",
    SELECT_FROM_DATE: "Select from date",
    SELECT_TO_DATE: "Select to date",
    AD_IMAGE_REQUIRED: "Ad image is required",
    TRIP: "trip",
    STAY: "stay",
    CREATE_META_AD_AND_CAMPAIGN_SUCCESS: "Meta ad created successfully",
    UPDATE_META_AD_SUCCESS: "Meta ad updated successfully",
    ACTIVATE_META_AD_MESSAGE: "Are you sure you want to activate this Meta ad?",
    PAUSE_META_AD_MESSAGE: "Are you sure you want to pause this Meta ad?",
    SPONSORED: "Sponsored",
    FILL_OUT_FORM_TO_BOOK:
        "Fill out the form and a guide from our team will call you soon!",
    DAILY_BUDGET_MUST_BE_GREATER_THAN: "Daily budget must be greater than $1",
    FACEBOOK_PAGE: "Facebook Page",
    CREATE_NEW_AD: "Create New Ad",
    NO_ADS_FOR_SELECTION: "No ads for the current selection",
    NO_ADS: "No ads",
    PERFORMANCES: "Performances",
    AD_PERFORMANCE_DATA: "Ad Performance Data",
    META_AD_SETTINGS: "Meta Ad Settings",
    META_AD_CONFIGURATION_DESCRIPTION:
        "This section configures the ad settings and object names in your meta dashboard.",
    META_AD_CONTENT: "Meta Ad Content",
    META_AD_CONTENT_DESCRIPTION:
        "This information will be shown in the ad to the target audience",
    META_AD_FORM: "Meta Ad Form",
    META_AD_FORM_DESCRIPTION:
        "This information will be shown in the form to the target audience",
    META_AD_NAME: "Ad Name",
    META_FORM_NAME: "Form Name",
    META_AD_NAME_PLACEHOLDER: "Enter ad name",
    META_FORM_NAME_PLACEHOLDER: "Enter form name",
    META_AD_END_DATE: "End Date",
    META_AD_DAILY_BUDGET: "Daily Budget",
    LEAD_FORM_TITLE: "Lead Form Title",
    LEAD_FORM_TITLE_PLACEHOLDER: "Enter lead form title",
    LEAD_FORM_DESCRIPTION: "Lead Form Description",
    AD_IMAGE: "Ad Image",
    LEAD_FORM_DESCRIPTION_PLACEHOLDER: "Enter lead form description",
    AD_TITLE: "Ad title",
    AD_TITLE_PLACEHOLDER: "Enter ad title",
    AD_CTA_LABEL: "Ad CTA Label",
    AD_CTA_LABEL_PLACEHOLDER: "Enter ad CTA label",
    CAMPAIGN_FOR: "Campaign for",
    AD_SET_FOR: "Ad Set for",
    AD_CREATIVE_FOR: "Ad Creative for",
    BOOK_YOUR: "Book your",
    TODAY_EXCLAMATION: "today!",
    READY_TO_BOOK: "Ready to book",
    APPROVE_BOOKING_NOW: "Approve this booking now?",
    UNNAMED_LEAD: "Unnamed Lead",
    UNNAMED: "Unnamed",
    VIEW_FULL_REVIEW: "View full review",
    FULL_REVIEW: "Full Review",
    SEE_ALL_REVIEWS: "See all reviews",
    UNVERIFIED: "Unverified",
    BY_YEAR: "By Year",
    BY_MONTH: "By Month",
    DISCONNECT: "Disconnect",
    DISCONNECT_QUICK_BOOKS: "Disconnect QuickBooks",
    TRIP_INSURANCE: {
        TITLE: "Travel Protection Added",
        FAILED_TITLE: "Failed to add travel protection",
        DESCRIPTION: "Travel insurance purchased through Mallard Bay",
        POLICY_NUMBER: "Policy Number",
    },
    PAID_ADS_REPORTING: "Ad Reporting",
    PAID_FACEBOOK_ADS: "Create Ads",
    ADDITIONAL_SOURCE_FORM_DATA: "Additional source form data",
    VERIFY_MICRODEPOSIT: "Verify microdeposit",
    NO_REVIEWS_YET:
        "You have not received any feedback about a completed trip.",
    NA: "N/A",
    EDIT: "Edit",
    CREATE_CONTACT: "Create Contact",
    EDIT_CONTACT: "Edit Contact",
    CONTACT_ROWS_MISSING_EMAIL_OR_PHONE:
        "Each contact must have an email or phone number. Missing in row(s):",
    OPT_OUT_OF_MARKETING: "Opt out of marketing",
    OPT_OUT_OF_MARKETING_CONFIRMATION_TITLE: "Opt out of marketing?",
    OPT_OUT_OF_MARKETING_CONFIRMATION_MESSAGE:
        "This contact will stop receiving marketing emails and SMS from your outfitter when those contact methods are on file. Booking confirmations, payment requests, and other transactional messages are not affected. Already scheduled marketing sends may still deliver.",
    OPT_OUT_OF_MARKETING_CONFIRM: "Opt out",
    OPT_OUT_OF_MARKETING_REQUIRES_CONTACT:
        "Add an email or phone to manage marketing opt-out.",
    OPT_OUT_OF_MARKETING_SUCCESS: "Marketing opt-out saved.",
    OPT_OUT_OF_MARKETING_SUCCESS_EMAIL_ONLY: "Marketing email opt-out saved.",
    OPT_OUT_OF_MARKETING_SUCCESS_SMS_ONLY: "Marketing SMS opt-out saved.",
    OPT_OUT_OF_MARKETING_SUCCESS_EMAIL_AND_SMS:
        "Marketing email and SMS opt-out saved.",
    OPT_OUT_OF_MARKETING_ERROR_NO_CONTACT:
        "Add an email or phone number before opting out of marketing.",
    MARKETING_OPTED_OUT: "Opted out of marketing",
    MARKETING_OPTED_OUT_EMAIL_ON: "Email opted out on",
    MARKETING_OPTED_OUT_EMAIL: "Email opted out",
    MARKETING_OPTED_OUT_SMS_ON: "SMS opted out on",
    MARKETING_OPTED_OUT_SMS: "SMS opted out",
    ADD_NEW_CONTACT: "Add New Contact",
    ADD: "Add",
    REMOVE: "Remove",
    CREATE: "Create",
    UPDATE: "Update",
    CHANGE: "Change",
    MANAGE: "Manage",
    DATES: "Dates",
    SELECT: "Select",
    MENU: "Menu",
    MORE_ACTIONS: "More",
    APPLY: "Apply",
    ATTRIBUTION_DISPLAY: {
        VIA: "via",
        WIDGET: "widget",
        DASHBOARD: "dashboard",
        STANDARD_QUOTE: "standard quote rate",
        MARKETPLACE_QUOTE: "marketplace quote rate",
        WEBSITE: "mallardbay.com",
    },
    CONFIRM_USER_FORM: {
        FIRST_NAME: "First name is a required field",
        LAST_NAME: "Last name is a required field",
        PHONE: "Phone number is a required field",
    },
    CHECK_IN_VALIDATION: {
        CHECK_IN_TIME_IS_REQUIRED: "Check-in time is required",
        CHECK_OUT_TIME_IS_REQUIRED: "Check-out time is required",
    },
    FEES_INFO: "Fees info",
    UPDATED_BOOKING_SUCCESS: "Successfully updated booking!",
    BOOKING_ACCEPTED_SUCCESS_MESSAGE: "Booking accepted!",
    INVALID_SLOTS: "Invalid slots",
    GROUP_PAY_MEMBER_SLOTS: "Group pay member slots",
    SLOTS: "Slots",
    TOTAL_SLOTS: "Total Slots",
    BOOKED_SLOTS: "Booked Slots",
    AVAILABLE_SLOTS: "Available Slots",
    TOTAL_SLOTS_EXPLANATION: 'Calculated by "Total slots" - "Booked slots"',
    BOOKING: "Booking",
    BOOKING_BY: "Booking by",
    GUEST: "Guest",
    CHANGE_BOOKING: "Change booking",
    CHANGE_BOOKING_CHECK_IN: "Change booking check-in times",
    NUMBER_OF_GUESTS: "Number of guests",
    NUMBER_OF_DAYS: "Number of days",
    NUMBER_OF_DAYS_SHORT: "# of Days",
    NUMBER_OF_GUESTS_SHORT: "# of Guests",
    CLOSE: "Close",
    CANCEL: "Cancel",
    NAME: "Name",
    SAVE: "Save",
    CONFIRM: "Confirm",
    CHANGES_PREVIEW: "Changes preview",
    NO_CHANGES: "No changes",
    NO_DATA: "No data for the current selection",
    CURRENT: "Current",
    NEW: "New",
    REFUNDED: "Refunded",
    REFUNDS: "Refunds",
    CANCEL_REFUND_IN_STRIPE: "Cancel",
    CREATE_REFUND: "Create Refund",
    AMOUNT: "Amount",
    REASON: "Reason",
    BY: "By",
    ON: "On",
    STATUS: "Status",
    AUCTION_STATUS: "Auction status",
    AUCTION_REQUEST_STATUS: "Auction request status",
    APPLY_FILTERS: "Apply filters",
    REQUEST: "Request",
    BIDS: "Bids",
    TIME_REMAINING: "Time Remaining",
    AUCTION_FILTERS: "Auction Filters",
    ONBOARDING_STATUS: "Onboarding status",
    APPROVED_BY: "Approved by",
    CANCELLED_BY: "Cancelled by",
    AT: "At",
    OVERVIEW: "Overview",
    STRIPE_REASON: "Stripe refund reason",
    RESPONSIBLE_PARTY: "Is outfitter responsible for refund?",
    MANUAL_REFUND_OWED: "Manual Refund Owed",
    MANUAL_REFUND_COMPLETED: "Manual Refund Completed",
    CHANGE_BOOKING_WARNING:
        "This is the old way of updating a booking. This is only being used for older bookings that lack the necessary info for the new method. All new bookings will use the new version.",
    LOADING: "Loading...",
    LOAD_MORE: "Load More",
    SELECT_OUTFITTER: "Select outfitter",
    PLEASE_SELECT_OUTFITTER: "Please select an outfitter",
    PLEASE_SELECT_EVENT_ORGANIZER: "Please select an event organizer",
    SOURCE_TRIPS: "Source Trips",
    DEFAULT_AVAILABILITY_RULES: "Default Availability Rules",
    AVAILABILITY_RULES: "availability rules",
    MANAGE_DEFAULT_AVAILABILITY_RULES: "Manage Default Availability Rules",
    NO_DEFAULT_AVAILABILITY_RULES: "No default availability rules",
    ADD_DEFAULT_AVAILABILITY_RULE: "Add Rule",
    CREATE_DEFAULT_AVAILABILITY_RULE: "Create Default Availability Rule",
    REPEAT_YEARLY: "Repeat Yearly",
    REPEAT_YEARLY_DESCRIPTION: "Apply this rule on the same dates every year.",
    RULE_NAME: "Rule Name",
    RULE_NAME_PLACEHOLDER: "e.g. Summer Weekday Hours",
    APPLICABLE_DATES: "Applicable Dates",
    DEFAULT_AVAILABILITY_RULE_DATES_EMPTY_HINT:
        "Leave blank to apply all dates.",
    DEFAULT_AVAILABILITY_RULE_SELECT_DAY_HINT:
        "Select a day on the calendar to edit daily availability.",
    DEFAULT_AVAILABILITY_RULE_SELECT_RESOURCE_TITLE: "Select a resource",
    DEFAULT_AVAILABILITY_RULE_SELECT_RESOURCE_HINT:
        "Choose a resource from the calendar page to view or manage its default availability rules.",
    DEFAULT_AVAILABILITY_RULE_SYSTEM_INFO_TITLE: "System Rule",
    DEFAULT_AVAILABILITY_RULE_SYSTEM_INFO_DESCRIPTION:
        "This rule is automatically managed by the system and cannot be edited or deleted.",
    NO_TIME_WINDOWS_HINT: "Drag on the calendar to add a time window.",
    TIME_WINDOWS: "Time Windows",
    DEFAULT_AVAILABILITY_RULE_NAME_REQUIRED: "Rule name is required",
    DEFAULT_AVAILABILITY_RULE_AT_LEAST_ONE_TIME_WINDOW_REQUIRED:
        "Add at least one time window before saving",
    DEFAULT_AVAILABILITY_RULE_CREATED: "Default availability rule created",
    DEFAULT_AVAILABILITY_RULE_UPDATED: "Default availability rule updated",
    DEFAULT_AVAILABILITY_RULE_DONE_CONFIRMATION_TITLE:
        "Save Default Availability Rule",
    DEFAULT_AVAILABILITY_RULE_DONE_CONFIRMATION_MESSAGE:
        "Are you sure you want to save these changes?",
    CREATE_RULE: "Create Rule",
    EDIT_RULE: "Edit Rule",
    DELETE_RULE: "Delete Rule",
    DELETE_DEFAULT_AVAILABILITY_RULE: "Delete Rule",
    DELETE_DEFAULT_AVAILABILITY_RULE_CONFIRMATION:
        "Are you sure you want to delete this default availability rule?",
    DAY_OF_WEEK_LABELS: {
        SUN: "Sunday",
        MON: "Monday",
        TUE: "Tuesday",
        WED: "Wednesday",
        THU: "Thursday",
        FRI: "Friday",
        SAT: "Saturday",
    },
    AUCTIONS: "Auctions",
    AUCTION_TRIPS: "Auction Trips",
    WELCOME: "Welcome",
    INVITED_TO_JOIN: "You have been invited to join",
    INVITATION_ACCEPTED: "Invitation successfully accepted!",
    DOWNLOAD_APP_TO_GET_STARTED: "Download the mobile app to get started.",
    DOWNLOAD_MOBILE_APP: "Download Mobile App",
    PRICING_PACKAGE_HAS_LODGING_WARNING:
        "The name of this package indicates that it includes lodging accommodation. Please make sure that lodging is included in the price & marked as included in the package.",
    ONBOARD_CONTINUE_BUTTON_LABEL: "Continue",
    FILE_EXCEEDS_LIMIT: "The file you selected exceeds the limit of",
    ADD_IMAGES: "Add images",
    CONFIRM_YOUR_INFO: "Confirm your info before continuing",
    FIRST_NAME: "First name",
    LAST_NAME: "Last name",
    PHONE_NUMBER: "Phone number",
    USER_UPDATE_SUCCESS: "👍🏼 User info successfully updated",
    ACCOUNT_SETTINGS: {
        PAGE_TITLE: "Account Settings",
        PROFILE: "Profile",
        NOTIFICATION_PREFERENCES: "Notification Preferences",
        PHOTO: "Photo",
        YEARS_OF_EXPERIENCE: "Years of Experience",
        BIO: "Bio",
        NOTIFICATION_PREFERENCES_COMING_SOON: "Coming soon",
        NOTIFICATION_PREFERENCES_TOPIC_COLUMN: "Topic",
        SAVE: "Save",
        PROFILE_UPDATE_ERROR: "Something went wrong. Please try again.",
    },
    ASSIGN_OUTFITTER_TO_USER_SUCCESS: "🎉 You've signed up as an outfitter",
    BOOKING_CREATE_SUCCESS: "Successfully created booking",
    OFFSITE_BOOKING_UPDATE_SUCCESS: "Succesfully updated off-site booking",
    ENTER_ALL_CORRECT_FIELDS: "Enter all correct fields",
    NATIVE_AUTH_TOKEN_TIMEOUT_ERROR:
        "Timed out waiting for the app to provide an access token.",
    AVERAGE_RATING_LABEL: "Average Rating",
    NUMBER_OF_REVIEWS_LABEL: "Number of Reviews",
    SHARE: {
        TEXT: "Text",
        EMAIL: "Email",
        SHARE: "Share",
        ERROR: "Failed to share",
        NATIVE_SHARE_ERROR: "Native share not supported",
        NATIVE_SHARE_BUTTON: "Text and more...",
    },
    COPY: {
        COPY: "Copy",
        COPY_LINK: "Copy link",
        COPIED: "Copied!",
        COPIED_TO_CLIPBOARD: "Copied to clipboard",
        COPY_BUTTON_ARIA_LABEL: "Copy to clipboard",
        CLIPBOARD_NOT_SUPPORTED: "Clipboard not supported",
    },
    CREATE_LISTING_FORM_LABELS: {
        TITLE: "Listing name",
        LOCATION: "Location",
        MEETING_LOCATION: "Meeting location",
        TYPE: "Listing type",
        LISTING_LICENSE: "Listing license",
        MIN_GUEST: "Minimum guests",
        MAX_GUEST: "Maximum guests",
        LICENSE_REQUIRED: "Is license required?",
        LODGINGS: "Would you like to assign any lodgings?",
        PHOTOS: "Photos",
    },
    CREATE_LISTING_FORM_SUB_LABELS: {
        TYPE: "Please select which type of listing you will provide",
        LICENSE_REQUIRED: "Does this listing require a license from contacts?",
        MIN_GUEST: "The minimum amount of guests required to book.",
        MAX_GUEST: "The maximum amount of guests allowed to book.",
    },
    CREATE_LISTING_FLOW: {
        CARD_TITLE: "Create Listing",
        CARD_DESCRIPTION:
            "Set up the listing details, pricing, add-ons, and availability.",
        DETAILS_TITLE: "Add listing details",
        DETAILS_DESCRIPTION:
            "Provide the required basics, location, species, and photos.",
        DESCRIPTION_TITLE: "Add listing description",
        DESCRIPTION_DESCRIPTION:
            "Share clear details about this specific trip, like what's included, what contacts can expect, the target species, and any methods of harvest!",
        LODGING_TITLE: "Assign lodging",
        LODGING_DESCRIPTION:
            "Let contacts know whether lodging can be booked with this listing.",
        ADD_ONS_TITLE: "Assign add-ons",
        ADD_ONS_DESCRIPTION:
            "Create optional services contacts can add when they book this listing.",
        PRICING_PACKAGES_TITLE: "Set up pricing packages",
        PRICING_PACKAGES_DESCRIPTION:
            "Create at least one pricing package so contacts know what is included and how much the trip costs.",
        AVAILABILITY_TITLE: "Set availability",
        AVAILABILITY_DESCRIPTION:
            "Let contacts know when this listing is available to book.",
        FINISH: "Finish",
        AI_ONBOARDING: {
            TITLE: "Create listings faster",
            OPTIONS_LABEL: "How would you like to create listings?",
            IMPORT_FROM_WEBSITE: "Import listings from website",
            IMPORT_FROM_EXISTING_WEBSITE: "Create listings from website",
            IMPORT_FROM_DOCUMENT: "Create listings from documents",
            WEBSITE_NOTE:
                "Scanning typically takes 2-5 minutes for most websites. We'll create listings from the details we find.",
            EXISTING_WEBSITE_NOTE:
                "We'll use the website information already imported for this outfitter to create listings.",
            DOCUMENT_NOTE:
                "Scanning documents typically takes 2-5 minutes. We'll create listings from the details we find.",
            LOADING_TEXT:
                "Hang tight - we're creating listings from your website.",
            DOCUMENT_LOADING_TEXT:
                "Hang tight - we're creating listings from your documents.",
            SUCCESS: "Listings created!",
        },
    },
    GROUP_PAY: {
        DETAILS: "Group details",
        LABEL: "Group pay",
        ORGANIZER: "Organizer",
        JOINED: "Joined",
        INVITED: "Invited",
        SLOTS_CLAIMED: "slots claimed",
        MEMBER_UPDATE_BUTTON: "Update member info",
        MEMBER_UPDATE_SUCCESS_MESSAGE: "Group member info updated successfully",
        MEMBER_UPDATE_MODAL_TITLE: "Update group member info",
        MEMBER_UPDATE_FORM_LABELS: {
            NAME: "Name",
            EMAIL: "Email",
            PHONE: "Phone number",
        },
    },
    OWNER_WARNING: {
        TITLE: "A Mallard Bay user is the billing owner of this outfitter",
        MESSAGE:
            "In order for the outfitter to receive payments you must make them the billing owner. Otherwise booking payments will go to the MallardBay Stripe account",
    },
    PAYMENTS: "Payments",
    ADDTIONAL_PAYMENT: "Additional payment",
    EXPIRATION: "Expiration",
    GROUP_PAYMENTS: "Group payments",
    AWAITING_PAYMENTS: "Awaiting",
    ALL_PAYMENTS_RECEIVED: "Paid",
    REQUEST_PAYMENT: "Request payment",
    RECORD_CASH_CHECK: "Record cash/check",
    REQUEST_ADDITIONAL_PAYMENT: "Request additional payment",
    RECORD_PAYMENT: "Record Payment",
    APPROVE_BOOKING: "Approve Booking",
    DENY_BOOKING: "Deny Booking",
    HOW_WILL_PAYMENT_BE_COLLECTED: "How will this payment be collected?",
    HOW_WAS_PAYMENT_RECEIVED: "How was this payment received?",
    WOULD_YOU_LIKE_TO_COLLECT_TAX_ON_THIS_PAYMENT_REQUEST:
        "Would you like to collect sales tax on this payment request?",
    DO_NOT_COLLECT_TAX_PAYMENT_REQUEST:
        "Do not collect sales tax on this payment request",
    COLLECT_TAX_ON_SUBTOTAL_PAYMENT_REQUEST:
        "Collect sales tax on the subtototal of this payment request",
    PAID_OFFLINE: "Paid offline",
    SENDS_INVOICE_TO_CONTACT: "Sends invoice to contact to pay online",
    PROVIDES_QR_CODE_TO_CONTACT:
        "Provides a QR code to contact to scan and pay in person",
    SHOW_QR_CODE_TO_CONTACT: "Show this QR code to contact",
    SHARE_PAYMENT_REQUEST_LINK: "Share the payment request link with contact",
    TOTAL: "Total",
    ADD_ANOTHER_PAYMENT: "Add another payment",
    PAYMENT_REQUESTS: "Payment requests",
    REQUESTED_PAYMENT_SUCCESS: "Successfully requested payment!",
    REQUESTED_PAYMENT_FAILED: "Error requesting payment.",
    RESOLVED_PAYMENT_REQUEST_SUCCESS: "Successfully resolved payment request!",
    RESOLVED_PAYMENT_REQUEST_FAILED: "Error resolving payment request.",
    GAS: "Gas",
    RECEIVED_PAYMENT_IN_PERSON: "Received this payment in person?",
    MARK_PAYMENT_REQUEST_RECEIVED: "Mark this payment request as received?",
    PAYMENT_REQUEST_RECEIVED_NOTE:
        "This will resolve the payment request and no further action will be required by the contact.",
    ENTER_AMOUNT_TO_REQUEST: "Enter amount to be requested",
    EVENTS_UPDATED: "Events updated",
    NO_EVENTS_IN_RANGE: "There are no bookings in this range.",
    SHOW_OFF_PLATFORM_BOOKINGS: "Show off-platform bookings",
    SHOW_MALLARD_BAY_BOOKINGS: "Show Mallard Bay bookings",
    TOTAL_COMPLETED_BOOKINGS: "Total completed bookings",
    CREATED_AT: "Created at",
    DETAILS: "Details",
    DESCRIPTION: "Description",
    VIEW_DETAILS: "View details",
    VIEW_BOOKING: "View booking",
    VIEW_BOOKING_INVITE: "View Booking Invite",
    BOOKING_DETAILS: "Booking details",
    VIEW_FORM_SUBMISSION: "View Form Submission",
    VIEW_PAYMENT_REQUEST: "View Payment Request",
    VIEW_LEAD: "View Lead",
    CHECK_IN: "Check-in",
    CHECK_OUT: "Check-out",
    EDIT_CHECK_IN: "Edit Check-in Settings",
    EDIT_BOOKING: "Edit booking",
    EDIT_BOOKING_TRIP: "Edit guests and trip dates",
    EDIT_BOOKING_CHECK_IN: "Edit check-in/check-out",
    GUESTS: "Guests",
    ADD_ONS: "add-ons",
    ADD_ONS_LABEL: "Add-ons",
    ADD_ON: "add-on",
    EMAIL: "Email",
    CALL: "Call",
    VIEW: "View",
    DELETE: "Delete",
    SUSPEND: "Suspend",
    EMAIL_OWNER: "Email owner",
    REASSIGN_BILLING_OWNER: "Reassign billing owner",
    REASSIGNING_BILLING_OWNER: "Reassigning billing owner",
    REASSIGNED_BILLING_OWNER: "Reassigned billing owner",
    CALENDAR: "Calendar",
    CALENDAR_FILTERS: "Calendar filters",
    FILTER: "Filter",
    LOCKED_WEEK_VIEW_ARIA_LABEL: "Why weekly calendar view is locked",
    LOCKED_WEEK_VIEW_TOOLTIP:
        "This resource supports hourly availability, so edit mode is locked to week view.",
    UPDATE_AVAILABILITY: "Update availability",
    SUBSCRIBE: "Subscribe",
    CALENDAR_SUBSCRIPTIONS: "Calendar Subscriptions",
    SUBSCRIBE_TO_CALENDAR: "Subscribe to calendar",
    APPLE_CALENDAR: "Apple Calendar",
    GOOGLE_CALENDAR: "Google Calendar",
    OUTLOOK_CALENDAR: "Outlook Calendar",
    LISTINGS: "Listings",
    LISTING: "Listing",
    SELECT_A_LISTING: "Select a listing",
    LODGE: "Lodge",
    OTHERS: "Others",
    OFF_PLATFORM: "Off-platform",
    HIDE: "Hide",
    SHOW: "Show",
    MORE: "more",
    CASH: "Cash",
    CHECK: "Check",
    OTHER: "Other",
    EMAIL_INVOICE: "Email Invoice",
    QR_CODE: "QR Code",
    QR_CODE_SHARE_DEFAULT_LABEL: "Show the QR code",
    ACTIVE: "Active",
    EXPIRED: "Expired",
    EXPIRING_SOON: "Expiring soon",
    INACTIVE: "Inactive",
    MY_OUTFITTERS: "My Outfitters",
    MY_OUTFITTER: "My Outfitter",
    NEW_OUTFITTER: "New outfitter",
    NO_OUTFITTERS_MESSAGE: "You haven't onboarded any outfitters yet",
    WIDGETS: "Widgets",
    ADD_WIDGET: "Add Widget",
    NO_WIDGETS_YET: "No widgets yet",
    UPDATED: "Updated",
    GET_INSTRUCTIONS: "Get instructions",
    LODGING: "Lodging",
    ADD_LODGING: "Add Lodging",
    NO_LODGINGS_YET: "No lodgings yet",
    COUPONS: "Coupons",
    ADD_COUPON: "Add coupon",
    NO_COUPONS_LEFT: "No coupons left",
    COUPON_EXPIRED: "This coupon is expired",
    SHOW_EXPIRED: "Show expired",
    HIDE_EXPIRED: "Hide expired",
    DELETE_COUPON_SUCCESS: "Successfully deleted coupon",
    REORDER: "Reorder",
    CREATE_LISTING: "Create Listing",
    NO_LISTINGS: "No Listings",
    EDIT_OUTFITTER: "Edit outfitter",
    CREATE_BOOKING: "Create Booking",
    CREATE_GROUP: "Create Group",
    EVENT_GROUP_CREATED_SUCCESSFULLY: "Event group created successfully!",
    EVENT_GROUP_UPDATED_SUCCESSFULLY: "Event group updated successfully!",
    ADD_EVENT: "Add Event",
    ADD_BOOKING: "Add Booking",
    REMOVE_EVENT: "Remove Event",
    REMOVE_BOOKING: "Remove Booking",
    SELECT_EVENTS_TO_REMOVE: "Select Events to Remove",
    SELECT_BOOKINGS_TO_REMOVE: "Select Bookings to Remove",
    EVENT_ADDED_TO_GROUP: "An event has been successfully added to",
    BOOKING_ADDED_TO_GROUP: "A booking has been successfully added to",
    EVENT_REMOVED_FROM_GROUP: "An event has been successfully removed from",
    BOOKING_REMOVED_FROM_GROUP: "A booking has been successfully removed from",
    ARCHIVE_EVENT_GROUP: "Delete Group",
    ARCHIVE_EVENT_GROUP_CONFIRM:
        "Are you sure you want to delete this group? This action cannot be undone.",
    ARCHIVE_EVENT_GROUP_SUCCESS: "Event group deleted successfully!",
    EDIT_EVENT_GROUP: "Edit Group",
    FOR: "For",
    DUE: "Due",
    OR: "or",
    MANAGE_REFUNDS: "Manage refunds",
    MANAGE_CALENDAR: "Manage calendar",
    APPROVE: "Approve",
    DECLINE: "Decline",
    ACCEPT: "Accept",
    OPEN_CALENDAR: "Open calendar",
    GO_TO_CALENDAR: "Go to calendar",
    AVAILABILITY_SUGGESTION_NOTE:
        "It's essential to regularly update your availability. This enables sports enthusiasts to plan their trips efficiently and ensures that your services are consistently booked.",
    AVAILABILITY_BANNER_TITLE: "Please Add Your Availability",
    PER_PERSON: "per person",
    PER_DAY: "per day",
    EDIT_PRICING: "Edit pricing",
    EDIT_PRICING_PACKAGE: "Edit pricing package",
    NO_METRICS_AVAILABLE: "No metrics available",
    TOTAL_GROSS_BOOKINGS: "Total gross bookings",
    GROSS_REVENUE: "Gross Revenue",
    INVOICE_NUMBER: "Invoice Number",
    BOOKING_ID: "Booking ID",
    BOOKINGS_GROSS_REVENUE_BY_MONTH: "Bookings Gross Revenue By Month",
    BOOKINGS_COUNT_BY_MONTH: "Bookings Count By Month",
    BOOKINGS_GROSS_REVENUE_BY_SOURCE: "Bookings Gross Revenue By Source",
    BOOKINGS_COUNT_BY_SOURCE: "Bookings Count By Source",
    BOOKINGS_GROSS_REVENUE_BY_CUSTOMER: "Bookings Gross Revenue By Customer",
    BOOKINGS_COUNT_BY_CUSTOMER: "Bookings Count By Customer",
    BOOKINGS: "Bookings",
    REVENUE_FORECAST: "Revenue Forecast",
    PAYMENTS_NET_REVENUE_BY_TYPE: "Payments Net Revenue By Type",
    PAYMENTS_COUNT_BY_TYPE: "Payments Count By Type",
    FOR_SELECTED_DATES: "For selected dates",
    COMPLETED_BOOKINGS_OVER_TIME:
        "Completed bookings over time (Last 12 months)",
    ACH_NOTE: "ACH - Additional 1-2 days processing",
    STRIPE_INVOICE: "Stripe invoice",
    STRIPE_RECEIPT: "Stripe receipt",
    AUTHORIZE_NET_TRANSACTION: "Authorize.net transaction",
    ADD_TO_APPLE_CALENDAR: "Add to Apple Calendar",
    ADD_TO_GOOGLE_CALENDAR: "Add to Google Calendar",
    ADD_TO_YOUR_CALENDAR: "Add to your calendar",
    MALLARD_BAY_TRIP: "Mallard Bay Trip",
    SELECT_PRICING_PACKAGE: "Select a Pricing Package",
    PACKAGE_NAME_LABEL: "Package name",
    PACKAGE_PRICE_LABEL: "Package price",
    PACKAGE_TYPE_LABEL: "Package type",
    DATE_TYPE_LABEL: "Trip length type",
    GROUP_PACKAGES: "Group packages",
    PER_PERSON_PACKAGES: "Per person packages",
    UNTITLED: "Untitled",
    TYPE: "Type",
    USED_FOR: "Used for",
    TODAY: "Today",
    PREVIOUS: "Previous",
    NEXT: "Next",
    SELECTED_DATES: "Selected Dates",
    SELECTED_MONTH: "Selected Month",
    CHOOSE_ONE: "Choose One",
    NONE: "None",
    AVAILABLE: "Available",
    UNAVAILABLE: "Unavailable",
    AVAILABILITY: "Availability",
    AVAILABILITY_UPDATED: "Availability updated",
    REMAINING_SLOTS_OUT_OF: "remaining slots out of",
    NOTES: "Notes",
    NOTE: "Note",
    ADD_DASHBOARD_BOOKING: "Add booking",
    DATE_NOTES: "Date notes",
    SELECT_RESOURCE: "Select resource",
    SELECT_RESOURCES: "Select resources",
    DOES_THIS_PACKAGE_REQUIRE_ANY_RESOURCES:
        "Does this package require any resources?",
    LAST_UPDATED: "Last updated",
    OPTIONS: "Options",
    ADMIN_OPTIONS: "Admin Options",
    OPTIONAL: "Optional",
    INCLUDED_LODGE: "Included lodge",
    LODGING_SELECTION_EXPLANATION:
        "Selecting a lodge will keep track of lodging availability for you when contacts book trips. It will also show contacts the details of their accommodations.",
    NO_RESOURCE_ID_AND_TYPE_ERROR:
        "Unable to update availability. Missing resource ID or type",
    NO_IS_AVAILABLE: "Unable to update availability. Missing isAvailable",
    NO_TOTAL_SLOTS:
        "Unable to update availability. Missing totalSlots for isAvailable = true",
    INVALID_TOTAL_SLOTS:
        "Unable to update availability. totalSlots must be a whole number between 1 and 200",
    TRIP_PACKAGES: "Trip packages",
    NO_ADD_ONS_AVAILABLE: "There are no add-ons available for this listing",
    TOTAL_GUESTS: "Total Guests",
    GUESTS_PACKAGE_NOTE: "The selected pricing package is set to include",
    MAX_GUESTS_MESSAGE:
        "The max number of guests available for the selected dates is",
    MIN_GUESTS_MESSAGE: "The min number of guests for the selected package is",
    COUPON: "Coupon",
    NO_COUPONS_CREATED: "There are no coupons created for",
    FILTER_BY_LISTING: "Filter by listing",
    CREATE_QUOTE_SUCCESS: "Successfully created quote!",
    UPDATE_QUOTE_SUCCESS: "Successfully updated quote!",
    UPDATE_QUOTE_ERROR: "Error updating quote.",
    DUPLICATE_BOOKING_INVITE_SUCCESS: "Successfully duplicated quote!",
    DUPLICATE: "Duplicate",
    DUPLICATE_QUOTE: "Duplicate quote",
    DUPLICATE_QUOTE_CONFIRMATION_MESSAGE:
        "Are you sure you want to duplicate this quote? This will create a new active quote based off of this one.",
    ARCHIVE: "Archive",
    ARCHIVE_QUOTE: "Archive quote",
    ARCHIVE_QUOTE_CONFIRMATION_MESSAGE:
        "Are you sure you want to archive this quote? This action is not reversable. However, after archiving, you can duplicate it to create a new active quote.",
    ARCHIVE_QUOTE_REQUEST_CONFIRMATION_MESSAGE:
        "Are you sure you want to archive this quote request? This action is not reversable.",
    ARCHIVE_QUOTE_REQUEST: "Archive quote request",
    ARCHIVE_BOOKING_INVITE_SUCCESS: "Successfully archived quote!",
    ARCHIVE_QUOTE_REQUEST_SUCCESS: "Successfully archived quote request!",
    UPDATE_PAYMENT_SUCCESS: "Successfully updated payment info!",
    RETRY_PAYMENT_SUCCESS: "Payment retried successfully!",
    UPDATE_PAYMENT_METHOD_SUCCESS: "Successfully updated the payment method!",
    DELETE_PAYMENT_METHOD_SUCCESS: "Successfully deleted payment method!",
    RETRY_PAYMENT: "Retry payment",
    CHANGE_PAYMENT_METHOD: "Change payment method",
    ADD_PAYMENT_METHOD: "Add New Payment Method",
    RETRY_FAILED_PAYMENT: "Retry failed payment",
    EDIT_QUOTE: "Edit Quote",
    CREATE_QUOTE: "Create Quote",
    NEW_QUOTE: "New Quote",
    NEW_LEAD: "New Lead",
    PRICING_PACKAGE: "Pricing Package",
    PRICING_PACKAGE_SELECTOR_EMPTY_MESSAGE:
        "We couldn’t find any pricing packages for this selection. If you selected multiple days, try choosing one day instead — hourly packages can only be booked one day at a time.",
    NO_PRICING_PACKAGES_PREFIX: "There are no pricing packages created for",
    NO_PRICING_PACKAGES_SUFFIX: "Please go to the listing page to create them.",
    BACK: "Back",
    GO_BACK: "Go back",
    CONTINUE: "Continue",
    NOTES_HELP_MESSAGE: "Add any internal notes you may need for this quote.",
    NOTES_PLACEHOLDER: "3 day with Johnny Appleseed and his 5 brothers...",
    NO_DATES_SELECTED: "No dates selected",
    PACKAGES: "Packages",
    NO_PACKAGES_MESSAGE: "No packages. Please add at least on package.",
    ADD_A_PACKAGE: "Add a Package",
    ADD_ANOTHER_PACKAGE: "Add Another Package",
    SEE_DETAILS: "See details",
    BACK_TO_PREVIOUS_STEP: "Back to previous step",
    SUBMIT: "Submit",
    GROUP_PACKAGE_VS_PAY_PER_PERSON: "Group package vs. pay per person?",
    PACKAGE_TYPE_HELPER_TEXT:
        "The package type changes how contacts will be charged.",
    GROUP_PACKAGE_HELPER_TEXT:
        "This type is for packages where there is a set number of contacts included, so you should set the price for the group as a whole.",
    PAY_PER_PERSON_HELPER_TEXT:
        "This type is for packages where contacts can select how many guests will be attending. The price should reflect how much it is for each guest.",
    THERE_ARE: "There are",
    LISTINGS_WITH_THIS_ADD_ON:
        "with pricing packages that include this add-on.",
    APPLIES_TO_ALL_LISTINGS: "Applies to all listings",
    THIS_ADD_ON_CANNOT_BE_DISABLED:
        "This add-on cannot be disabled because it is set to apply to all listings.",
    DISABLED_FOR_LISTING: "Disabled for listing",
    DISABLED: "Disabled",
    ENABLED: "Enabled",
    DELETE_ADD_ON: "Delete add-on",
    DELETE_ADD_ON_WARNING:
        "Are you sure you want to delete this add-on? This action cannot be undone.",
    APPLY_TO_ALL_LISTINGS: "Apply to all listings?",
    IS_HIDDEN_FROM_SPORTSMEN: "Hide this add-on from contacts at checkout?",
    IS_HIDDEN_FROM_SPORTSMEN_TOOLTIP:
        "Turn this on if you want to make this add-on visible only to you and your staff when requesting payments, and not visible to contacts during checkout.",
    PRICING: {
        PER_DAY: "/ day",
        PER_GUEST: "/ guest",
        DEPOSIT: "Deposit",
        EACH: "each",
        TOTAL: "Total",
        NET: "Net",
        PAID_BY: "Paid by",
        DUE_AFTER_TRIP: "Due after trip",
        PRICING: "Pricing",
    },
    DEFAULT_IMAGE: "Default image",
    DEFAULT: "Default",
    CUSTOM_IMAGE: "Custom image",
    VS: "vs.",
    DEFAULT_IMAGE_HELPER_TEXT:
        "If you don't have a custom image, we'll use this one.",
    CUSTOM_IMAGE_HELPER_TEXT:
        "Upload a custom image for this add-on. This will replace the default image.",
    UPFRONT_PAYMENT_STRUCTURE: "Upfront payment structure",
    CUSTOMIZE_UPFRONT_PAYMENT_STRUCTURE_HELPER_TEXT:
        "Customize the upfront payment structure for this add-on. Select how much is due before the trip, if any.",
    CONFIRMATION_STEP_HELPER_TEXT:
        "Here's how your Add-on will look to guests at checkout",
    CONFIRMATION_STEP_HELPER_TEXT_PRICING_PACKAGE:
        "Does your pricing package look correct?",
    DECREASE: "Decrease",
    INCREASE: "Increase",
    YES: "Yes",
    NO: "No",
    TRUE: "True",
    FALSE: "False",
    PRICING_PACKAGE_CREATED_SUCCESSFULLY:
        "Pricing package created successfully",
    PRICING_PACKAGE_CREATION_FAILED: "Failed to create pricing package",
    PRICING_PACKAGE_UPDATED_SUCCESSFULLY:
        "Pricing package updated successfully",
    PRICING_PACKAGE_REMOVED_SUCCESSFULLY:
        "Pricing package removed successfully",
    STEP: "Step",
    NOT_INCLUDED: "Not included",
    GROUP_PACKAGE: "Group package",
    PAY_PER_PERSON: "Pay per person",
    SET_DAY: "Set # of days",
    PAY_PER_DAY: "Pay per day",
    HOURLY: "Hourly",
    PACKAGE_NAME: "Name",
    PACKAGE_TYPE: "What kind of package is this?",
    PACKAGE_LODGING_ONLY: "Is this package for lodging only?",
    DATE_TYPE: "How should dates be selected?",
    PACKAGE_PRICE: "Price",
    GUESTS_INCLUDED: "How many guests are included in this package?",
    PER_GUEST_INPUT: "How many guests can be booked for this package?",
    MIN_GUESTS: "Min guests",
    MAX_GUESTS: "Max guests",
    DAYS_INCLUDED: "How many days are included in this package?",
    DURATION: "Duration",
    HOUR: "Hour",
    START_TIMES: "Start Times",
    ADD_START_TIME: "Add Start Time",
    REMOVE_START_TIME: "Remove start time",
    DOES_THIS_PACKAGE_INCLUDE_LODGING:
        "Does this package include lodging in the price?",
    DOES_THIS_PACKAGE_INCLUDE: "Does this package include",
    LODGING_ACCOMMODATION: "lodging accommodation",
    TROPHY_FEES: "trophy fees",
    GEAR_RENTALS: "gear rentals",
    IN_THE_PRICE: "in the price?",
    IS_LODGING_INCLUDED: "Is lodging included?",
    ARE_TROPHIES_INCLUDED: "Are trophy fees included?",
    IS_GEAR_INCLUDED: "Are gear rentals included?",
    ARE_MEAL_UPGRADES_INCLUDED: "Are meal upgrades included?",
    ARE_OTHER_ADD_ONS_INCLUDED: "Are any other add-ons included?",
    DELETE_PRICING_PACKAGE: "Delete Pricing Package",
    SELECTED_TROPHY_FEES: "Which trophy fees are included in this package?",
    SELECTED_GEAR_RENTALS: "Which gear rentals are included in this package?",
    SELECTED_MEAL_UPGRADES: "Which meal upgrades are included in this package?",
    IS_OTHER_ADDONS_INCLUDED:
        "Are there any other add-ons included in the price for this package?",
    SELECTED_OTHER_ADDONS: "Which other add-ons are included in this package?",
    LODGINGS: {
        ADD_ROOM: "Add room",
        EDIT_ROOM: "Edit room",
        ADD_LODGING: "Add lodging",
        EDIT_LODGING: "Edit lodging",
        DELETE_ROOM: "Delete room",
        DELETE_ROOM_CONFIRMATION: "Are you sure to delete this room?",
        LODGING_CREATED_SUCCESS: "Lodging successfully created",
        LODGING_UPDATED_SUCCESS: "Lodging successfully updated",
        LODGING_DELETED_SUCCESS: "Lodging successfully deleted",
        ROOM_TYPE: "Room type",
        ROOM_NAME: "Room name",
        ROOM_DESCRIPTION: "Description",
        ROOM_NAME_PLACEHOLDER:
            "Ex: Living Room, Bedroom 1, or a unique name for the room",
        SLEEPING_ARRANGEMENTS: "Sleeping Arrangements",
        REMOVE_LODGING_IMAGE_ARIA_LABEL: "Remove lodging image",
        REMOVE_LODGING_WARNING_TITLE: "Affected pricing packages",
        REMOVE_LODGING_WARNING_DESCRIPTION:
            "Deleting this room will also remove it as the included lodging option from pricing packages. Bookings already made with these pricing packages will not be affected.",
        ASSIGN_TO_LISTINGS:
            "Would you like to assign this lodge to any listings?",
        CAPACITY: "Capacity",
        UPDATED_LODGING_IMAGES_SUCCESS: "Lodging images updated successfully",
    },
    IMAGES: "Images",
    BOOKING_FEE: "Booking Fee",
    CONTACT_BOOKING_FEE: "Contact Booking Fee",
    CARD_PROCESSING_FEE: "Card Processing Fee",
    ACH_PROCESSING_FEE: "ACH Processing Fee",
    OUTFITTER_FEE: "Outfitter Fee",
    OUTFITTER_NET: "Outfitter Net",
    SALES_TAX: "Sales Tax",
    BOOKING_FEE_RATE: "Booking Fee Rate",
    BOOKING_FEE_FIXED: "Booking Fee Fixed",
    MAX_BOOKING_FEE: "Max Booking Fee",
    PROCESSING_FEE_RATE: "Processing Fee Rate (CC)",
    PROCESSING_FEE_FIXED: "Processing Fee Fixed (CC)",
    PROCESSING_FEE_RATE_ACH: "Processing Fee Rate (ACH)",
    PROCESSING_FEE_FIXED_ACH: "Processing Fee Fixed (ACH)",
    MAX_PROCESSING_FEE_ACH: "Max Processing Fee (ACH)",
    PROCESSING_FEE_PAYED_BY_CONTACT: "Processing Fee Paid By Contact",
    PROCESSING_FEE_SETTINGS: "Processing Fee Settings",
    PAYMENT_PROCESSING_FEE: "Payment Processing Fee",
    MALLARD_BAY_FEE: "Mallard Bay Fee",
    PAID_BY_CONTACT: "Paid By Contact",
    TAX_RATE: "Tax Rate",
    DEFAULT_TAX_RATE: "Default Tax Rate",
    RATES: "Rates",
    EDIT_RATES: "Edit Rates",
    PAYMENT_FEE_SETTINGS: "Payment fee settings",
    EDIT_PAYMENT_FEE_SETTINGS: "Edit payment fee settings",
    OVERRIDE_PAYMENT_FEE_SETTINGS:
        "Override subscription tier outfitter payment fee settings?",
    OVERRIDE_CHECK_IN_SETTINGS: "Set custom check in settings?",
    GEAR_RENTAL: "Gear Rental",
    MEAL_UPGRADE: "Meal Upgrade",
    SAVING: "Saving",
    SAVING_PRICING_PACKAGE: "Saving pricing package...",
    FULL_DEPOSIT: "Full Deposit",
    PARTIAL_DEPOSIT: "Partial Deposit",
    IMAGE_UPDATED: "Image Updated",
    REQUIRES_UPFRONT_PAYMENT: "Requires upfront payment",
    PERCENTAGE: "Percentage",
    FLAT_AMOUNT: "Flat Amount",
    ADD_ON_LABELS: {
        NAME: "Enter a name for your Add-on",
        DESCRIPTION: "Add a description for your Add-on",
        UNIT_PRICE: "Enter a price for your Add-on",
        DEPOSIT_AMOUNT: "How much does the guest need to pay upfront?",
        DEPOSIT_PERCENTAGE:
            "What percentage of the price does the guest need to pay upfront?",
        IMAGE: "Image",
        HAS_DEPOSIT: "Does your Add-on require payment before the trip?",
        DEPOSIT_TYPE:
            "Does the guest need to pay the full amount or a partial amount before the trip?",
        PARTIAL_DEPOSIT_TYPE:
            "Does the guest need to pay a flat amount or a percentage of the add on price?",
        SPECIES: "Select a Species",
        FULL_DEPOSIT: "Full Amount",
        PARTIAL_DEPOSIT: "Partial Amount",
        PERCENTAGE_DEPOSIT: "Percentage",
        AMOUNT_DEPOSIT: "Amount",
        GUESTS_TYPE: "Is this price for all guests or per guest?",
        DATE_TYPE: "Is this price for all days or per day?",
        GROUP_PACKAGE: "All Guests",
        PER_GUEST: "Per Guest",
        SET_DAY: "All Days",
        PER_DAY: "Per Day",
    },
    ADD_ON_STEP_LABELS: {
        BASIC_INFO: "Basic Information",
        IMAGE: "Add-on Image",
        PRICING: "Add-on Pricing",
        DEPOSIT: "Add-on pre-trip deposit",
    },
    LISTING_MUTATIONS: {
        DUPLICATE_LISTING_SUCCESS: "Listing duplicated successfully",
        DUPLICATE_LISTING_ERROR: "Failed to duplicate listing",
        DELETE_LISTING_SUCCESS: "Listing deleted successfully",
        DELETE_LISTING_ERROR: "Failed to delete listing",
        PUBLISH_LISTING_SUCCESS: "Listing published successfully",
        UNPUBLISH_LISTING_SUCCESS: "Listing unpublished successfully",
    },
    LISTING_MANAGE: {
        LISTING_BASICS: "Listing basics",
        DESCRIPTION: "Description",
        GEAR_LIST: "Gear List",
        AVAILABILITY: "Availability",
        PRICING: "Pricing",
        PHOTOS: "Photos",
        LOCATION: "Location",
        LODGING: "Lodging",
        SPECIES: "Species",
        AMENITIES: "Amenities",
        ADD_ONS: "Add-ons",
        OUTFITTER_DOCUMENTS: "Documents",
        PAYMENT_RATES: "Payment rates",
        POST_BOOKING_PAYMENTS: "Post-booking payments",
        GUIDE: "Guide",
        BACK_TO_OUTFITTER: "Back to outfitter",
        DUPLICATE_LISTING_CONFIRMATION:
            "Are you sure to duplicate this listing?",
        DELETE_LISTING_CONFIRMATION: "Are you sure to delete this listing?",
        DUPLICATING: "Duplicating",
        DELETING: "Deleting",
        UNPUBLISHING: "Unpublish",
        UNPUBLISH_LISTING_CONFIRMATION:
            "This listing will no longer appear in the marketplace until you publish it again.",
        DELETE_LISTING_WARNING_ITEM_1:
            "The listing will be unpublished and will not show up in search results or Mallard Bay website",
        DELETE_LISTING_WARNING_ITEM_2:
            "All bookings associated with this listing will not be affected and will remain under your account",
        DELETE_LISTING_WARNING_ITEM_3:
            "You will no longer have access to view or edit the listing. This action can not be undone.",
        // Group titles
        LISTING_SETUP: "Listing Setup",
        AVAILABILITY_PRICING: "Availability & Pricing",
        PAYMENTS: "Payments",
        OPERATIONS_LOGISTICS: "Operations & Logistics",
        ADMIN_SETTINGS: "Admin Settings",
        LISTING_PROGRESS: {
            TITLE: "Let's Finish Up",
            SUBTITLE: "Nearly there! Finish setting up your listing.",
            BUTTON_TEXT: "See What's Missing",
            // Progress item subtitles
            LISTING_BASICS_SUBTITLE:
                "Set up your listing name and basic information",
            DESCRIPTION_SUBTITLE:
                "Tell guests about your experience and what to expect",
            LOCATION_SUBTITLE: "Add meeting points and travel details",
            PHOTOS_SUBTITLE: "Upload photos to showcase your experience",
            LODGING_SUBTITLE: "Configure accommodation options and details",
            SPECIES_SUBTITLE: "Select the types of fish or game available",
            AMENITIES_SUBTITLE: "List what amenities are available",
            PRICING_SUBTITLE: "Set your rates and payment terms",
            ADD_ONS_SUBTITLE: "Offer additional services and upgrades",
            POST_BOOKING_PAYMENTS_SUBTITLE:
                "Configure tips, deposits, and final payments",
            AVAILABILITY_SUBTITLE: "Set your schedule and booking calendar",
            GUIDE_SUBTITLE: "Add guides and their information",
        },
        PUBLISH_ACTION_BANNER: {
            TITLE: "Ready to Publish",
            DESCRIPTION:
                "This listing isn't currently published. Publish it now so guests can find and book it.",
            BUTTON_TEXT: "Publish Listing",
        },
    },
    LISTING_MANAGE_MENU: {
        COPY_LINK: "Copy link",
        DELETE_LISTING: "Delete listing",
        PREVIEW_LISTING: "Preview listing",
        DUPLICATE_LISTING: "Duplicate listing",
        UNPUBLISH_LISTING: "Unpublish listing",
    },
    OUTFITTER_MANAGE_MENU: {
        COPY_LINK: "Copy link",
        DELETE_OUTFITTER: "Delete outfitter",
    },
    PRICE: "Price",
    DEPOSIT_AMOUNT: "Deposit amount",
    DEPOSIT_PERCENTAGE: "Deposit percentage",
    APPLYING_TO_ALL_LISTINGS: "Applying to all listings",
    ASSIGNED_TO: "Assigned to",
    SPECIES: "Species",
    ATTENTION: "Attention",
    SELECT_COLOR: "Select color",
    OPEN_COLOR_PICKER: "Open color picker",
    CLEAR_CUSTOM_COLOR: "Clear custom color",
    ERROR_SETTING_CUSTOM_COLOR: "Error setting custom color",
    CHANGE_COLOR: "Change color",
    IMPORT_OUTFITTER: "Import an Outfitter from Hubspot",
    SEARCH_HUBSPOT_COMPANIES: "Search Hubspot companies",
    NO_HUBSPOT_COMPANIES_FOUND: "No Hubspot companies found",
    IMPORT: "Import",
    IMPORT_CONTACTS: "Import Contacts",
    IMPORT_LEADS: "Import Leads",
    IMPORT_LEADS_CSV: "Import Leads CSV",
    IMPORT_BOOKINGS: "Import Bookings",
    DOWNLOAD_SAMPLE: "Download Sample",
    IMPORT_SUCCESS_PREFIX: "Successfully imported",
    IMPORT_FAILED_PREFIX: "Failed to import",
    IMPORT_FAILED_SUFFIX: "failed",
    EXPORT: "Export",
    ERROR: "Error!",
    ERROR_LABEL: "Error",
    ERROR_FROM_STRIPE: "Error from Stripe",
    IMPORTED_OUTFITTER: "Imported Outfitter",
    APPROVED: "Approved",
    SUSPENDED: "Suspended",
    PENDING_APPROVAL: "Pending approval",
    OWNER: "Owner",
    DELETE_OUTFITTER: "Delete outfitter",
    ADDRESS: "Address",
    LINK_COPIED: "Link copied",
    UNAPPROVED: "Unapproved",
    WEBSITE: "Website",
    NO_WEBSITE: "No website set",
    NO_CONTACT_EMAIL: "No contact email",
    NO_CONTACT_PHONE: "No contact phone",
    DEFAULT_CHECK_IN: "Default Check-in",
    DEFAULT_CHECK_OUT: "Default Check-out",
    NONE_SET: "None set",
    SHARE_LINK: "Share link",
    AM: "AM",
    PM: "PM",
    SPECIES_MANAGE: {
        ADD_SPECIES: "Add species",
        EDIT_SPECIES: "Edit species",
        DELETE_SPECIES: "Delete species",
        HUNTING_SPECIES: "Hunting species",
        FISHING_SPECIES: "Fishing species",
        DELETED_SPECIES: "Deleted species",
        DELETE_SPECIES_SUCCESS: "Species deleted successfully",
        DELETE_SPECIES_ERROR: "Failed to delete species",
        DELETE_SPECIES_CONFIRMATION: "Are you sure to delete this species?",
        SEARCHABLE_KEYWORDS: "Searchable Keywords",
    },
    DELETE_OUTFITTER_CONFIRMATION: "Are you sure to delete this outfitter?",
    DELETE_OUTFITTER_SUCCESS: "Outfitter deleted successfully",
    DELETE_OUTFITTER_ERROR: "Failed to delete outfitter",
    NONE_ADDED: "None added",
    UPDATE_OUTFITTER_CONTACT: "Update contact",
    NO_OUTFITTER_CONTACTS_ADDED_YET: "No contacts added yet",
    OUTFITTER_MANAGE: {
        GENERAL: "General",
        ABOUT: "About",
        STATS: "Stats",
        LISTINGS: "Listings",
        TEAM_MEMBERS: "Team members",
        PHOTOS: "Photos",
        VIDEO: "Video",
        LODGING: "Lodging",
        ADD_ONS: "Add-ons",
        POST_BOOKING_PAYMENTS: "Post-booking payments",
        WIDGETS: "Widgets",
        COUPONS: "Coupons",
        CANCELLATION_POLICY: "Cancellation policy",
        PAYMENT_RATES: "Payment rates",
        PAYMENT_FEE_SETTINGS: "Payment fee settings",
        PAYMENT_SETTINGS: "Payment settings",
        CONTACTS: "Contacts",
        ADMIN_NOTES: "Admin notes",
        BILLING_OWNER: "Billing owner",
        STRIPE_CONNECTED_ACCOUNT: "Stripe connected account",
        OUTFITTER_DOCUMENTS: "Documents",
        FEEDBACK: "Feedback",
        // Group labels
        ACCOUNT_BUSINESS_INFO: "Account & Business Info",
        MEDIA: "Media",
        RESOURCES: "Resources",
        BOOKING_GUEST_EXPERIENCE: "Booking & Guest Experience",
        PAYMENTS_FINANCIALS: "Payments & Financials",
        INTEGRATIONS_TOOLS: "Integrations & Tools",
        ADMIN_SETTINGS: "Admin Settings",
    },
    EVENT_ORGANIZER_MANAGE: {
        PROFILE_AND_CONTACT_INFO: "Profile & Contact Info",
    },
    CHECK_IN_CONFIG: "Check-in settings",
    ADD_CUSTOM_POST_BOOKING_PAYMENT: "Add custom post-booking payment",
    NO_POST_BOOKING_PAYMENTS: "No post-booking payments available",
    ADDRESS_INPUT_PLACEHOLDER: "Start typing an address to get suggestions",
    NO_RESULTS: "No results",
    NO_RESULTS_FOUND: "No results found",
    INVOICE_NOTE: "Invoice Note",
    CONTACT_NAME: "Contact Name",
    CONTACT_EMAIL: "Contact Email",
    CONTACT_PHONE: "Contact Phone",
    CONTACT_EMAIL_PLACEHOLDER: "contact@gmail.com",
    HUBSPOT_DEAL_OWNER_EMAIL_PLACEHOLDER: "youruser@mallardbay.com",
    ATTRIBUTION_FORM_LABELS: {
        CONTACT_EMAIL: "Contact Email",
        HUBSPOT_DEAL_OWNER_EMAIL: "HubSpot Deal Owner Email",
        DEAL_ATTRIBUTION: "How did this customer request a quote?",
    },
    PROCESSING_FEES_ADDED: "Processing fees will be added",
    BOOKING_INVITE_FOR: "Booking invite for",
    OUTFITTER: "Outfitter",
    OUTFITTERS: "Outfitters",
    RESPONSIBLE_FOR_FEES: "is responsible for processing fees.",
    CARD: "Card",
    BANK: "Bank (ACH)",
    MAX: "max",
    QUANTITY: "Quantity",
    CHARGE_CARD: "Charge card",
    CHARGES_A_CARD_THAT_THE_CONTACT_HAS_SAVED:
        "Charges a card that the contact has saved",
    BANK_CARD: "Bank/card",
    INITIATED: "Initiated",
    EST_ARRIVAL: "Est. Arrival",
    PAYOUT: {
        PAYOUTS: "Payouts",
        NO_PAYOUTS: "No payouts",
        STRIPE_PAYOUT_ID: "Stripe payout ID",
        DELIVERY_METHOD: "Delivery method",
        PAY_TO: "Pay to",
        TRANSACTIONS: "Transactions",
        TIMELINE: "Timeline",
        PAYOUT_TIMELINE_HELPER_TEXT_1: "Don't see your payout?",
        PAYOUT_TIMELINE_HELPER_TEXT_2:
            "Banks can take longer than expected to process payouts. Waiting 1 or 2 business days solves most issues.",
    },
    ADD_ON_NAMES: {
        TROPHY_FEES: "Trophy Fees",
        GEAR_RENTALS: "Gear Rentals",
        MEAL_UPGRADES: "Meal Upgrades",
        OTHER_ADD_ONS: "Other Add-ons",
    },
    REMAINING: "Remaining",
    UNPAID_BALANCES: "Unpaid Balances",
    PLEASE_SELECT_THE_UNPAID_BALANCES_THAT_NEED_TO_BE_CAPTURED:
        "Please select the unpaid balances that need to be captured",
    PAID: "Paid",
    REQUESTED: "Requested",
    REFUNDS_ISSUED: "Refunds Issued",
    SUCCESS: "Success!",
    PAYMENT_TOTAL_AFTER_EXISTING_REFUNDS:
        "Payment total after existing refunds:",
    NO_REFUNDS: "No refunds issued",
    INVOICE: "Invoice",
    INCLUDE_INVOICE: "Include an invoice for the contact?",
    INVOICE_ALERT_BOX_NOTE:
        "If including an invoice for the contact, we will generate a PDF invoice to include in the automated email. To use this feature, you must provide the contact's name and email address. Additionally, the details in this quote will be locked, and the contact will not be able to make any changes once the quote is created.",
    NO_PAYMENTS_FOUND: "No payments found",
    NO_PAYMENTS_MADE_YET: "No payments made yet!",
    SETTLED: "Settled",
    MARK_AS_RECIEVED_IN_PERSON: "Mark as received in person",
    VIEW_INVOICE: "View invoice",
    COPIED_TO_CLIPBOARD: "Copied to clipboard!",
    RESEND_INVOICE: "Resend invoice",
    COPY_LINK: "Copy link",
    DEACTIVATE: "Deactivate",
    ACTIVATE: "Activate",
    SUCCESSFULLY_SENT_INVOICE: "Successfully sent invoice!",
    SUCCESSFULLY_UPDATED_INVITE: "Successfully updated invite!",
    SUCCESSFULLY_SENT_TEAM_MEMBER_INVITE:
        "Successfully sent team member invite!",
    PENDING: "Pending",
    CANCELED: "Canceled",
    CANCEL_UNPAID_BALANCE: "Cancel unpaid balance",
    ACTIVATE_UNPAID_BALANCE: "Activate unpaid balance",
    CANCEL_THIS_UNPAID_BALANCE: "Cancel this unpaid balance?",
    CANCEL_UNPAID_BALANCE_NOTE: "This will cancel the unpaid balance.",
    REACTIVATE_UNPAID_BALANCE: "Re-Activate unpaid balance?",
    REACTIVATE_UNPAID_BALANCE_NOTE: "This will re-activate the unpaid balance.",
    NO_UNPAID_BALANCES: "No unpaid balances",
    CANCELED_UNPAID_BALANCE: "Canceled unpaid balance",
    ACTIVATED_UNPAID_BALANCE: "Activated unpaid balance",
    HIDE_FROM_CONTACT: "Hide from contact at checkout",
    HIDE_FROM_CONTACT_LABEL: "Hide from contact at checkout?",
    OUTFITTER_CREATED_SUCCESSFULLY: "Outfitter created successfully",
    OUTFITTER_UPDATED_SUCCESSFULLY: "Outfitter updated successfully",
    PAYMENT_SETTINGS_UPDATED_SUCCESSFULLY:
        "Payment settings updated successfully",
    HIDE_PACKAGE_FROM_CONTACT_NOTE:
        "Turn this on if you want to make this package visible only to you and your staff when sending quotes/invoices, and not visible to the contact during checkout.",
    HIDDEN: "Hidden",
    YOUR_OUTFITTER_WILL_BE_LIVE_AT: "Your outfitter will be live at",
    THIS_NAME_IS_ALREADY_IN_USE: "This name is already in use",
    ADMIN_ONLY: "Admin only",
    CREATE_OUTFITTER: "Create outfitter",
    OUTFITTER_CARD_FORM_ERRORS: {
        EMAIL: "Contact email is required",
        PHONE: "Contact phone is required",
    },
    OUTFITTER_CARD_FORM_LABELS: {
        NAME: "Outfitter name",
        EMAIL: "Contact email",
        PHONE: "Contact phone",
        ABOUT: "Outfitter description",
        WEBSITE: "Website",
        AVATAR_URL: "Logo",
        GMB_ID: "Google My Business ID",
        HUBSPOT_ID: "Hubspot Company ID",
        FEATURED: "Is this a featured outfitter?",
    },
    CHECK_IN_LABELS: {
        NONE_SET: "No custom settings",
        LODGING_CONFIG: "Lodging Check-in",
        NON_LODGING_CONFIG: "Custom check-in settings",
        CHECK_IN_TOGGLE: "Disable check-in time",
        CHECK_OUT_TOGGLE: "Disable check-out time",
        CHECK_IN_DAY: "Is check-in day before?",
        CHECK_OUT_DAY: "Is check-out day after?",
        HOURLY_PRICING_SUBLABEL:
            "Hourly pricing packages will use start times as check-in times by default",
    },
    GUIDE_TECH: "GuideTech",
    CLICK_TO_LEARN_MORE_ABOUT_GUIDE_TECH:
        "Click here to learn more about GuideTech Pro",
    VIEW_QR_CODE: "View QR code",
    RESOLVE: "Resolve",
    INVALID_SLUG: "Invalid slug",
    TOP_LISTINGS_SECTION_TITLE: "Top listings section title",
    TOP_OUTFITTERS_SECTION_TITLE: "Top outfitters section title",
    OTHER_LISTINGS_SECTION_TITLE: "Other listings section title",
    OTHER_OUTFITTERS_SECTION_TITLE: "Other outfitters section title",
    FEATURED_LISTINGS: "Featured listings",
    FEATURED_OUTFITTERS: "Featured outfitters",
    OTHER_LISTINGS: "Other listings",
    OTHER_OUTFITTERS: "Other outfitters",
    CREATE_PRICING_PACKAGE: "Create pricing package",
    CREATE_ADD_ON: "Create Add-on",
    EDIT_ADD_ON: "Edit Add-on",
    SELECT_ADD_ON_TYPE: "Select the type of add-on you want to create",
    DEPOSITS: "Deposits",
    DAYS_BEFORE_BALANCE_DUE: "Days before balance due",
    DAYS: "days",
    DATE_BALANCE_DUE: "Date balance due",
    EDIT_PAYMENT_SETTINGS: "Edit payment settings",
    RESET: "Reset",
    CLEAR: "Clear",
    CLEAR_FILTERS: "Clear filters",
    CUSTOM_STATEMENT_DESCRIPTOR: "Custom statement descriptor",
    // prev/next month is used for aria labels and needs to match what we're
    // using in the shared lib calendar.
    PREVIOUS_MONTH: "Previous month",
    NEXT_MONTH: "Next month",
    IS_PROCESSING_PAYMENT:
        "Will this payment be processed through Mallard Bay?",
    PAYMENT_INFO: "Payment info",
    HAS_RECEIVED_PAYMENT: "Has payment been received?",
    DEPOSIT_DATE: "Deposit date",
    PAYMENT_METHOD: "Payment method",
    CHECK_NUMBER: "Check number",
    EDIT_OFF_PLATFORM_BOOKING: "Edit off-platform booking",
    MARK_PAYMENT_AS_PAID_OFFLINE_SUCCESS:
        "Successfully marked payment as paid.",
    MARK_AS_NOT_NEEDING_REFUND_SUCCESS:
        "Successfully marked payment as not needing refund.",
    CANCEL_PAYMENT_SUCCESS: "Successfully canceled payment.",
    PAY_OUTFITTER_SUCCESS: "Successfully paid outfitter.",
    MARK_AS_PAID: "Mark as paid",
    PAY_OUTFITTER: "Pay outfitter",
    OUTFITTER_PAID: "Outfitter Paid",
    CANCEL_PAYMENT: "Cancel payment",
    CANCEL_PAYMENT_CONFIRMATION_MESSAGE:
        "Are you sure you want to cancel this payment?",
    PAY_OUTFITTER_CONFIRMATION_MESSAGE_PREFIX: "When you initiate a payout,",
    PAY_OUTFITTER_CONFIRMATION_MESSAGE_SUFFIX:
        "will be transferred to the outfitter's connected Stripe account. Please ensure that the contact's payment has cleared in our account before proceeding. Are you certain you want to payout the outfitter?",
    CHANGE_DUE_DATE: "Change due date",
    CHANGE_DUE_DATE_SUCCESS: "Successfully changed payment due date.",
    PAYMENT_DETAILS: "Payment Details",
    PAYMENT_METHODS: "Payment Methods",
    ALLOW_PAY_WITH_CHECK: "Would you like to allow contacts to pay by check?",
    PAYMENT_ID: "Payment ID",
    DUE_DATE: "Due Date",
    PROCESSING_FEE: "Processing Fee",
    DEPOSIT_DATE_CAPITALIZED: "Deposit Date",
    CHECK_NUMBER_CAPITALIZED: "Check Number",
    SORT: "Sort",
    SEARCH: "Search",
    REQUIRED_FIELD: "Required field",
    ENTER_CORRECT_EMAIL: "Enter correct email",
    ENTER_CORRECT_PHONE: "Enter correct phone",
    REQUIRED: "Required",
    IN_PROGRESS: "In Progress",
    OUTFITTER_DEFAULT: "Outfitter default",
    NOT_ACTIVE_ON_LISTINGS: "Not active on any listings",
    ACTIVE_ON: "Active on",
    ADD_ON_ENABLED_BUT_NOT_ASSIGNED:
        "This add-on is enabled but is not assigned to any listings.",
    LISTING_TYPE: "Listing type",
    PLEASE_SELECT_LISTING_TYPE:
        "Please select which type of listing you will provide.",
    HUNTING: "Hunting",
    FISHING: "Fishing",
    ALL_OUTFITTERS: "All outfitters",
    ALL_REGIONAL_DIRECTORS: "All regional directors",
    SEARCH_ALL_OUTFITTERS: "Search all outfitters",
    NO_OUTFITTERS_YET: "No outfitters yet",
    CLICK: "Click",
    TO_GIVE_SOMETHING_TO_BOOK: "to give your customers something to book!",
    CREATE_NEW_LISTING: "Create new listing",
    SUCESSFULLY_CREATED_LISTING: "Successfully created listing",
    FAILED_TO_CREATE_LISTING: "Failed to create listing",
    LISTING_BASICS: "Listing basics",
    BLAST_AND_CAST: "Cast & Blast",
    UNSET: "Unset",
    NOT_SET: "Not set",
    LICENSE_REQUIRED: "License required",
    CHECK_IN_TIME: "Check-in Time",
    CHECK_OUT_TIME: "Check-out Time",
    CHECK_IN_DAY: "Check-in Day",
    CHECK_OUT_DAY: "Check-out Day",
    SUCCESSFULLY_UPDATED_LISTING: "Successfully updated listing",
    FAILED_TO_UPDATE_LISTING: "Failed to update listing",
    LISTING_BASICS_FORM_LABELS: {
        PUBLISHED: "Status",
        TITLE: "Title",
        RULE: "Rules",
        LICENSE_REQUIRED: "Does this listing require a license from contacts?",
        MIN_GUEST: "Minimum guests",
        MAX_GUEST: "Maximum guests",
        LICENSE_INFO: "Select license state",
        SHOULD_ALLOW_QUOTE_REQUESTS: "Allow contacts to request quotes?",
    },
    LISTING_BASICS_FORM_SUB_LABELS: {
        PUBLISHED: "What is the status of this listing?",
        TITLE: "Give your listing an appealing title to attract contacts",
        RULE: "Provide any extra details for contacts booking your trip",
        MIN_GUEST: "The minimum amount of guests required to book",
        MAX_GUEST: "The maximum amount of guests allowed to book",
        CHECK_IN_MINUTES: "How long should contacts check in?",
        CHECK_OUT_MINUTES: "How long should contacts check out?",
        SHOULD_ALLOW_QUOTE_REQUESTS:
            "This will allow contacts to request quotes and additional information for this listing",
    },
    US_LICENSES: "US Licenses",
    CANADA_LICENSES: "Canada Licenses",
    CANCEL_BOOKING: "Cancel booking",
    CANCEL_BOOKING_SUCCESS: "Successfully canceled booking!",
    CANCEL_BOOKING_CONFIRMATION_TITLE: "Are you sure you want to cancel?",
    CANCEL_BOOKING_CONFIRMATION_MESSAGE:
        "By canceling this booking, all pending payments will be automatically canceled and the availability on your calendar will be restored. Please fill out the form below to select a reason for the cancellation and issue any needed refunds.",
    MARK_AS_REFUNDED: "Mark as refunded",
    DOES_NOT_NEED_REFUND: "Does not need a refund",
    MARK_AS_REFUNDED_CONFIRMATION_TITLE:
        "Are you sure you want to mark as refunded?",
    MARK_AS_REFUNDED_CONFIRMATION_MESSAGE:
        "Before marking this payment as refunded, please ensure you have manually processed the refund. This action will only record the payment as refunded and will not initiate an actual refund.",
    MARK_AS_REFUNDED_SUCCESS: "Successfully marked payment as refunded!",
    REFUND_STATUS: "Refund Status",
    REFUNDED_OFFLINE: "Refunded offline",
    OFFLINE_REFUND_NEEDED: "Offline refund needed",
    CUSTOM_BOOKING_FEE: "Custom booking fee",
    TOTAL_AMOUNT: "Total amount",
    USE_CUSTOM_BOOKING_FEE: "Use custom booking fee?",
    BOOKING_DATE: "Date Booked",
    TRIP_DATE: "Trip Start Date",
    CHOOSE_METRIC_DATE_PROP: "Choose how to group data",
    THIS_YEAR: "This Year",
    LAST_YEAR: "Last Year",
    NEXT_YEAR: "Next Year",
    PREVIOUS_YEAR: "Previous Year",
    THIS_MONTH: "This Month",
    NO_ALERTS_AVAILABLE: "No alerts available",
    REPORTING: {
        LABEL: "Reporting",
        BUSINESS_PERFORMANCE: "Business Performance",
        BUSINESS_PERFORMANCE_DEFINITION:
            "Summary of your overall business performance on Mallard Bay, including key metrics like gross bookings, average bookings, and revenue forecast",
        PAYOUTS_DEFINITION:
            "The Payouts report shows all payments that have been initiated to your Stripe Connected account and transferred to your bank account.",
        PAYMENTS_DEFINITION:
            "The Payments report details all transactions for your outfitter, including those linked to initial bookings and any additional payment requests.",
        UNPAID_BALANCES_DEFINITION:
            "The Unpaid Balances report lists all transactions that have not yet been processed, such as add-ons with payment plans. Once processed, these transactions will appear on the Payments report.",
    },
    ALL_STATUSES: "All statuses",
    OFFLINE: "Offline",
    SENT_TO: "Sent to",
    RECEIVED_FROM: "Received from",
    DATE: "Date",
    BOOKING_TOTAL: "Booking total",
    TBD: "TBD",
    MALLARD_BAY: "Mallard Bay",
    NO_REQUESTED_BOOKINGS: "No requested bookings found.",
    PLEASE_SELECT_BOOKING: "Please select a booking to continue.",
    DESCRIPTION_REQUIRED: "Description is required.",
    CONTACT_NAME_REQUIRED: "Contact name is required.",
    CONTACT_EMAIL_REQUIRED: "Contact email is required.",
    EMAIL_IS_REQUIRED: "Email is required",
    REVIEW: "Review",
    REVIEWING: "Reviewing",
    THE_OUTFITTER: "the outfitter",
    HAVE_QUESTIONS: "Have questions?",
    WITH_BOOKING: "With booking",
    WITHOUT_BOOKING: "Without booking",
    CONFIRM_BULK_ARCHIVE_MESSAGE_1: "Are you sure you want to archive",
    CONFIRM_BULK_ARCHIVE_MESSAGE_2: BULK_ACTION_CANNOT_BE_UNDONE,
    CONFIRM_BULK_DELETE_MESSAGE_1: "Are you sure you want to delete",
    CONFIRM_BULK_DELETE_MESSAGE_2: BULK_ACTION_CANNOT_BE_UNDONE,
    DELETE_LEADS: "Delete leads",
    DELETE_CONTACTS: "Delete Contacts",
    DELETE_CONTACT_LISTS: "Delete contact lists",
    ARCHIVE_CUSTOM_PROPERTIES: "Archive custom properties",
    UPDATE_LEADS: "Update leads",
    MARK_AS_NOT_NEEDING_REFUND_TITLE: "Mark payment as not needing refund",
    MARK_AS_NOT_NEEDING_REFUND_MESSAGE:
        "Are you sure you want to mark this payment as not needing a refund?",
    DENIED: "denied",
    DECLINED: "declined",
    PLEASE_SELECT_THE_REASON: "Please select the reason this",
    IS_BEING: "is being",
    ADD_A_TEAM_MEMBER: "Add a team member",
    ADD_TEAM_MEMBER: "Add team member",
    EDIT_TEAM_MEMBER: "Edit team member",
    UPDATE_TEAM_MEMBER: "Update team member",
    NO_TEAM_MEMBERS_YET: "No team members yet",
    LISTING_TYPES: {
        HUNTING: "Hunting",
        FISHING: "Fishing",
        BLAST_CAST: "Blast & Cast",
        LODGING_ONLY: "Lodging Only",
        ACTIVITY: "Activity",
    },
    SEND_QUOTE: "Send Quote",
    HOME: "Home",
    ROLE: "Role",
    CREATE_TEAM_MEMBER_SUCCESS: "Successfully added team member!",
    UPDATE_TEAM_MEMBER_SUCCESS: "Successfully updated team member!",
    DELETE_TEAM_MEMBER_SUCCESS: "Successfully deleted team member!",
    DELETE_TEAM_MEMBER_TITLE: "Delete team member",
    DELETE_TEAM_MEMBER_MESSAGE:
        "Are you sure you want to delete this team member?",
    EXPORT_DATA: {
        LABEL: "Export",
        EXPORT_DATA: "Export data",
        SELECT_DATA_TYPE: "Select data type",
        INVALID_DATA_TYPE: "Invalid data type selected",
        SUCCESS_MESSAGE_PAYMENTS: "Successfully exported payments",
        SUCCESS_MESSAGE_UNPAID_BALANCES:
            "Successfully exported unpaid balances",
        SUCCESS_MESSAGE_CONTACT_LIST: "Successfully exported contact list",
        NOTE_PAYMENTS_EXPORT:
            "Export payments for the selected outfitter and download them as a CSV file.",
        NOTE_UNPAID_BALANCES_EXPORT:
            "Export unpaid balances for the selected outfitter and download them as a CSV file.",
        DUE_AFTER: "Due after",
        DUE_BEFORE: "Due before",
        CREATED_AFTER: "Created after",
        CREATED_BEFORE: "Created before",
    },
    GUIDE: "Guide",
    NO_GUIDE_YET: "No guide yet.",
    NO_BOOKING_GUIDE_YET: "A guide has not been assigned to this trip.",
    NO_GUIDES_AVAILABLE:
        "No guides available. Please add team members with a 'guide' role to the outfitter.",
    EDIT_GUIDE: "Edit Guide",
    ASSIGN_GUIDE: "Assign a Guide",
    QUOTES: "Quotes",
    QUOTE_REQUESTS: "Quote Requests",
    NEW_COUPON: "New coupon", // TODO delete?
    CREATE_COUPON: "Create Coupon",
    SITE_WIDE_COUPON_NOTE: "Leave blank to create a site wide coupon",
    EXPIRATION_DATE: "Expiration Date",
    AVAILABILITY_BANNER: {
        CURRENTLY: "currently",
        DO: "do",
        DOES: "does",
        DESCRIPTION_1: "not have any availability.",
        DESCRIPTION_2: "Please open the calendar to add available dates.",
    },
    FOR_MORE_ADD_ON_INFO_PREFIX:
        "For more information and examples, please see",
    FOR_MORE_ADD_ON_INFO_LINK_TEXT: "this article",
    PUNCTUATION: {
        PERIOD: ".",
    },
    PERIOD: "Period",
    CLOSE_DRAWER: "Close drawer",
    UPDATE_BOOKING_PAYMENT_PLAN_NOTE:
        "Note: Editing a booking using a deposit payment plan within 14 days of the trip may schedule a payment past the start date of the booking.",
    POLICY_DESCRIPTION_PLACEHOLDER: "Describe your policy here...",
    EDIT_POLICY: "Edit policy",
    REFUND: "Refund",
    MARK_AS_REFUND_NEEDED: `Mark as "Refund needed"`,
    UNABLE_TO_ISSUE_AUTO_REFUND: `We are unable to issue an automatic refund for this contact. They either paid offline or used an alternate payment method. By selecting "Mark as refund needed", we will flag the payments as needing a manual refund. Once the refund has been manually issued, go to the payments section of the booking and choose "Mark as refunded".`,
    AMOUNT_PAID: "Amount paid",
    NO_DEPOSIT_NOTE:
        "There was no deposit payment because the contact paid in full.",
    CHOOSE_HOW_MUCH_TO_REFUND: "Choose how much to refund each contact.",
    NO_REFUNDS_AVAILABLE: "No refunds available.",
    CANCELLATION_NOTE_LABEL: "Additional notes about cancellation.",
    OUTFITTER_POLICY: "Outfitter cancellation policy",
    YOUR_POLICY: "Your cancellation policy",
    UPLOAD_VIDEO: "Upload video",
    EDIT_VIDEO: "Edit Video",
    EDIT_LOCATION: "Edit Location",
    EDIT_AMENITIES: "Edit Amenities",
    CONTACT_NUMBER_NOT_AVAILABLE: "Contact number not available.",
    HUBSPOT_COMPANY_PROFILE: "Hubspot Company Profile",
    PROCESSING_FEE_WARNING:
        "* Total is subject to a processing fee at checkout based on payment method",
    SUMMARY: "Summary",
    DISCOUNT: "Discount",
    DISCOUNT_WARNING:
        "* Discount can only be applied up to the subtotal of your booking.",
    SELECT_A_TIME: "Select a Time",
    SHOULD_SEND_CONTACT_CONFIRMATION_NOTIFICATION:
        "Should contact receive a confirmation email?",
    NOTIFICATION_SETTINGS: "Notification settings",
    DAYS_BEFORE_DISABLE_PAYMENT_PLAN: "Days before disable payment plan",
    PAYMENT_RETRIES: "Payment Retries",
    SHOW_ALL: "Show all",
    SHOW_LESS: "Show less",
    NO_PHOTOS_YET: "No photos yet",
    SELECT_A_PAYMENT_METHOD: "Select a payment method",
    EXISTING_PAYMENT_METHOD: "Existing payment method",
    ADD_NEW: "Add new",
    STRIPE_NOT_INITIALIZED_ERROR: "Failed to initialize stripe",
    PAYMENT_METHOD_REQUIRED: "Payment method is required",
    GROUP_BOOKING: "Group booking",
    GROUP_LEADER: "Group leader",
    PRICE_SUMMARY: "Price summary",
    NO_DATES_FOR_SUMMARY:
        "Unable to show price summary when dates are open ended",
    START_TIME_REQUIRED_FOR_PRICE_SUMMARY:
        "Select a start time to see the price summary.",
    UNABLE_TO_SHOW_SUMMARY:
        "Summary will show once dates and a package have been selected",
    COUPON_CUSTOM_CODE_PLACEHOLDER: "Enter a custom code (i.e 'WINTER20')",
    COUPON_DISCOUNT_AMOUNT_PLACEHOLDER: "Enter a discount amount (> 0)",
    CREATE_COUPON_SUCCESS: "Coupon created successfully",
    ARCHIVED: "Archived",
    CREATE_NEW: "Create new",
    CUSTOMIZE_EXISTING: "Customize existing",
    CUSTOM_PRICE: "Custom price",
    CUSTOMIZE_PRICING_PACKAGE: "Customize pricing package",
    SELECT_PRICING_PACKAGE_TO_CUSTOMIZE:
        "Select a pricing package to customize",
    CUSTOMIZE_ADD_ON: "Customize add on",
    SELECT_ADD_ON_TO_CUSTOMIZE: "Select an add on to customize",
    DAY_BEFORE: "the day before",
    DAY_AFTER: "the day after",
    DAY_OF: "the day of",
    THIS_WILL_NOT_AFFECT_THE_PRICE_OF_YOUR_PACKAGE:
        "This will not affect the price of your package, it's just for reference if you ever want to reuse this add-on.",
    USUAL_PRICE: "Usual price",
    EDITABLE_AT_CHECKOUT: "Editable at Checkout",
    INCLUDED: "included",
    ATTRIBUTION: "Attribution",
    PACKAGE: "Package",
    GUESTS_AND_ADD_ONS: "Guests & Add-ons",
    CONFIGURE: "Configure",
    PAYMENT: "Payment",
    CREATE_ADDITIONAL_BOOKING_PAYMENT: "Create booking payment",
    NEW_BOOKING_PAYMENT: "New booking payment",
    CHECK_CASH_OTHER: "Check/Cash/Other",
    WHEN_SHOULD_THE_PAYMENT_BE_COLLECTED:
        "When should the payment be collected?",
    RECEIVED: "Received",
    DUE_NOW: "Due Now",
    DUE_LATER: "Due Later",
    PAYMENT_WILL_BE_CHARGED_IMMEDIATELY: "Payment will be charged immediately",
    PAYMENT_WILL_BE_DUE_AT_A_LATER_DATE: "Payment will be due at a later date",
    PAYMENT_NOTES: "Payment notes",
    ADDITIONAL_BOOKING_PAYMENT_SUCCESS: "Successfully added booking payment!",
    ADDITIONAL_BOOKING_PAYMENT_FAILED: "Failed to add booking payment",
    SELECT_AN_AMOUNT_TO_BEGIN: "Select an amount to begin",
    SELECT_MEMBER: "Select member",
    PAYMENT_HAS_BEEN_RECEIVED: "Payment has been received",
    DATE_RECEIVED: "Date Received",
    LOGGED_IN_AS: "Logged in as",
    NOW_VIEWING: "Now viewing",
    VIEW_AS: "View as",
    SELECTED_MEMBER: "Selected",
    SWITCH_IMPERSONATION: "Switch impersonation",
    SEARCH_OUTFITTERS: "Search outfitters",
    SEARCH_FOR_AN_OUTFITTER_TO_VIEW_AS: "Search for an outfitter to view as...",
    SELECT_A_MEMBER: "Select a member",
    VIEWING: "Viewing",
    EXIT_IMPERSONATION: "Exit",
    STOP_IMPERSONATING: "Stop impersonation",
    LISTING_RATES_OVERRIDE_OUTFITTER_RATES:
        "Payment rates set here will override the values that have been set at the outfitter level.",
    LISTING_PAYMENT_FEE_SETTINGS_OVERRIDE_OUTFITTER_SETTINGS:
        "Payment fee settings set here will override the values that have been set at the outfitter level.",
    ASSETS: "Assets",
    UPGRADE_PLAN: "Upgrade plan for access",
    FEATURE_UNAVAILABLE: "Feature not available",
    DEFAULT_PAYWALL_COPY:
        "This feature is not available with your current subscription. Please reach out to your account manager to upgrade.",
    COUPON_LIMIT: "Coupon Limit Reached",
    COUPON_LIMIT_COPY:
        "You've reached the maximum number of coupons on your current plan. To add more coupons, please upgrade to a higher tier plan.",
    TEAM_MEMBER_LIMIT: "Team Member Limit Reached",
    TEAM_MEMBER_LIMIT_COPY:
        "You've reached the maximum number of team members on your current plan. To add more team members, please upgrade to a higher tier plan.",
    NEW_BOOKING: "New Booking",
    TRIP_DETAILS: "Trip Details",
    CUSTOMER_DETAILS: "Customer Details",
    GUESTS_AND_PACKAGE: "Guests & Package",
    ADD_NOTES_FOR_THIS_BOOKING: "Add notes for this booking",
    OVERRIDE_AMOUNT: "Override amount?",
    UPDATE_LISTING_LODGINGS_SUCCESS: "Successfully updated listing lodgings!",
    QUICK_PAY: {
        LABEL: "Quick Pay",
        CREATE: "Create Quick Pay",
        UPDATE: "Update Quick Pay",
        SHOULD_COLLECT_TAX_LABEL:
            "Would you like to collect tax for this payment?",
        SHOULD_COLLECT_PAYMENT_NOW_LABEL:
            "Would you like to enter payment details now?",
        CREATE_QUICK_PAY_SUCCESS: "Successfully created quick pay payment!",
        UPDATE_QUICK_PAY_SUCCESS: "Successfully updated quick pay payment!",
        PROCESS_QUICK_PAY_SUCCESS: "Successfully processed quick pay payment!",
        COVER_PROCESSING_FEES:
            "Would you like the contact to cover the processing fees?",
        COVER_PROCESSING_FEES_HELPER_TEXT:
            "This setting will override your default preferences for who covers credit card or ACH processing fees.",
    },
    LISTING_SHARE_TEXT: "Check out this listing on Mallard Bay",
    CUSTOMER: "Customer",
    SKIP: "Skip",
    EXIT: "Exit",
    COUPON_CONFIRMATION: {
        DELETE_COUPON: "Delete coupon",
        DELETE_COUPON_CONFIRMATION_MESSAGE:
            "Are you sure you want to delete this coupon?",
        DELETE_COUPON_CONFIRMATION_MESSAGE_2: "This action cannot be undone",
    },
    COUPON_TABLE: {
        COUPON_NAME: "Coupon Name",
        CODE: "Code",
        AMOUNT: "Amount",
        LIMIT: "Limit",
        EXPIRES: "Expires",
        OUTFITTER: "Outfitter",
        MISSING_FIELD: "--",
    },
    OUTFITTERS_TABLE: {
        NAME: "Name",
        LOCATION: "Location",
        STATUS: "Status",
        SUBSCRIPTION_TIER: "Subscription Tier",
        BILLING_OWNER: "Billing owner",
        IS_FEATURED: "Is Featured",
    },
    ONBOARDINGS: "Onboardings",
    AMENITIES: "Amenities",
    TRIP_INCLUDES: "Trip includes",
    LICENSES: "Licenses",
    OUTFITTER_NAME: "Outfitter name",
    NO_ONBOARDINGS: "No onboardings found.",
    ONBOARDING: "Onboarding",
    PRICING_SUMMARY: "Pricing Summary",
    CREATE_PAYMENT_LINK: "Create Payment Link",
    UPDATE_PAYMENT_LINK: "Update Payment Link",
    SEND_PAYMENT_LINK: "Send payment link email?",
    PRODUCT: "Product",
    SELECT_PRODUCT: "Select product",
    SELECT_PROMO_CODE: "Select promo code",
    UPDATE_ONBOARDING_SUCCESS: "Successfully updated onboarding!",
    INITIATE_ONBOARDING: "Initiate Onboarding",
    PROMO_CODE: "Promo code",
    ARCHIVE_ONBOARDING_SUCCESS: "Successfully archived onboarding!",
    DELETE_LEADS_SUCCESS: "Successfully deleted leads!",
    DELETE_CONTACTS_SUCCESS: "Successfully deleted contacts!",
    ARCHIVE_OUTFITTER_CUSTOM_PROPERTIES_SUCCESS:
        "Successfully archived custom properties!",
    DELETE_CONTACT_LISTS_SUCCESS: "Successfully deleted contact lists!",
    UPDATE_LEADS_SUCCESS: "Successfully updated leads!",
    ARCHIVE_ONBOARDING: "Archive onboarding",
    ARCHIVE_ONBOARDING_CONFIRM:
        "Are you sure you want to archive this onboarding?",
    COPY_PAYMENT_LINK: "Copy payment link",
    COPY_BILLING_PORTAL_LINK: "Copy billing portal link",
    COPY_CONTEXT_FOR_LLM: "Copy context for LLM",
    FILTER_BY_STATUS: "Filter by status",
    NO_NOTE: "No note",
    NO_COUPON: "No coupon",
    NO_QUOTES_FOUND: "No quotes found",
    NO_QUOTE_REQUESTS_FOUND: "No quote requests found",
    BOOKING_INVITE_TABLE: {
        CONTACT: "Contact",
        LISTING: "Listing",
        PACKAGE: "Package",
        NOTES: "Notes",
        DATES_GUESTS: "Dates / Guests",
        ADD_ONS: "Add-ons",
        COUPON: "Coupon",
        EDITABLE: "Editable",
    },
    BOOKING_INVITE_REQUESTS_TABLE: {
        DATE_REQUESTED: "Date Requested",
        LISTING: "Listing",
        NAME_AND_EMAIL: "Name / Email",
        PREFERRED_DATES: "Preferred Dates",
        STATUS: "Status",
    },
    LISTINGS_TABLE: {
        TITLE: "Title",
        LOCATION: "Location",
        STATUS: "Status",
        AVAILABILITY: "Availability",
    },
    SELF_ONBOARD_LISTINGS_TABLE: {
        TITLE: "Title",
        LOCATION: "Location",
        MIN_GUESTS: "Min Guests",
        MAX_GUESTS: "Max Guests",
    },
    SELF_ONBOARD_LODGING_TABLE: {
        ROOM_NAME: "Room Name",
        CAPACITY: "Capacity",
        LOCATION: "Location",
    },
    WELCOME_ABOARD: "Welcome Aboard!",
    ONBOARDING_INVITATION_ACCEPTED:
        "Your account has been successfully created!",
    ONBOARDING_INVITE_CTA_MESSAGE:
        "Click the button below to access your Mallard Bay for Guides Dashboard and start your onboarding process.",
    VIEW_DASHBOARD: "View Dashboard",
    VERIFYING_INVITE: "Verifying invite...",
    SETTING_UP_ACCOUNT: "Setting up your account...",
    LAUNCH: "Launch",
    CONNECT: "Connect",
    YOUR_STRIPE_DASHBOARD: "your Stripe dashboard",
    STRIPE_DASHBOARD: "Stripe dashboard",
    VIEW_FUNDS: "View your available funds",
    CONNECT_TO_START: "Connect to start accepting payments",
    STRIPE_ACCOUNT_CONNECTED:
        "Your Stripe account is connected and ready to use.",
    BILLING_PORTAL_TITLE: "Stay in Control",
    BILLING_PORTAL_SUBTITLE:
        "Need to update your plan? Click below to manage your subscription in just a few steps.",
    MANAGE_SUBSCRIPTION: "Manage Subscription",
    WIDGET_CARD_TITLE: "Monetize Your Website",
    WIDGET_CARD_SUBTITLE:
        "Add the Mallard Bay booking widget to your site and let customers book trips directly with ease.",
    WIDGET_CARD_CTA: "Get Widget Now",
    AGO: "ago",
    BOOKING_INFO: "Booking Info",
    PRICING_INFO: "Pricing Info",
    THIS_LISTING_HAS_NO_AVAILABLE_PACKAGES:
        "This listing has no available packages",
    DATES_IS_A_REQUIRED_FIELD: "Dates is a required field",
    NO_BOOKINGS: "No bookings",
    BOOKING_HAS_NO_PRICING_PACKAGE: "This booking has no pricing package.",
    UNABLE_TO_FIND_CURRENT_STEP: "Unable to find current step",
    TO_SUBMIT_A_REFUND_REQUEST:
        "to submit a refund request. Be sure to provide a booking ID, amount, and reason.",
    CONTACT_SUPPORT: "Contact support",
    ONBOARDING_CALL_CARD_TITLE: "Schedule an onboarding call",
    ONBOARDING_CALL_CARD_SUBTITLE:
        "Have questions? Click below to schedule a call with our team.",
    ONBOARDING_CALL_CARD_CTA: "Schedule a call",
    AFTER_CREATING_THIS_BOOKING:
        "After creating this booking you will be redirected to the payment processing screen.",
    IMPORTANT_NOTE: "Important Note",
    META_AD_CONFIG_NEEDED: "Meta ad account configuration in progress",
    META_AD_CONFIG_NEEDED_DESCRIPTION:
        "Your accounts are being configured for this outfitter. For a current status update, please contact support.",
    META_AD_ACCOUNT_IMPORT_IN_PROGRESS: "Import in progress",
    META_AD_ACCOUNT_IMPORT_IN_PROGRESS_DESCRIPTION:
        "We are importing your Meta ad accounts. Please refresh this page in a few minutes to view your data.",

    USER_AND_ADDONS: "User & Add-ons",
    SELF_INITIATED: "Self Initiated",
    MIGRATE_SUBSCRIPTION: "Migrate subscription",
    MIGRATE_SUBSCRIPTION_CONFIRM:
        "Are you sure you want to migrate this outfitter's subscription?",
    EDIT_FREE_SUBSCRIPTION: "Edit free subscription",
    EDIT_FREE_SUBSCRIPTION_CONFIRM:
        "In order to change a free tier subscription, we will need to create a new onboarding and send a payment link. Are you sure you want to proceed?",
    CREATE_ONBOARDING_FOR_OUTFITTER_SUCCESS:
        "Successfully created onboarding for outfitter",
    EDIT_SUBSCRIPTION: "Edit subscription",
    EDIT_PAYWALL_FEATURES: "Edit paywall features",
    FREE_TIER_ONBOARDING_NOTICE:
        "This outfitter currently has a free tier subscription. A payment link will be required to convert to a paid tier.",
    FAILED_PAYMENTS: "Failed payments",
    OUTFITTER_BOOKING_FEE: "Outfitter booking fee",
    WEBSITE_RATE: "Website Rate",
    STANDARD_QUOTE_RATE: "Standard Quote Rate",
    MARKETPLACE_QUOTE_RATE: "Marketplace Quote Rate",
    QUOTE_RATE: "Quote Rate",
    WIDGET_RATE: "Widget Rate",
    DASHBOARD_RATE: "Dashboard Rate",
    ADDED: "Added",
    BOOKED: "Booked",
    BOOKINGS_TABLE_HEADERS: {
        LISTING_TITLE: "Listing",
        BOOKING_DATE: "Date Booked",
        CHECK_IN: "Check-in",
        TRIP_DATES: "Dates",
        CHECK_OUT: "Check-out",
        CUSTOMER: "Customer",
        TAGS: "Tags",
        OUTFITTER: "Outfitter",
        ACTIONS: "Actions",
        GUESTS: "Guests",
    },
    REFUND_INDICATOR_SUFFIX: " *",
    CANCEL_PAYMENT_REQUEST: "Cancel payment request",
    CANCELLED_PAYMENT_REQUEST_SUCCESS: "Successfully cancelled payment request",
    CANCELLED_PAYMENT_REQUEST_FAILED: "Failed to cancel payment request",
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_PAYMENT_REQUEST:
        "Are you sure you want to cancel this payment request?",
    THE_SPORSTMAN_WILL_NO_LONGER_BE_ABLE_TO_ACCESS_THIS_REQUEST:
        "The contact will no longer be able to access this request.",
    OFFSITE_BOOKING: "Off-site booking",
    OFFSITE: "Off-site",
    CONTACT_THE_DEV_TEAM_TO_UPDATE_LEGACY_OUTFITTER:
        "This is a legacy outfitter. Contact the dev team if you want to update these settings",
    TIER: "Tier",
    OWNER_INVITE_STATUS: "Owner status",
    CREATE_SUBSCRIPTION: "Create Subscription",
    SUBSCRIPTION_DETAILS: "Subscription Details",
    SUBSCRIPTION_TIER: "Subscription tier",
    START_DATE: "Start date",
    START_TIME: "Start time",
    END_DATE: "End date",
    END_TIME: "End time",
    CURRENT_PERIOD_START: "Current period start",
    CURRENT_PERIOD_END: "Current period end",
    UPDATE_SUBSCRIPTION: "Update Subscription",
    UPDATE_SUBSCRIPTION_NOTE:
        "Once updated, it may take several minutes for these changes to take effect.",
    UPDATE_SUBSCRIPTION_SUCCESS: "Successfully updated outfitter subscription!",
    UPDATE_FEATURE_ACCESS_SUCCESS:
        "Successfully updated outfitter paywall features!",
    REMOVE_LIMIT: "Remove limit",
    SET_LIMIT: "Set limit",
    CURRENT_USAGE: "Current usage",
    ADD_FEATURE_PLACEHOLDER: "Select a feature to add...",
    REMOVE_FEATURE: "Remove feature",
    UPDATE_PAYWALL_FEATURES: "Update Paywall Features",
    EDIT_PAYWALL_FEATURES_NOTE:
        "Extra features that have been added can be removed at any time, however, removing features that are part of the current subscription tier is not allowed.",
    ONBOARDING_EMAIL_NOTE: {
        NON_ZERO_STANDARD:
            "This email will be used if you choose to send the automated payment link to the recipient, and to set up the owner team member for the outfitter.",
        ZERO_SUBTOTAL_STANDARD:
            "This email will be used to set up the owner team member for the Outfitter.",
        NON_ZERO_LEGACY:
            "This email will be used if you choose to send the automated payment link to the recipient. Since this is a legacy Outfitter, we will not use this email to setup or update any team member accounts.",
        NON_ZERO_CURRENT_FREE_TIER:
            "This email will be used if you choose to send the automated payment link to the recipient. Since this is an existing free tier Outfitter, we will not use this email to setup or update any team member accounts.",
    },
    NO_UPCOMING_AVAILABILITY: "No availability",
    BOOKING_INVITE_QUOTE_RATE_LABEL:
        "Which booking rate should we charge the outfitter?",
    SELECT_A_RATE: "Select a rate",
    LEGACY_OUTFITTER_FEE_RATE_WARNING: "Outfitter fee rate is",
    LEGACY_OUTFITTER_FEE_FIXED_WARNING: "Outfitter fee fixed value is",
    PAYMENT_FEE_SETTINGS_OVERRIDE_WARNING:
        "These settings are overriding the subscription tier payment fees",
    PAYMENT_FEE_SETTINGS_UPDATED: "Payment fee settings updated",
    PAYMENT_FEE_SETTINGS_OVERRIDE_DELETED:
        "Deleted payment fee settings override",
    UPGRADE_FREE_TIER_NOTICE: {
        LINE_ONE:
            "If this outfitter signed up for a free tier through the pricing page, we will need them to add a payment method before upgrading the subscription.",
        LINE_TWO:
            "The outfitter owner can use the following link to login to the billing portal and add a payment method:",
    },
    REMINDER_EDITING_THIS_BOOKING:
        "Reminder: Editing this booking will re-create the previously canceled payment. If the payment is not needed, please be sure to cancel it again.",
    YOU_NEED_TO_FINISH_ONBOARDING_HEADER: "You need to finish onboarding!",
    YOU_NEED_TO_FINISH_ONBOARDING_TEXT:
        "You need to finish onboarding a Stripe account with Mallard Bay to get paid for your bookings.",
    REORDER_LISTINGS: "Reorder listings",
    REORDER_LISTINGS_DND: "Reorder listings by dragging and dropping",
    YOUR_LISTINGS_WILL_BE_IN_THIS_ORDER:
        "Your listings will appear in the following order",
    REORDER_PHOTOS: "Reorder photos",
    REARRANGE_PHOTOS_HEADER_TEXT: "Rearrange photos by dragging and dropping",
    REARRANGE_PHOTOS_HELP_TEXT:
        "Your photos will appear in the following order",
    REORDER_PRICING_PACKAGES: "Reorder pricing packages",
    REORDER_PRICING_PACKAGES_HEADER_TEXT:
        "Reorder pricing packages by dragging and dropping",
    REORDER_PRICING_PACKAGES_HELP_TEXT:
        "Your pricing packages will appear in the following order",
    SELECT_LISTINGS: "Select listings",
    SELECT_PRICING_PACKAGES: "Select pricing packages",
    BOOKING_STATUS: "Booking status",
    FIND_SOLUTIONS_AND_GUIDES:
        "Find solutions and guides to streamline your booking experience",
    NEED_HELP_WITH_YOUR_BOOKING: "Need help with your booking?",
    NEED_HELP_UNDERSTANDING_YOUR_CONTACTS:
        "Need help understanding your contacts?",
    NEED_HELP_UNDERSTANDING_YOUR_CUSTOM_PROPERTIES:
        "Need help understanding how to use custom properties?",
    CUSTOM_PROPERTIES_LEARN_MORE:
        "Learn how to leverage custom properties to accelerate your business.",
    NEED_HELP_MANAGING_YOUR_LEADS: "Need help managing your leads?",
    VISIT_KNOWLEDGE_BASE: "Visit Knowledge Base",
    CHECKOUT_OUR_KNOWLEDGE_BASE: "Checkout our knowledge base!",
    NEED_HELP_ADJUSTING_YOUR_AVAILABILITY:
        "Need help adjusting your availability?",
    NEED_HELP_SENDING_A_QUOTE: "Need help sending a quote?",
    NEED_HELP_UNDERSTANDING_YOUR_REPORTS:
        "Need help understanding your reports?",
    NEED_HELP_WITH_QUICK_PAY: "Need help with Quick Pay?",
    NEED_HELP_MANAGING_YOUR_LISTING: "Need help managing your listing?",
    NEED_HELP_MANAGING_YOUR_OUTFITTER_PROFILE:
        "Need help managing your Outfitter profile?",
    KNOWLEDGE_BASE: "Knowledge Base",
    EDIT_AMENITY: "Edit amenity",
    ADD_AMENITY: "Add amenity",
    ALL_AMENITIES: "All amenities",
    INCLUDED_LODGING_REQUIRED:
        "Included lodging is required for lodging only packages.",
    PRO_TIP: "Pro Tip",
    CHANGE_IMAGE: "Change image",
    UPLOAD_IMAGE: "Upload image",
    ABOUT_YOUR_OUTFITTER: "About your Outfitter",
    PHOTOS_AND_VIDEO: "Photos & Video",
    WEBSITE_URL: "Website URL",
    WEBSITE_URL_PLACEHOLDER: "https://www.example.com",
    WEBSITE_URL_ERROR: "Must be a valid URL starting with http:// or https://",
    CANCELLATION_POLICY: "Cancellation Policy",
    OUTFITTER_MEDIA_FORM_LABELS: {
        AVATAR: "Logo",
        VIDEO: "Video",
        PHOTOS: "Photos",
    },
    ADD_ANOTHER_LISTING: "Add another listing",
    SELECTED: "selected",
    ADD_SPECIES: "Add species",
    SELF_ONBOARDING: {
        TITLE: "It's easy to",
        HIGHLIGHTED_TITLE: "get started",
        DESCRIPTION:
            "Set up your profile and start managing bookings effortlessly.",
        OUTFITTER_SETUP_TITLE: "Tell us about your business",
        OUTFITTER_SETUP_DESCRIPTION:
            "Share a few key details to let customers know who you are and what you offer.",
        PAYMENT_DETAILS_TITLE: "Payment Details",
        PAYMENT_DETAILS_DESCRIPTION:
            "Set up secure payment options to ensure smooth transactions.",
        PACKAGES_AND_ADD_ONS_TITLE: "Add packages and add-ons",
        PACKAGES_AND_ADD_ONS_DESCRIPTION:
            "Customize your offerings with packages and extras to cater to your customers' needs.",
        AVAILABILITY_TITLE: "Add availability for bookings",
        AVAILABILITY_DESCRIPTION:
            "Let customers know when you're available by setting your schedule.",
        GETTING_PAID_TITLE: "Getting paid",
        GETTING_PAID_DESCRIPTION:
            "Setup your stripe connected account to receive payments from Mallard Bay.",
        OUTFITTER_NAME_TITLE: "First, let's setup your Outfitter Profile",
        OUTFITTER_NAME_DESCRIPTION:
            "Please confirm that this is the name and URL that you would like to use.",
        OUTFITTER_DESCRIPTION_TITLE: "Showcase your outfitting business",
        OUTFITTER_DESCRIPTION_DESCRIPTION:
            "Describe your business, what makes your operation unique, how long you've been operating, and why someone should book a trip with you!",
        OUTFITTER_INFO_TITLE: "First, let's set up your Outfitter Profile",
        OUTFITTER_INFO_DESCRIPTION:
            "Add a few details about your outfitter to get started.",
        OUTFITTER_ADDRESS_TITLE: "Next, let's set up your address",
        OUTFITTER_ADDRESS_DESCRIPTION: "Tell us where you're located.",
        OUTFITTER_ADDITIONAL_INFO_TITLE:
            "Great! Now, let's add some additional details.",
        OUTFITTER_ADDITIONAL_INFO_DESCRIPTION:
            "Add these key details to make your business stand out and provide essential information for your customers.",
        OUTFITTER_MEDIA_TITLE:
            "Awesome! It's time to upload some photos and a video.",
        OUTFITTER_MEDIA_DESCRIPTION:
            "Highlight your adventures, gear, and unique experiences. Eye-catching visuals help bring your listing to life!",
        OUTFITTER_CHECK_IN_OUT_TITLE:
            "What time do your guests need to check-in and check-out for their trip?",
        OUTFITTER_CHECK_IN_OUT_DESCRIPTION:
            "Provide details about your check-in and check-out times",
        OUTFITTER_CANCELLATION_POLICY_TITLE:
            "What is your cancellation policy?",
        OUTFITTER_CANCELLATION_POLICY_DESCRIPTION:
            "Outline your cancellation policy to ensure clarity and manage expectations with your contacts.",
        OUTFITTER_REVIEW_TITLE: "Lookin' Good, Let's Review Your Profile!",
        OUTFITTER_REVIEW_DESCRIPTION:
            "Take a moment to check your details and ensure everything is correct.",
        LISTINGS_AND_LODGING_TITLE: "Add listings and lodging",
        LISTINGS_AND_LODGING_DESCRIPTION:
            "Add listings and lodging for customers to book.",
        ADD_EDIT_LISTINGS_TITLE:
            "Now that your Outfitter profile is setup, let's add your listings.",
        ADD_EDIT_LISTINGS_DESCRIPTION:
            "To complete your listing, please provide the following details:",
        STATEMENT_DESCRIPTOR_TITLE:
            "Please adjust your payment descriptor as needed.",
        STATEMENT_DESCRIPTOR_DESCRIPTION:
            "The payment descriptor is how your brand will appear on a contact's bank statement.",
        DEPOSIT_SETTINGS_TITLE: "Would you like to allow payment plans?",
        DEPOSIT_SETTINGS_DESCRIPTION:
            "Payment plans let contacts split the cost of their Mallard Bay trip into manageable installments. Outfitters have full control over the terms, including payment schedules and due dates, offering flexibility for their business while ensuring a clear and accessible booking process for contacts.",
        PAYMENT_SETTINGS_REVIEW_TITLE:
            "Great!  Lets review your payment settings",
        PAYMENT_SETTINGS_REVIEW_DESCRIPTION:
            "If everything looks good, lets move on to pricing packages and add-ons",
        OUTFITTER_ADD_ONS_TITLE:
            "Would you like to create any add-on services that contacts can select at checkout?",
        OUTFITTER_ADD_ONS_DESCRIPTION:
            "Add-ons are optional services that can be added to a booking at checkout. They are a great way to increase revenue and provide additional value to your contacts.",
        ADD_EDIT_LODGING_TITLE: "Do you offer lodging?",
        ADD_EDIT_LODGING_DESCRIPTION:
            "Let adventurers know if they can stay with you. Adding lodging options can make your listing even more appealing!",
        SKIP_LODGING_DESCRIPTION: `Just skip this step by pressing "Next" if you don't offer lodging.`,
        LISTINGS_AND_LODGING_REVIEW_TITLE:
            "Congrats!  You've setup your listings and lodging",
        LISTINGS_AND_LODGING_REVIEW_DESCRIPTION:
            "Once you review your listings and lodging, lets add payment settings",
        PRICING_PACKAGES_TITLE: "Let's set up your pricing packages!",
        PRICING_PACKAGES_DESCRIPTION:
            "A pricing package outlines what's included and establishes the price. You can include multiple price packages in one listing if they share the same season and location. If the season or location changes, create a separate listing to keep calendar management simple.",
        ADD_ONS_AND_PACKAGES_REVIEW_TITLE:
            "Great!  Lets review your pricing packages and add-ons",
        ADD_ONS_AND_PACKAGES_REVIEW_DESCRIPTION:
            "If everything looks good, lets move on to the next step",
        ADD_AVAILABILITY_TITLE:
            "Now that your listings are ready, let's update your calendar availability.",
        ADD_AVAILABILITY_DESCRIPTION:
            "Ensure your calendar is up-to-date so contacts know when you're available.",
        AVAILABILITY_REVIEW_TITLE: "Great!  Lets review your availability",
        AVAILABILITY_REVIEW_DESCRIPTION:
            "Once you review your availability, you'll be all set!",
        GETTING_PAID_STRIPE_TITLE: "Connect your Stripe account",
        GETTING_PAID_STRIPE_DESCRIPTION:
            "It's time to to setup your Stripe Connected account. This will allow us to automatically deposit funds into your account as we process payments.",
        OUTFITTER_CARD_TITLE: "Set Up Your Outfitter Profile",
        OUTFITTER_CARD_DESCRIPTION:
            "Add your business details, photos, and policies so contacts know who you are and what to expect when booking with you.",
        PAYMENTS_CARD_TITLE: "Configure Payments & Payouts",
        PAYMENTS_CARD_DESCRIPTION:
            "Set up your Stripe account and choose deposit and payment settings so you can accept bookings and get paid securely.",
        LISTING_CARD_TITLE: "Create Your First Listing",
        LISTING_CARD_DESCRIPTION:
            "Build your first trip listing by adding pricing, lodging options, and availability so customers can start booking right away.",
        LISTING_DETAILS_TITLE:
            "Now that your Outfitter is set up, let's add your first listing.",
        LISTING_DETAILS_DESCRIPTION: "Provide the following details:",
        LISTING_AVAILABILITY_TITLE: "Add availability",
        LISTING_AVAILABILITY_DESCRIPTION:
            "Let customers know when your listing is available to book by setting your schedule. One listing = one availability calendar.",
        LISTING_REVIEW_TITLE: "Congrats! You've set up your first listing.",
        LISTING_REVIEW_DESCRIPTION:
            "Once you review your listing, you'll be all set!",
        LISTING_DESCRIPTION_TITLE: "Add listing description",
        LISTING_DESCRIPTION_DESCRIPTION:
            "Share clear details about this specific trip, like what's included, what contacts can expect, the target species, and any methods of harvest!",
    },
    THIS_OUTFITTER_HAS_SUCCESSFULLY_BEEN_APPROVED:
        "This outfitter has successfully been approved",
    EDIT_LISTING: "Edit listing",
    FAILED_TO_APPROVE_OUTFITTER: "Failed to approve outfitter",
    BOOKING_DECLINED: "Booking declined",
    FAILED_TO_DECLINE_BOOKING: "Failed to decline booking",
    VALIDATION: {
        PHONE: "Please provide a valid phone number",
    },
    CAPACITY: "Capacity",
    FAILED_TO_FETCH_SPECIES: "Failed to fetch species",
    GROUP_PRICING: "Group Pricing",
    PER_PERSON_PRICING: "Per Person Pricing",
    NO_GROUP_PRICING_PACKAGES: "No group pricing packages",
    NO_PER_PERSON_PRICING_PACKAGES: "No per person pricing packages",
    ADD_PRICING_PACKAGE: "Add Pricing Package",
    PRICING_PACKAGES: "Pricing Packages",
    ADD_AVAILABILITY: "Add availability",
    EDIT_AVAILABILITY: "Edit availability",
    GET_CODE_NOW: "Get Code Now",
    VIEW_YOUR_DASHBOARD: "View your Dashboard",
    RESOURCES: "Resources",
    ADD_RESOURCE: "Add Resource",
    EDIT_RESOURCE: "Edit Resource",
    VEHICLE: "Vehicle",
    BOAT: "Boat",
    BLIND: "Blind",
    RESOURCE_TYPE: "Resource Type",
    MAKE: "Make",
    MODEL: "Model",
    BOAT_MANUFACTURER: "Boat Manufacturer",
    BOAT_TYPE: "Boat Type (ft.)",
    BOAT_LENGTH: "Boat Length (ft.)",
    YEAR: "Year",
    CREATE_RESOURCE_SUCCESS: "Successfully created resource!",
    CATEGORY: "Category",
    VEHICLES: "Vehicles",
    BOATS: "Boats",
    BLINDS: "Blinds",
    DELETE_RESOURCE: "Delete Resource",
    DELETE_RESOURCE_SUCCESS: "Successfully deleted resource!",
    DELETE_RESOURCE_CONFIRMATION:
        "Are you sure you want to delete this resource?",
    REMOVE_RESOURCE_WARNING_TITLE: "Affected pricing packages",
    REMOVE_RESOURCE_WARNING_MESSAGE:
        "Deleting this resource will also remove it as the included resource option from pricing packages. Bookings already made with these pricing packages will not be affected.",
    MANUFACTURER: "Manufacturer",
    QUESTIONS: "Questions?",
    OUTFITTER_DOCUMENTS: "Documents",
    LIABILITY_WAIVERS: "Liability waivers",
    LIABILITY_WAIVER: "Liability waiver",
    WHAT_TO_EXPECT_DOCUMENTS: "What to expect documents",
    WHAT_TO_EXPECT_DOCUMENT: "What to expect document",
    ADD_A_LIABILITY_WAIVER: "Add a liability waiver",
    ADD_A_WHAT_TO_EXPECT_DOCUMENT: "Add a what to expect document",
    DOCUMENT: "Document",
    DOCUMENT_VALIDATION: {
        NAME_IS_REQUIRED: "Name is required",
        URL_IS_REQUIRED: "Url is required",
    },
    OUTFITTER_DOCUMENT_CREATED: "Outfitter document successfully created",
    OUTFITTER_DOCUMENT_UPDATED: "Outfitter document successfully updated",
    OUTFITTER_DOCUMENT_ARCHIVED: "Outfitter document successfully archived",
    VIEW_DOCUMENT: "View",
    EXTERNAL_URL: "Url",
    ASSOCIATED_WITH_THIS_DOCUMENT: "associated with this document",
    DELETE_OUTFITTER_DOCUMENT: "Delete outfitter document",
    DELETE_OUTFITTER_DOCUMENT_DISABLED:
        "Please update the document to remove the associated listings and or pricing packages and then delete",
    DELETE_OUTFITTER_DOCUMENT_WARNING:
        "Are you sure you want to delete this outfitter document? This action cannot be undone.",
    EDIT_ASSIGNED_PRICING_PACKAGES: "Edit assigned pricing packages",
    EDIT_ASSIGNED_LISTINGS: "Edit assigned listings",
    NO_ADDONS_INCLUDED: "No add-ons included",
    INCLUDED_ADD_ONS: "Included add-ons",
    ASSOCIATED_ITEM: "associated item",
    ATV: "ATV",
    GEAR: "Gear",
    UPDATE_RESOURCE_SUCCESS: "Successfully updated resource!",
    GENERIC_RESOURCE: "Generic Resource",
    NO_RESOURCES: "No resources",
    SELECT_OPTIONS: "Select options...",
    RESOURCES_SELECTED: "Resources selected",
    DAYS_BEFORE_TRIP_HELPER:
        "This value determines when payment plans are no longer available to the customer based on the number of days between the booking date and the trip's start date.",
    DAYS_BEFORE_BALANCE_DUE_HELPER:
        "Set a specific date when final payments must be processed. This is commonly used by outfitters who need to collect all payments before their season starts.",
    DEPOSIT_FOR_TRIP: "Deposit for trip",
    PER_GUEST: "per guest",
    DEPOSIT: "Deposit",
    LAST_DAY_OF_TRIP: "Last day of trip",
    ICON_URL: "Icon URL",
    CREATE_AMENITY_SUCCESS: "Successfully created amenity!",
    UPDATE_AMENITY_SUCCESS: "Successfully updated amenity!",
    UNITED_STATES_LICENSES: "United States Licenses",
    UNITED_STATES: "United States",
    CANADA: "Canada",
    GENERAL_INFORMATION_URL: "General information URL",
    LINK_TO: "Link to",
    GENERAL_LICENSE_INFO_PAGE: "General license info page",
    HUNTING_INFORMATION_URL: "Hunting information URL",
    HUNTING_LICENSE_INFO_PAGE: "Hunting license info page",
    FISHING_INFORMATION_URL: "Fishing information URL",
    FISHING_LICENSE_INFO_PAGE: "Fishing license info page",
    ONLINE_PORTAL_URL: "Online portal URL",
    LICENSE_PURCHASE_PORTAL: "License purchase portal",
    LICENSE_INFO_UPDATED: "License info updated",
    OUTDOORS_LICENSE_INFO: "Outdoors license info",
    UPDATE_LICENSE_SUCCESS: "Successfully updated license!",
    CREATE_SPECIES_SUCCESS: "Successfully created species!",
    UPDATE_SPECIES_SUCCESS: "Successfully updated species!",
    PAYMENT_METHOD_CAPITALIZED: "Payment Method",
    BACK_TO_DASHBOARD: "Back to Dashboard",
    GO_TO_SELF_ONBOARD_TITLE: "Outfitter Self Onboarding",
    GO_TO_SELF_ONBOARD_SUBTITLE:
        "If you want to go through the self onboarding process you can do that here",
    GO_TO_SELF_ONBOARD: "Go to Self Onboard",
    INVALID_PAYMENT_METHOD: "Invalid payment method",
    CONTACTS_PREVIEW: "Contacts Preview",
    CONTACTS: "Contacts",
    CONTACT_LISTS: "Contact Lists",
    IMPORTS: "Imports",
    SENT_BLASTS: "Sent Blasts",
    CONTACT_LIST: "contact list",
    CONTACT_LISTS_TABLE: {
        NAME: "Name",
        SIZE: "Size",
        TYPE: "Type",
        MANUAL: "Manual",
        FILTERS: "Filters",
        SYSTEM: "System",
    },
    BULK_IMPORTS_TABLE: {
        STARTED: "Started",
        STATUS: "Status",
        PROGRESS: "Progress",
        SUCCESSFUL: "Successful",
        FAILED: "Failed",
    },
    BULK_IMPORT_PROGRESS_MODAL: {
        TITLE: "Import Progress",
        COMPLETE_TITLE: "Import complete",
        COMPLETED_WITH_ERRORS_TITLE: "Import completed with errors",
        FAILED_TITLE: "Import failed",
        STATUS_TITLE_SUFFIX: "import",
        PROCESSED: "processed",
        RAN_FOR: "Ran for",
        RUNNING_FOR: "Running for",
        RUNNING_IN_BACKGROUND:
            "This import will keep running in the background. You can safely close this progress modal.",
        DETAILS_TITLE: "Import details",
        SUCCESSFUL: "Successful",
        FAILED: "Failed",
        REMAINING: "Remaining",
        ROW: "row",
        ERROR: "error",
        FOUND: "found.",
    },
    BOOKING_IMPORT: {
        SELECT_STEP_TITLE: "Import Bookings",
        SELECT_STEP_DESCRIPTION:
            "Pick the listing and pricing package to apply to every booking in your file. Then upload a CSV with one row per trip.",
        MISSING_EMAIL: "Email is required.",
        INVALID_START_DATE:
            "Start date is missing or invalid (use YYYY-MM-DD).",
        INVALID_END_DATE: "End date is missing or invalid (use YYYY-MM-DD).",
        END_BEFORE_START: "End date must be on or after the start date.",
        INVALID_NUMBER_OF_GUESTS:
            "Number of guests must be a whole number greater than zero.",
        SUBMIT_FAILED:
            "Something went wrong importing your bookings. Please try again.",
    },
    IMPORT_ROW_ERRORS: {
        ROW_LABEL: "Row",
        VALIDATION_TITLE: "Fix these rows, then re-upload your file:",
        ASYNC_FAILURE_TITLE: "These rows could not be imported:",
        FIX_AND_REUPLOAD: "Fix and re-upload",
    },
    BULK_SEND_PROGRESS_MODAL: {
        TITLE: "Send Progress",
        COMPLETE_TITLE: "Send complete",
        COMPLETED_WITH_ERRORS_TITLE: "Send completed with errors",
        FAILED_TITLE: "Send failed",
        STATUS_TITLE_SUFFIX: "send",
        PROCESSED: "sent",
        RUNNING_IN_BACKGROUND:
            "This send will keep running in the background. You can safely close this progress modal.",
        DETAILS_TITLE: "Send details",
    },
    CONTACTS_TABLE: {
        NAME: "Name",
        NAME_EMAIL: "Name/Email",
        EMAIL: "Email",
        STAGE: "Stage",
        PHONE_NUMBER: PHONE_NUMBER_LABEL,
        SOURCE: "Source",
        PRIOR_BOOKINGS: "Prior Bookings",
        GROSS_SALES: "Gross Sales",
        MOST_RECENT_TRIP_START_DATE: "Most Recent Trip Start Date",
        DATE_ADDED: "Date Added",
    },
    CONTACT_STAGE_FILTER: {
        ALL: "All",
        LEAD: "Lead",
        CLIENT: "Client",
        UNASSIGNED: "Unassigned",
    },
    LEADS_TABLE: {
        NAME: "Name",
        SOURCE: "Source",
        EMAIL: "Email",
        PHONE_NUMBER: PHONE_NUMBER_LABEL,
        PRIOR_BOOKINGS: "Prior Bookings",
        GROSS_SALES: "Gross Sales",
        DATE_ADDED: "Date Added",
    },
    OUTFITTER_CUSTOM_PROPERTIES_TABLE: {
        PROPERTY_NAME: "Property Name",
        PROPERTY_TYPE: "Property Type",
        DESCRIPTION: "Description",
    },
    META_ADS_TABLE: {
        AD_NAME: "Ad Name",
        CAMPAIGN_NAME: "Campaign Name",
        STATUS: "Status",
        OBJECTIVE: "Objective",
        IMPRESSIONS: "Impressions",
        REACH: "Reach",
        CLICKS: "Clicks",
        SPEND: "Spend",
        CTR: "CTR",
        CPM: "CPM",
        CPC: "CPC",
    },
    CONTACT_SEARCH_PLACEHOLDER: "Search by name, phone, email",
    CONTACT_LISTS_SEARCH_PLACEHOLDER: "Search lists",
    BOOKING_SEARCH_PLACEHOLDER: "Search bookings",
    MOST_RECENT_TRIP_DATE: "Most recent trip date",
    DATE_ADDED: "Date added",
    CONTACT_DETAILS: "Contact details",
    GROSS_SALES_ALL_TIME: "Gross Sales (All Time)",
    GROSS_SALES_PAST_YEAR: "Gross Sales (Past Year)",
    CONTACT_PRIOR_TRIPS_TABLE: {
        LISTING_PACKAGE: "Listing / Package",
        TRIP_DATES: "Trip Dates",
        AMOUNT: "Amount",
        BOOKING_DATE: "Booking Date",
        TRIP_STATUS: "Trip Status",
    },
    CONTACT_LEADS_TABLE: {
        CONTACT_INFO: "Contact Info",
        PHONE: "Phone",
        CREATED_DATE: "Created Date",
        STATUS: "Status",
    },
    PRIOR_TRIP_DETAILS: "Prior trip details",
    WRITE_YOUR_NOTES_HERE: "Write your notes here...",
    QUOTES_SENT: "Quotes Sent",
    QUOTES_REQUESTS: "Quotes Requests",
    QUOTE_SEARCH_PLACEHOLDER: "Search quotes",
    QUOTE_REQUEST_SEARCH_PLACEHOLDER: "Search quote requests",
    REQUEST_DETAILS: "Request Details",
    CONVERT_TO_QUOTE: "Convert to Quote",
    PREFERRED_DATES: "Preferred Dates",
    FROM: "From",
    TO: "To",
    PREFERRED_CONTACT: "Preferred Contact",
    LEARN_MORE: "Learn more",
    HOW_DOES_CONTACT_WANT_TO_PAY: "How is the contact paying for this trip?",
    DUE_ON: "Due on",
    DUE_AFTER_CONFIRMATION: "Due after booking confirmation",
    ERROR_CREATING_BOOKING:
        "Unable to create booking please refresh and try again",
    NOTE_FROM_CONTACT: "Note from contact",
    OUTFITTER_GROUP_PAY_TITLE: "Would the contact like to use group payment?",
    OUTFITTER_GROUP_PAY_SUBTITLE:
        "Group payment allows the contact to split the total cost of the booking with other guests",
    OUTFITTER_HOW_MANY_GUESTS:
        "How many guests would the contact like to pay for?",
    CONTACT_PAY_ENTIRE_COST:
        "Have the contact pay for the entire cost of the booking",
    INVITE_OTHERS_TO_SHARE_COST:
        "Allow the contact to invite others to share the cost of the booking",
    REMAINING_SLOTS: "Remaining slots",
    HOW_IT_WORKS: "How it works",
    GROUP_PAY_NOTE_ONE:
        "The contact will be required to pay for at least one slot",
    GROUP_PAY_NOTE_TWO:
        "The remaining slots can be claimed and paid for by new members joining the contact's group",
    GROUP_PAY_NOTE_THREE:
        "A group pay joining link will be provided after the booking request is made",
    GROUP_PAY_NOTE_FOUR:
        "If there are slots unclaimed, the contact will be charged for the remaining amount before the trip starts, on the last payment due date",
    ONLINE_PAYMENT: "Online Payment",
    NO_CONTACTS: "No Contacts",
    NO_CONTACT_LISTS: "No Contact Lists",
    NO_IMPORTS: "No imports yet",
    NO_SENT_BLASTS: "No blasts sent yet",
    SAVED: "Saved",
    MOST_RECENT_TRIP_START_DATE: "Most Recent Trip Start Date",
    DISCOUNT_LABEL: "Discount: ",
    RESET_DATES: "Reset Dates",
    EMAIL_IS_RECOMMENDED:
        "We recommend including an email address so contacts can receive their booking receipts.",
    EMPTY_FIELD: "-",
    LEADS: "Leads",
    LEAD: "lead",
    LEAD_CAPITALIZED: "Lead",
    INTEGRATIONS: "Integrations",
    TOGGLE_SUBMENU: "Toggle submenu",
    FEATURED: "Featured",
    NOT_FEATURED: "Not Featured",
    STATE_SAVING: "Saving...",
    CUSTOM_CODE: "Custom Code",
    DISCOUNT_TYPE: "Discount Type",
    DISCOUNT_AMOUNT: "Discount Amount",
    COUPON_EXPIRATION_DATE_PLACEHOLDER: "Select an expiration date",
    PERCENT_OFF: "Percent Off (%)",
    AMOUNT_OFF: "Amount Off ($)",
    ADD_COUPON_FOR: "Add Coupon For",
    ADDITIONAL_PAYMENTS_ALERT_TITLE: "Additional booking payments",
    ADDITIONAL_PAYMENTS_ALERT_DESCRIPTION:
        "This booking includes additional payments that won't automatically update if you change the dates or number of guests. If needed, you'll need to adjust those payments separately.",
    QUICK_BOOKS: {
        LABEL: "QuickBooks",
        DESCRIPTION:
            "Connect QuickBooks to automate invoicing and track finances with ease",
        CTA_LABEL: "Connect to QuickBooks",
        CTA_LABEL_RECONNECT: "Reconnect and sync data",
        CTA_HEADER: "Seamlessly Sync with QuickBooks Online",
        CTA_DETAILS:
            "If you use QuickBooks Online for your accounting, Mallard Bay makes it easy to keep everything in sync. Our platform offers a smooth connection with QuickBooks Online so your financials stay up to date without the hassle. Want to see how it works? Check out our knowledge base for all the details.",
        CONNECTION_SUCCESSFUL: "QuickBooks connected!",
        ACTION_BANNER_TITLE: "Connect Your QuickBooks Account to MallardBay",
        ACTION_BANNER_DESCRIPTION:
            "Easily sync your financial data for smoother tracking and reporting.",
        ACCOUNT_DETAILS: "Account Details",
        GENERAL_SETTINGS: "General Settings",
        CLASS_MAPPINGS: "Class Mappings",
        PRODUCT_AND_SERVICE_MAPPINGS: "Product and Service Mappings",
        ACCOUNT_DETAILS_HEADER: "QuickBooks Account Details",
        COMPANY_NAME: "Company Name",
        CONNECTED_USER: "Connected User",
        INTEGRATION_STATUS: "Integration Status",
        GO_TO_QUICK_BOOKS: "Go to QuickBooks",
        ACTIVE_STATUS: "Active",
        INVOICE_DATE: "Invoice Date",
        INVOICE_DATE_SUB_LABEL:
            "Select which timestamp you would like to use as your invoice date",
        SELECT_A_TIMESTAMP: "Select a timestamp",
        UPDATED_SETTING: "Successfully updated setting!",
        DEPOSIT_SETTINGS: "Deposit Settings",
        DEPOSIT_ACCOUNT: "Deposit Account",
        DEPOSIT_ACCOUNT_SUB_LABEL:
            "Select which account the funds are being sent to",
        SELECT_AN_ACCOUNT: "Select an account",
        CLASS: "QuickBooks Class",
        SELECT_CLASS: "Select class",
        SUCCESSFULLY_UPDATED_CLASS_MAPPING:
            "Successfully updated the class mapping!",
        SUCCESSFULLY_UPDATED_ITEM_MAPPING:
            "Successfully updated the product or service mapping!",
        NO_CLASSES_HEADER: "No QuickBooks classes defined",
        NO_CLASSES_MESSAGE:
            "There are no classes defined in the linked QuickBooks account. Please add classes in your QuickBooks account if you wish to set up mappings.",
        NO_ITEMS_HEADER: "No QuickBooks products and services defined",
        NO_ITEMS_MESSAGE:
            "There are no products and services items defined in the linked QuickBooks account. Please add items in your QuickBooks account if you wish to set up mappings.",
        ITEM_MAPPING_OPTION_1:
            "Use the same product or service, in QuickBooks, for all Mallard Bay pricing packages and add-ons",
        ITEM_MAPPING_OPTION_2:
            "Use a different product or service, in QuickBooks, for all Mallard Bay pricing packages and add-ons",
        SELECT_ITEM: "Select product or service",
        DEFAULT_PRODUCT_OR_SERVICE: "Default product or service",
        RECONNECT_TITLE: "Your QuickBooks account needs to be reconnected",
        RECONNECT_MESSAGE:
            "You may need to manually sync data that was not synced while it was disconnected.",
        QUICK_PAY_MESSAGE:
            "Name and Email are required for quick pay transactions to be synced to QuickBooks",
        ACCOUNT_DETAILS_KNOWLEDGE_BASE_TITLE:
            "Having trouble syncing your data to QuickBooks?",
        ACCOUNT_DETAILS_KNOWLEDGE_BASE_DESCRIPTION:
            "Our knowledge base walks you through the syncing process.",
        GENERAL_SETTINGS_KNOWLEDGE_BASE_TITLE:
            "Need help setting up QuickBooks?",
        GENERAL_SETTINGS_KNOWLEDGE_BASE_DESCRIPTION:
            "Check out our knowledge base for step-by-step guidance on setting up your connection and simplifying your accounting.",
        CLASS_MAPPINGS_KNOWLEDGE_BASE_TITLE:
            "Need help mapping your QuickBooks class to your listing?",
        CLASS_MAPPINGS_KNOWLEDGE_BASE_DESCRIPTION:
            "Explore our knowledge base to learn how.",
        ITEM_MAPPINGS_KNOWLEDGE_BASE_TITLE:
            "Unsure how to map your QuickBooks products and services to Mallard Bay?",
        ITEM_MAPPINGS_KNOWLEDGE_BASE_DESCRIPTION:
            "Visit our knowledge base for a step-by-step guide.",
        DISCONNECT_SUCCESS: "QuickBooks disconnected successfully!",
        DISCONNECT_CONFIRMATION_TITLE: "Disconnect QuickBooks?",
        DISCONNECT_CONFIRMATION_MESSAGE:
            "Are you sure you want to disconnect your QuickBooks account? Payments and bookings will no longer be synced to QuickBooks.",
    },
    NO_LEADS: "No leads",
    NO_OUTFITTER_CUSTOM_PROPERTIES: "No custom properties",
    OUTFITTER_CUSTOM_PROPERTIES_SEARCH_PLACEHOLDER: "Search by label",
    LEAD_SEARCH_PLACEHOLDER: "Search by name, phone, email",
    FORM_SEARCH_PLACEHOLDER: "Search by name",
    ADD_NEW_LEAD: "Add New Lead",
    LEAD_DETAILS: "Lead Details",
    LEAD_FORM_LABELS: {
        NAME: "Name",
        EMAIL: "Email",
        PHONE: "Phone",
        ADDRESS: "Address",
        TRIP_AMOUNT: "Trip Amount",
        GROUP_SIZE: "Group Size",
        NOTE: "Note",
        STATUS: "Status",
        QUALITY: "Quality",
        REFERRAL_SOURCE: "Referral Source",
        FIRST_NAME: "First Name",
        LAST_NAME: "Last Name",
        BRIEF_DESCRIPTION: "Brief Description",
    },
    LEAD_FORM_PLACEHOLDERS: {
        BRIEF_DESCRIPTION: "Enter a brief description",
        EMAIL: "Enter email",
        PHONE: "Enter phone number",
        ADDRESS: "Enter address",
        TRIP_AMOUNT: "Enter trip amount",
        GROUP_SIZE: "Enter group size",
        NOTE: "Write your notes here...",
        FIRST_NAME: "Enter first name",
        LAST_NAME: "Enter last name",
    },
    OTHER_DETAILS: "Other Details",
    REFERRAL_SOURCE_LABELS: {
        NONE: "None",
        AD: "Ad",
        BOOKING_AGENT: "Booking Agent",
        CUSTOMER_REFERRAL: "Customer Referral",
        GOOGLE: "Google",
        TRADE_SHOW: "Trade Show",
        WEBSITE: "Website",
        WORD_OF_MOUTH: "Word of Mouth",
    },
    SAVE_LEAD: "Save Lead",
    CREATE_LEAD_SUCCESS: "Lead created successfully",
    SELECT_AN_OPTION: "Select an option...",
    ASSOCIATE_LEAD_TO: "Associate Lead to",
    IF_YOU_DO_NOT_SELECT_A_CONTACT:
        "If you do not select a contact to associate, we will create a new contact for you.",
    SELECT_A_CONTACT: "Select a contact",
    SMART_SCHEDULING_TITLE:
        "Smarter Scheduling with AI. Update your availability, effortlessly.",
    SMART_SCHEDULING_BUTTON_LABEL: "Smart Schedule with AI",
    SMART_SCHEDULING_RESOURCE_SELECTOR_TITLE: "You've selected Listing",
    SMART_SCHEDULING_RESOURCE_SELECTOR_MESSAGE:
        "Now, pick the specific listing you want to schedule. This ensures availability is managed accurately for that resource.",
    SMART_SCHEDULING_RESOURCE_TYPE_SELECTOR_TITLE: "Select a Resource",
    SMART_SCHEDULING_RESOURCE_TYPE_SELECTOR_MESSAGE:
        "Pick one resource to schedule. This helps us tailor availability and keep everything perfectly in sync.",
    SMART_SCHEDULE_WITH_AI: "Smart Schedule with AI",
    AI_AVAILABILITY: "AI Availability",
    SMART_SCHEDULING_CHAT_INSTRUCTIONS:
        "Now, let me know what you'd like to do next—whether it's setting your available dates or blocking-off dates.",
    YOU_SELECTED: "You've selected",
    AI_CHAT_PLACEHOLDER: "Enter your request...",
    AI_CHAT_ERROR_FALLBACK:
        "Something went wrong. Try again or send a new message.",
    AI_CHAT_RETRY: "Try again",
    AI_CHAT_DEBUG_UNHANDLED_PART_LABEL: "Unhandled chat part",
    AI_CHAT_TOOL_CALL_RUNNING: "Running",
    AI_CHAT_TOOL_CALL_DONE: "Done",
    AI_CHAT_TOOL_CALL_WAITING_APPROVAL: "Waiting for approval",
    AI_CHAT_TOOL_CALL_APPROVED: "Approved",
    AI_CHAT_TOOL_CALL_DENIED: "Declined",
    AI_CHAT_TOOL_CALL_FAILED: "Something went wrong running this step.",
    AI_CHAT_TOOL_CLIENT_NOT_IMPLEMENTED:
        "This assistant step is not implemented in the dashboard client yet",
    AI_CHAT_TOOL_NAVIGATE_RUNNING: "Opening",
    AI_CHAT_TOOL_NAVIGATE_DONE: "Opened",
    AI_CHAT_TOOL_NAVIGATE_FALLBACK_DESTINATION: "destination",
    AI_CHAT_TOOL_CREATE_MESSAGE_TEMPLATE_RUNNING: "Creating message template",
    AI_CHAT_TOOL_CREATE_MESSAGE_TEMPLATE_DONE: "Message template created",
    AI_CHAT_TOOL_EMAIL_TEMPLATE_RUNNING: "Updating email template",
    AI_CHAT_TOOL_EMAIL_TEMPLATE_DONE: "Email template updated",
    AI_CHAT_TOOL_OUTFITTER_FORM_PREPARE_RUNNING: "Preparing outfitter form",
    AI_CHAT_TOOL_OUTFITTER_FORM_PREPARE_DONE: "Outfitter form draft ready",
    AI_CHAT_TOOL_CONTACT_IMPORT_PREPARE_RUNNING: "Preparing contact import",
    AI_CHAT_TOOL_CONTACT_IMPORT_PREPARE_DONE: "Contact import ready",
    AI_CHAT_TOOL_CONTACT_IMPORT_EXECUTE_RUNNING: "Starting contact import",
    AI_CHAT_TOOL_CONTACT_IMPORT_EXECUTE_DONE: "Contact import started",
    AI_CHAT_TOOL_REQUEST_SELECTION_RUNNING: "Preparing choices",
    AI_CHAT_TOOL_REQUEST_SELECTION_DONE: "Choices ready",
    AI_CHAT_TOOL_PRESENT_CHART_RUNNING: "Loading chart",
    AI_CHAT_TOOL_PRESENT_CHART_DONE: "Chart ready",
    AI_CHAT_TOOL_PRESENT_PLAN_RUNNING: "Drafting plan",
    AI_CHAT_TOOL_PRESENT_PLAN_DONE: "Plan ready",
    AI_CHAT_TOOL_PLAN_CURRENT_STEP: "Your turn",
    AI_CHAT_TOOL_PLAN_CONTINUE: "Start this step",
    AI_CHAT_TOOL_PLAN_CONTINUE_MESSAGE_PREFIX: "Let's continue with",
    AI_CHAT_TOOL_PLAN_STATUS_COMPLETED: "Completed",
    AI_CHAT_TOOL_PLAN_STATUS_IN_PROGRESS: "Current step",
    AI_CHAT_TOOL_PLAN_STATUS_PENDING: "Pending",
    AI_CHAT_USER_SELECTION_SUBMIT: "Send selection",
    AI_CHAT_TOOL_OUTFITTER_FORM_PREPARE_INVALID:
        "Assistant returned an outfitter form draft the dashboard could not apply",
    AI_CHAT_SOURCE_LABEL: "Source",
    AI_CHAT_SOURCE_DOCUMENT_FALLBACK_TITLE: "Document",
    AI_CHAT_FILE_DOWNLOAD_LABEL: "Download attachment",
    AI_CHAT_ATTACH_ARIA: "Attach image, PDF, or CSV",
    AI_CHAT_REMOVE_ATTACHMENT_ARIA: "Remove attachment",
    AI_CHAT_UNSUPPORTED_ATTACHMENT:
        "Only images, PDF files, and CSV files are supported.",
    AI_CHAT_ATTACHMENT_UPLOAD_FAILED:
        "Failed to upload attachment. Please try again.",
    OUTFITTER_ASSISTANT_TITLE: "Assistant",
    OUTFITTER_ASSISTANT_NAME: "Susie AI",
    OUTFITTER_ASSISTANT_EMPTY_STATE_TITLE: "Hi! I'm Susie",
    OUTFITTER_ASSISTANT_EMPTY_STATE:
        "Your Mallard Bay Dashboard assistant. Ask me anything - from managing bookings to finding client details and more.",
    OUTFITTER_ASSISTANT_QUICK_SUGGESTIONS_LABEL: "Quick Suggestions:",
    OUTFITTER_ASSISTANT_INPUT_PLACEHOLDER: "Ask anything...",
    OUTFITTER_ASSISTANT_DRAG_HANDLE_ARIA: "Drag assistant sheet",
    OUTFITTER_ASSISTANT_CLOSE_ARIA: "Close assistant",
    OUTFITTER_ASSISTANT_HISTORY_TITLE: "History",
    OUTFITTER_ASSISTANT_HISTORY_ARIA: "View assistant history",
    OUTFITTER_ASSISTANT_HISTORY_BACK_ARIA: "Back to assistant chat",
    OUTFITTER_ASSISTANT_HISTORY_EMPTY: "No saved chats yet",
    OUTFITTER_ASSISTANT_HISTORY_UNTITLED: "Untitled chat",
    OUTFITTER_ASSISTANT_HISTORY_LOAD_MORE: "Load more chats",
    OUTFITTER_ASSISTANT_HISTORY_NEW_CONVERSATION: "Start a new conversation",
    OUTFITTER_ASSISTANT_OPEN_ARIA: "Open assistant",
    OUTFITTER_ASSISTANT_PAGE_HELP_ARIA: "Open assistant for this page",
    OUTFITTER_ASSISTANT_SUPPORT_PROMPT:
        "I have a question for Mallard Bay support. Please help me find the answer.",
    PREVIEW_CHANGES: "Preview Changes",
    REJECT: "Reject",
    START_OVER: "Start Over",
    GROUP_SIZE: "Group Size",
    NUMBER_OF_PRIOR_BOOKINGS: "Number of Prior Bookings",
    COMMENTS: "Comments",
    WRITE_YOUR_COMMENT_HERE: "Write your comment here...",
    NO_COMMENTS: "No comments",
    SEND: "Send",
    LEAD_QUALITY: "Lead Quality",
    QUALITY: "Quality",
    REFERRAL_SOURCE: "Referral Source",
    SELECT_LEAD_QUALITY: "Select lead quality",
    SELECT_REFERRAL_SOURCE: "Select referral source",
    SELECT_STATUS: "Select status",
    LEAD_UPDATE_SUCCESS: "Lead updated successfully",
    DISQUALIFY_LEAD: "Disqualify Lead",
    SELECT_REASON_FOR_DISQUALIFICATION: "Select reason for disqualification",
    DONE: "Done",
    SELECT_A_FOLLOW_UP_DATE_FOR_THIS_LEAD:
        "Select a follow-up date for this lead.",
    LEAD_DISQUALIFIED: "Lead Disqualified",
    THIS_LEAD_HAS_BEEN_MARKED_AS_DISQUALIFIED:
        "This lead has been marked as disqualified for the reason(s) selected:",
    THIS_LEAD_HAS_BEEN_MARKED_AS_DISQUALIFIED_WITH_NO_REASON:
        "This lead has been marked as disqualified.",
    YOU_CAN_UPDATE_OR_REVIEW_THE_REASON_ANYTIME:
        "You can update or review the reason anytime.",
    REQUALIFY_LEAD: "Requalify Lead",
    EDIT_LEAD_DISQUALIFICATION: "Edit Lead Disqualification",
    FOUND: "found",
    ABOUT: "About",
    SKIP_LEADS_THAT_ALREADY_EXIST:
        "When selected, we'll automatically check for duplicate leads (based on email and phone number) uploaded within the past 30 days and skip creating new ones.",
    VS_LAST_PERIOD: "vs. last period",
    EDIT_ABOUT: "Edit About",
    EDIT_WITH_AI: "Edit with AI",
    EDIT_DESCRIPTION: "Edit Description",
    EDIT_GEAR_LIST: "Edit Gear List",
    NO_GEAR_LIST_YET: "No gear list yet",
    RICH_TEXT_AI_BANNER_TITLE: "Get a smart, ready-to-edit draft in seconds.",
    RICH_TEXT_AI_BANNER_BUTTON_LABEL: "Generate with AI",
    CREATE_NEW_LEAD: "Create New Lead",
    ADD_A_LISTING: "Add a listing",
    BACK_TO_STANDARD_EDITOR: "Back to standard editor",
    VIEW_CONTACT_DETAILS: "View Contact Details",
    VIEW_CONTACT_LIST: "View Contact List",
    LISTING_AI_CHAT_INSTRUCTIONS:
        "Share details about your business, and we'll combine what you provide with your existing listing and outfitter data to generate an optimized description. If you already have a description, let us know what you'd like to change—even if it's just to refine the copy—and we'll deliver a revised draft.",
    OUTFITTER_AI_CHAT_INSTRUCTIONS:
        "Share details about your business, and we'll combine what you provide with your existing outfitter data to generate an optimized description. If you already have a description, let us know what you'd like to change—even if it's just to refine the copy—and we'll deliver a revised draft.",
    SINGLE_USE_PER_TIME_SLOT: "Single-use per time slot",
    SINGLE_USE_PER_TIME_SLOT_HELPER_TEXT: `By default, a resource can be booked by multiple trips until it reaches full capacity. If you'd prefer to make a resource unavailable as soon as a trip is booked for a given date—regardless of remaining capacity—you can enable the "single-use per time slot" option.`,
    META_REPORTING_KNOWLEDGE: {
        TITLE: "Need help understanding your web performance?",
        DESCRIPTION:
            "Discover insights, solutions, and tips to help optimize your website's speed, reliability, and overall performance.",
    },
    META_ADS_KNOWLEDGE: {
        TITLE: "Need help promoting your listing faster?",
        DESCRIPTION:
            "Quickly create and publish Facebook ads to boost visibility and bookings — all from your dashboard.",
    },
    CALENDAR_INTEGRATION_DESCRIPTION:
        "Import or export calendar data to sync availability across platforms.",
    CALENDAR_EXPORTS_KNOWLEDGE: {
        TITLE: "Sync Your Calendar Seamlessly",
        DESCRIPTION:
            "Sync your trips and resources with your personal calendar or preferred third-party tool.",
    },
    CALENDAR_IMPORTS_KNOWLEDGE: {
        TITLE: "Sync Your Calendar Seamlessly",
        DESCRIPTION:
            "Import availability from your personal calendar, Airbnb, Vrbo & more to auto-block dates on Mallard Bay and prevent double bookings.",
    },
    EXPORT_A_CALENDAR: "Export a Calendar",
    EXPORT_A_CALENDAR_DESCRIPTION:
        "Export your trips and resource availability to your personal calendar or to online travel agencies (OTAs) like Airbnb or Vrbo.",
    IMPORT_A_CALENDAR: "Import a Calendar",
    IMPORT_A_CALENDAR_DESCRIPTION:
        "Import your availability from personal calendars and online travel agencies (OTAs) like Airbnb or Vrbo. Block off dates on Mallard Bay automatically to avoid double bookings.",
    IMPORT_CALENDAR: "Import Calendar",
    ALL_RESOURCES: "All resources",
    SELECT_ALL: "Select All",
    SELECT_RESOURCES_LABEL:
        "Select the listing or Resources you want to track.",
    CALENDAR_SUBSCRIPTION_CREATED:
        "Calendar subscription created successfully!",
    CALENDAR_SUBSCRIPTION_UPDATED:
        "Calendar subscription updated successfully!",
    CALENDAR_SUBSCRIPTION_DELETED:
        "Calendar subscription deleted successfully!",
    CALENDAR_EVENT_UPDATED: "Calendar event updated successfully!",
    SYNCED_CALENDAR_CREATED: "Synced calendar created successfully!",
    SYNCED_CALENDAR_UPDATED: "Synced calendar updated successfully!",
    SYNCED_CALENDAR_ARCHIVED: "Synced calendar archived successfully!",
    MESSAGE_TEMPLATE_CREATED: "Message template created successfully!",
    MESSAGE_TEMPLATE_UPDATED: "Message template updated successfully!",
    MESSAGE_TEMPLATE_DELETED: "Message template deleted successfully!",
    MESSAGE_TEMPLATE_DUPLICATED: "Message template duplicated successfully!",
    MESSAGE_TEMPLATE_RESTORED_TO_DEFAULT:
        "Message template restored to default successfully!",
    MESSAGE_TEMPLATE_NAME_LABEL: "Template name",
    MESSAGE_TEMPLATE_CREATED_LABEL: "Created",
    MESSAGE_TEMPLATE_SEND_LOGS_TAB: "Send Logs",
    MESSAGE_TEMPLATE_SCHEDULED_MESSAGES_TAB: "Scheduled Messages",
    MESSAGE_TEMPLATE_SCHEDULED_FOR_LABEL: "Scheduled for",
    MESSAGE_TEMPLATE_PREVIEW_COMING_SOON: "Preview coming soon",
    MESSAGE_TEMPLATE_PREVIEW_FAILED: "Failed to load preview.",
    SEND_TEST: "Send test",
    SEND_TEST_EMAIL_TITLE: "Send test email",
    SEND_TEST_EMAIL_DESCRIPTION:
        "Send a preview of this template to an email address using mock recipient data.",
    SEND_TEST_EMAIL_PLACEHOLDER: "Enter email address",
    TEST_EMAIL_SENT: getTestEmailSentMessage,
    MESSAGE_TEMPLATE_SEND_LOGS_COMING_SOON: "Send logs will appear here.",
    MESSAGE_TEMPLATE_SCHEDULED_MESSAGES_COMING_SOON:
        "Scheduled messages will appear here.",
    MESSAGE_SENT: "Message sent successfully!",
    SEND_NOW: "Send now",
    SEND_TIMING: "Send timing",
    SCHEDULE_FOR_LATER: "Schedule for later",
    SCHEDULE_SEND: "Schedule send",
    SCHEDULED_SEND_DATE: "Send date",
    SCHEDULED_SEND_TIME: "Send time",
    SCHEDULED_SEND_MUST_BE_FUTURE: "Scheduled send time must be in the future.",
    MESSAGE_SCHEDULED: "Message scheduled successfully!",
    BULK_MESSAGE_SCHEDULED: "Bulk message scheduled successfully!",
    BULK_EMAIL_QUEUED: "Bulk email queued successfully!",
    BULK_SMS_QUEUED: "Bulk SMS queued successfully!",
    WEBSITE_UPDATED: "Website updated successfully!",
    WEBSITE_PUBLISHED: "Website published successfully!",
    ARCHIVE_SYNCED_CALENDAR: "Archive Calendar",
    ARCHIVE_SYNCED_CALENDAR_CONFIRMATION_MESSAGE:
        "Are you sure you want to archive this calendar? Events already imported will remain, but no new events will be synced.",
    DELETE_CALENDAR_SUBSCRIPTION: "Delete Calendar Subscription",
    DELETE_CALENDAR_SUBSCRIPTION_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this calendar subscription? Existing synced events will remain, but the calendar will no longer receive updates.",
    SOURCE: "Source",
    LINK: "Link",
    SYNCED_CALENDAR_ACTIONS: {
        VIEW_DETAILS: "View Details",
        EDIT_RULES: "Edit Rules",
        ARCHIVE: "Archive",
    },
    CREATE_NEW_IMPORT_RULE: "Create New Import Rule",
    EDIT_RULES: "Edit Rules",
    LISTINGS_TO_UPDATE: "Listings to Update",
    LODGINGS_TO_UPDATE: "Lodgings to Update",
    RESOURCES_TO_UPDATE: "Resources to Update",
    SOURCE_PLACEHOLDER: "ie iCal, Google Calendar, Outlook, Airbnb, Vrbo",
    LINK_PLACEHOLDER: "Add link",
    LINK_HELPER_TEXT: "Must be ICS format (.ics)",
    LINK_INPUT_PREFIX: "https://",
    AVAILABILITY_CONFIG: "Availability Config",
    REMOVE_ALL_AVAILABILITY: "Remove all availability",
    SET_A_DEFAULT_NUMBER_OF_SLOTS_TO_REMOVE:
        "Set a default number of slots to remove",
    DEFAULT_SLOTS_TO_REMOVE: "Default slots to remove",
    VIEW_IMPORT_RULE: "View Import Rule",
    NO_AVAILABILITY_CHANGES: "No availability changes",
    EVENT: "Event",
    GUIDED_BY: "Guided by",
    EDIT_CALENDAR_EVENT: "Edit Calendar Event",
    TITLE: "Title",
    SUBTITLE: "Subtitle",
    ONE_RESOURCE_REQUIRED: "At least one resource is required",
    START_DATE_BEFORE_END: "Start date/time must be before end date/time",
    QUOTE_REQUEST_BOOKING_INVITES_TABLE: {
        CONTACT: "Contact",
        LISTING: "Listing",
        NOTES: "Notes",
        DATES_AND_GUESTS: "Dates and Guests",
    },
    BOOKING_INVITES: "Booking Invites",
    NO_BOOKING_INVITES: "No booking invites",
    FORMS: "Forms",
    ADD_NEW_FORM: "Add New Form",
    BASICS: "Basics",
    FORM_DETAILS: "Form Details",
    CREATE_FORM: "Create Form",
    FORM_COPY: {
        ENTER_FORM_NAME: "Enter form name",
        FORM_DESCRIPTION_OR_NOTES: "Form description or notes",
        WOULD_YOU_LIKE_TO_ADD_THIS_FORM_TO_A_BOOKING:
            "Would you like to add this form to a booking?",
        CREATE_LEADS_FROM_FORM_SUBMISSIONS:
            "Do you want leads to be created from form submissions?",
        IS_FORM_REQUIRED: "Is this form required?",
        LISTINGS_AND_PRICING_PACKAGES: "Listings & Pricing Packages",
        LISTINGS_AND_PRICING_PACKAGES_DESCRIPTION:
            "Enable this option to attach the form to bookings. Once turned on, you can choose which listings and pricing packages it applies to.",
        CUSTOM_FIELDS: "Custom Fields",
        CUSTOM_FIELDS_DESCRIPTION:
            "Add custom fields to collect specific information tailored to your needs.",
        ENABLE_TO_AUTOMATICALLY_CREATE_LEADS_FROM_FORM_SUBMISSIONS:
            "Enable this to automatically create a new lead from each form submission.",
        SUCCESS_REDIRECT_URL: "Success Redirect URL",
        SUCCESS_REDIRECT_URL_DESCRIPTION:
            "Send contacts to this URL after they successfully submit the form.",
        SUCCESS_REDIRECT_URL_PLACEHOLDER: "https://www.example.com/thank-you",
        SUCCESS_REDIRECT_URL_ERROR:
            "Must be a valid URL starting with http:// or https://",
        IS_FORM_REQUIRED_DESCRIPTION:
            "This form will be shown as required on the contact trip details.",
    },
    TEXT: "Text",
    FIELD_NAME: "Field Name",
    FIELD_TYPE: "Field Type",
    CUSTOM_FIELDS: "Custom Fields",
    DOES_EACH_GROUP_MEMBER_NEED_TO_COMPLETE_THIS_FORM:
        "Does each group member need to complete this form?",
    ADD_CUSTOM_FIELD: "Add Custom Field",
    ENTER_FIELD_NAME: "Enter field name",
    REQUIRE_THIS_INPUT_FIELD: "Require this input field",
    ADD_FIELD: "Add Field",
    NO_FORMS: "No forms",
    TEXT_AREA: "Text Area",
    FIELD_NAME_REQUIRED: "Field name is required",
    FIELD_TYPE_REQUIRED: "Field type is required",
    SIGNATURE_REQUIRES_EMAIL:
        "Forms with signature inputs must also include an email input set to required.",
    FORM_CREATED_SUCCESSFULLY: "Form created successfully",
    FORM_UPDATED_SUCCESSFULLY: "Form updated successfully",
    PUBLISH: "Publish",
    SETTINGS: "Settings",
    BLOCKS: "Blocks",
    PAGES: "Pages",
    STYLE: "Style",
    DELETE_PAGE: "Delete Page",
    DELETE_PAGE_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this page?",
    ADD_NEW_PAGE: "Add New Page",
    EDIT_PAGE: "Edit Page",
    DUPLICATE_PAGE: "Duplicate Page",
    UNDO: "Undo",
    REDO: "Redo",
    IMAGE: "Image",
    NO_SETTINGS_AVAILABLE: "No settings available",
    NO_STYLING_AVAILABLE: "No styling available",
    DIMENSIONS: "Dimensions",
    MARGIN: "Margin",
    PADDING: "Padding",
    TYPOGRAPHY: "Typography",
    HEADING: "Heading",
    MEDIA: "Media",
    TARGET: "Target",
    THIS_WINDOW: "This window",
    NEW_WINDOW: "New window",
    NAVIGATION: "Navigation",
    EXTERNAL_LINK: "External Link",
    LINK_TO_PAGE: "Link to page",
    LAYOUT: "Layout",
    COLUMN: "Column",
    TWO_COLUMNS: "2 Columns",
    SIZE_LABELS: {
        X_LARGE: "X-Large",
        LARGE: "Large",
        MEDIUM: "Medium",
        SMALL: "Small",
        X_SMALL: "X-Small",
    },
    META: {
        LABEL: "Meta",
        DESCRIPTION: "Connect your Facebook and Instagram pages to MallardBay",
        CTA_LABEL: "Connect to Meta",
        CTA_HEADER: "Connect Your Business to Meta",
        CTA_DETAILS:
            "Connect your Facebook and Instagram pages to MallardBay to sync your leads and never miss out on any potential contacts.",
        CONNECTION_SUCCESSFUL: "Meta connected!",
        ACTION_BANNER_TITLE:
            "Connect Your Facebook and Instagram pages to MallardBay",
        ACTION_BANNER_DESCRIPTION:
            "Easily respond to leads and maximize bookings.",
        ACCOUNT_DETAILS_KNOWLEDGE_BASE_TITLE:
            "Having trouble syncing leads from Facebook and Instagram?",
        ACCOUNT_DETAILS_KNOWLEDGE_BASE_DESCRIPTION:
            "Our knowledge base walks you through the syncing process.",
        ACCOUNT_DETAILS_HEADER: "Meta Connection Details",
        RECONNECT_BUTTON_LABEL: "Reconnect",
        RECONNECT_BANNER_TITLE: "Reconnect Your Meta Account",
        RECONNECT_BANNER_DESCRIPTION:
            "One or more of your Meta connections has or is about to expire. Reconnect to continue syncing leads.",
        DISCONNECT_MODAL_TITLE: "Disconnect Meta",
        DISCONNECT_MODAL_MESSAGE:
            "Are you sure you want to disconnect your Meta integration? Leads will no longer be synced from your Facebook and Instagram ads.",
        DISCONNECT_SUCCESS: "Meta integration disconnected successfully",
        CONNECTIONS_TABLE: {
            PAGE_NAME: "Page Name",
            STATUS: "Status",
            EXPIRATION_DATE: "Connection Expiration Date",
            CONNECTING_USER_NAME: "Connecting User Name",
            CONNECTING_USER_EMAIL: "Connecting User Email",
            NO_CONNECTIONS: "No connections found",
        },
    },
    META_REPORTING: {
        AD_ACCOUNT: "Ad Account",
        AD_CAMPAIGN: "Ad Campaign",
        AD_SET: "Ad Set",
        AD: "Ad",
    },
    SMS: {
        LABEL: "SMS",
        DESCRIPTION: "Enable marketing and customer support based SMS",
        KNOWLEDGE_BASE_TITLE: "Need help setting up SMS?",
        KNOWLEDGE_BASE_DESCRIPTION:
            "Check out our knowledge base for step-by-step guidance on configuring SMS for marketing and customer support.",
        CONNECTION_DETAILS_HEADER: "SMS Connection Details",
        MARKETING_SMS: "Marketing SMS",
        TRANSACTIONAL_SMS: "Transactional SMS",
        STATUS: "Status",
        SETUP_COMPLETED: "Setup completed",
        PENDING_APPROVAL: "Pending approval",
        CTA_HEADER: "Connect SMS to Mallard Bay",
        CTA_DETAILS:
            "Enable SMS capabilities to communicate with your customers through marketing campaigns and transactional messages. Stay connected and improve customer engagement.",
        CTA_LABEL: "Set Up SMS",
        STEPS: {
            REPRESENTATIVE: "Representative",
            REPRESENTATIVE_DESCRIPTION:
                "Fill in the details of your authorized business representative.",
            BUSINESS_DETAILS: "Business Details",
            BUSINESS_DETAILS_DESCRIPTION:
                "Provide your business details as they appear on legal documents.",
            MARKETING_CAMPAIGN: "Marketing Campaign Details",
            MARKETING_CAMPAIGN_DESCRIPTION:
                "Information about why you want to send messages and how you will.",
            REVIEW_AND_SUBMIT: "Review and Submit",
            REVIEW_AND_SUBMIT_DESCRIPTION:
                "Review your information and submit your SMS registration.",
        },
        FORM: {
            ZIP_CODE_IS_REQUIRED: "Zip code is required",
            STATE_CODE_LENGTH:
                "State must be 2 characters. Please contact support for help setting up SMS.",
            COUNTRY_CODE_LENGTH:
                "Country must be 2 characters. Please contact support for help setting up SMS.",
            MARKETING_CAMPAIGN_DESCRIPTION_LENGTH:
                "Description must be between 40 and 4,096 characters.",
            MESSAGE_SAMPLE_LENGTH:
                "Message sample must be between 20 and 1,024 characters.",
            MESSAGE_SAMPLE_COUNT: "There must be between 2 and 5 messages.",
            ADDRESS: "Address",
            ADDRESS_SUBLABEL: "Where is your business located?",
            DELETE_MESSAGE_SAMPLE: "Delete message sample",
            FIRST_NAME: "First Name",
            LAST_NAME: "Last Name",
            EMAIL: "Email",
            PHONE_NUMBER: PHONE_NUMBER_LABEL,
            JOB_POSITION: "Job Position",
            BUSINESS_TITLE: "Business Title",
            BUSINESS_INFORMATION_SECTION: "Business Information",
            BUSINESS_NAME: "Business Name",
            BUSINESS_EIN: "EIN (Employer Identification Number)",
            BUSINESS_EIN_HELPER:
                "Your business's 9-digit federal tax identification number",
            BUSINESS_EIN_ERROR: "Must be 9 digits",
            BUSINESS_TYPE: "Business Type",
            BUSINESS_WEBSITE: "Business Website",
            COMPANY_TYPE: "Company Type",
            BUSINESS_INFORMATION_DESCRIPTION:
                "Provide your business details as they appear on legal documents.",
            STREET: "Street Address",
            CITY: "City",
            REGION: "State/Region",
            REGION_HELPER: "State abbreviation (e.g., CA, TX, NY)",
            POSTAL_CODE: "Postal Code",
            ISO_COUNTRY: "Country Code",
            MARKETING_CAMPAIGN_SECTION: "Marketing Campaign Details",
            MARKETING_CAMPAIGN_DESCRIPTION: "Campaign Description",
            MARKETING_CAMPAIGN_DESCRIPTION_HELPER:
                "Describe how you plan to use SMS for marketing",
            MESSAGE_SAMPLE: "Message Sample",
            ADD_MESSAGE_SAMPLE: "Add Message Sample",
            REGIONS_OF_OPERATION: "Regions of Operation",
            SUBMIT: "Register for SMS",
            DEFAULT_MARKETING_CAMPAIGN_DESCRIPTION:
                "This marketing campaign will be used to send promotional messaging to consented users to book trips.",
            DEFAULT_MARKETING_CAMPAIGN_MESSAGE_SAMPLE_1:
                "Hi, we're offering a 10% discount on all trips this month. Book now to save! Sent via Mallard Bay. Reply STOP to opt out",
            DEFAULT_MARKETING_CAMPAIGN_MESSAGE_SAMPLE_2:
                "Don't miss out on our exclusive offer! Book your trip today and save 10%! Sent via Mallard Bay. Reply STOP to opt out",
        },
    },
    WEBSITE_WIDGET: {
        LABEL: "Website Widget",
        DESCRIPTION:
            "Create and manage your website widget so guests can discover and book your trips.",
    },
    CUSTOM_EMAIL_DOMAIN: {
        DOMAIN_REQUIRED: "Domain is required",
        FROM_EMAIL_REQUIRED: "From email is required",
        FROM_EMAIL_INVALID: "Please enter a valid email address",
        FROM_EMAIL_DOMAIN_MISMATCH:
            "The from email must use the same domain you entered above.",
        REPLY_TO_EMAIL_INVALID: "Please enter a valid reply-to email address",
        REPLY_TO_EMAIL_DOMAIN_MISMATCH:
            "The reply-to email must use the same domain you entered above.",
        LABEL: "Custom Email Domain",
        DESCRIPTION:
            "Send emails from your own domain to improve deliverability and brand trust",
        CTA_HEADER: "Set Up a Custom Email Domain",
        CTA_DETAILS:
            "Configure a custom email domain to send emails from your own domain name. Stay connected and improve email deliverability while strengthening your brand identity.",
        CTA_LABEL: "Set Up Custom Email Domain",
        TITLE: "Custom Email Domain",
        SETUP: "Set up custom domain",
        VERIFY: "Verify domain",
        KNOWLEDGE_BASE_TITLE: "Need help setting up Custom Email Domain?",
        KNOWLEDGE_BASE_DESCRIPTION:
            "Check out our knowledge base for step-by-step guidance on configuring a custom email domain.",
        REMOVE: "Remove domain",
        STATUS: "Status",
        NO_DOMAIN_CONFIGURED:
            "No custom email domain configured. Set up a custom domain to send emails from your own domain.",
        DOMAIN_LABEL: "Domain",
        DOMAIN_PLACEHOLDER: "yourdomain.com",
        FROM_EMAIL_LABEL: "From Email",
        FROM_EMAIL_PLACEHOLDER: "noreply@yourdomain.com",
        REPLY_TO_EMAIL_LABEL: "Reply-To Email",
        REPLY_TO_EMAIL_PLACEHOLDER: "support@yourdomain.com",
        SAVE: "Set Up Domain",
        DESCRIPTION_DETAIL:
            "Enter your domain and the email address you want to send emails from. After setup, you'll need to add DNS records to verify ownership of the domain.",
        EMAIL_DOMAIN_MATCH_NOTE:
            "'From Email' and 'Reply-to Email' must use the same domain as the one entered above.",
        FROM_EMAIL_LOCAL_PART_PLACEHOLDER: "noreply",
        REPLY_TO_EMAIL_LOCAL_PART_PLACEHOLDER: "support",
        DNS_RECORDS: "DNS Records",
        TYPE: "Type",
        HOST: "Host",
        DATA: "Data",
        VALID: "Valid",
        VERIFIED_AT: "Verified At",
        PENDING: "Pending Verification",
        VERIFIED: "Verified",
        FAILED: "Verification Failed",
        DNS_INSTRUCTIONS:
            "Add the following DNS records to your domain to complete verification:",
        SETUP_SUCCESS: "Custom email domain setup initiated successfully",
        VERIFY_SUCCESS: "Domain verification completed successfully",
        VERIFY_FAILED:
            "Domain verification not successful. Please ensure you have added the DNS records and try again.",
        REMOVE_SUCCESS: "Custom email domain removed successfully",
        REMOVE_CONFIRMATION_HEADER: "Delete Custom Email Domain",
        REMOVE_CONFIRMATION_MESSAGE:
            "Are you sure you want to remove this custom email domain? You will no longer be able to send emails from this domain.",
        ERROR: "An error occurred. Please try again.",
        VERIFY_DESCRIPTION:
            "Once you have added the DNS records to your provider, click verify to finish the process. DNS settings can take some time to propagate so if it fails the first time wait and try again later.",
    },
    PLACEHOLDER: "Placeholder",
    ENTER_PLACEHOLDER: "Enter a placeholder",
    EDIT_FORM: "Edit Form",
    FORM_CONFIRMATION: {
        DELETE_FORM: "Delete Form",
        DELETE_FORM_CONFIRMATION_MESSAGE:
            "Are you sure you want to delete this form?",
        DELETE_FORM_CONFIRMATION_MESSAGE_2: "This action cannot be undone. ",
        DUPLICATE_FORM: "Duplicate Form",
        DUPLICATE_FORM_CONFIRMATION_MESSAGE:
            "Are you sure you want to duplicate this form? This will create a new form based off of this one.",
    },
    FORM_DELETED_SUCCESSFULLY: "Form deleted successfully",
    FORM_DUPLICATED_SUCCESSFULLY: "Form duplicated successfully",
    VIEW_FORM_DETAILS: "View Form Details",
    CUSTOM_FORM: "Custom Form",
    FORM_NAME: "Form Name",
    FORM_DESCRIPTION: "Form Description",
    TERMS: "Terms",
    LINKED_TO_BOOKING_AND_PRICING_PACKAGES:
        "Linked to Bookings / Pricing Packages",
    FILE_UPLOAD: "File Upload",
    ADDITIONAL_NOTES: "Additional Notes",
    ADD_NOTES_OR_INSTRUCTIONS:
        "Add any notes or instructions related to the file upload",
    SELECTION: "Selection",
    CHECKBOX: "Checkbox",
    ENTER_OPTION: "Enter option",
    OPTION: "Option",
    ADD_NEW_OPTION: "Add New Option",
    REMOVE_OPTION: "Remove Option",
    SIGNATURE: "Signature",
    FORM: "Form",
    REQUEST_A_QUOTE: "Request a Quote",
    MODAL: "Modal",
    MALLARD_BAY_WIDGET: "Mallard Bay Widget",
    WIDGET_ARIA_SPECIFIC_LISTINGS: "Is this widget for specific listings?",
    WIDGET_ARIA_USE_EXTERNAL: "Use external widget",
    BOOK_NOW: "Book Now",
    WIDGET_MODAL: "Widget Modal",
    REQUEST_A_QUOTE_MODAL: "Request a Quote Modal",
    CALENDAR_SYNC_HELP: {
        TITLE: "Need help finding your ICS link?",
        CTA_LABEL: "👉 Get link",
        DESCRIPTION:
            "Follow our step-by-step guide on how to get the correct .ics (calendar) link for this integration.",
    },
    PAGE_HEADER: "Page Header",
    PAGE_FOOTER: "Page Footer",
    LOGO: "Logo",
    PAGE_SECTION: "Page Section",
    IMAGE_AND_TEXT: "Image & Text",
    IMAGE_AND_TEXT_REVERSED: "Image & Text (Reversed)",
    INFO_CARD: "Info Card",
    INFO_CARD_REVERSED: "Info Card (Reversed)",
    INFO_CARD_STACKED: "Info Card (Stacked)",
    LEARN_MORE_CAPITALIZED: "Learn More",
    LOREM_IPSUM: {
        HEADING: "Lorem ipsum dolor sit amet",
        PARAGRAPH:
            "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas.",
        SHORT: "Quisque faucibus ex sapien vitae pellentesque sem placerat.",
    },
    COMPONENT: "Component",
    TITLE_TEXT_AND_BUTTONS: "Title, Text & Buttons",
    HERO_IMAGE: "Hero Image",
    HERO: "Hero",
    BACKGROUND_IMAGE: "Background image",
    OF: "of",
    COMPLETED: "completed",
    YOUTUBE_VIDEO: "YouTube Video",
    VIDEO_URL: "Video URL",
    ENTER_YOUTUBE_VIDEO_URL: "Enter a YouTube video URL",
    SELECT_A_VIDEO: "Select a video in settings",
    VIEW_FORM_ENTRIES: "View Form Entries",
    NO_FORM_SUBMISSIONS: "No form submissions",
    NO_FORM_INPUTS: "No form inputs",
    NO_ANSWER_PROVIDED: "No answer provided",
    FORM_SUBMISSIONS: "Form Submissions",
    FORM_SUBMISSION: "Form Submission",
    DATE_SUBMITTED: "Date Submitted",
    BACKGROUND_IMAGE_AND_TEXT: "Background Image & Text",
    BUTTON_LINK: "Button Link",
    EXTERNAL_BUTTON_LINK: "External Button Link",
    TEXT_LINK: "Text Link",
    EXTERNAL_TEXT_LINK: "External Text Link",
    LIGHT_MODE: "light mode",
    DARK_MODE: "dark mode",
    BACKGROUND_COLOR: "Background Color",
    CONTENT_COLOR: "Content Color",
    BORDER_COLOR: "Border Color",
    BRAND_COLOR: "Brand Color",
    BRAND_CONTENT_COLOR: "Brand Content Color",
    BUTTON_BACKGROUND_COLOR: "Button Background Color",
    BUTTON_CONTENT_COLOR: "Button Content Color",
    MOBILE: "Mobile",
    DESKTOP: "Desktop",
    PAGE_HORIZONTAL_PADDING: "Page Horizontal Padding",
    THEME_SETTINGS: "Theme Settings",
    SITE_SETTINGS: "Site Settings",
    FAVICON: "Favicon",
    FAVICON_NOTE:
        "PNGs with transparency are supported. Use images with a square aspect ratio for best results.",
    HEAD_TAGS: "Head Tags",
    ADD_TAG: "Add Tag",
    SCRIPT_PLACEHOLDER: "Paste a <script> or <meta> tag",
    INVALID_SCRIPT_TAG:
        "Must be a valid <script>...</script> or <meta ...> tag",
    INVALID_URL: "Must be a valid URL starting with https://",
    COLORS: "Colors",
    SPACING: "Spacing",
    GENERAL: "General",
    FONT_FAMILY: "Font Family",
    BODY_FONT_FAMILY: "Body Font Family",
    HEADING_FONT_FAMILY: "Heading Font Family",
    DARK_LIGHT_MODE: "Dark/Light Mode",
    FONT_FAMILY_LABELS: {
        NUNITO_SANS: "Nunito Sans",
        ARIAL: "Arial",
        COURIER_NEW: "Courier New",
        GEORGIA: "Georgia",
        HELVETICA: "Helvetica",
        TAHOMA: "Tahoma",
        TIMES_NEW_ROMAN: "Times New Roman",
        TREBUCHET_MS: "Trebuchet MS",
        VERDANA: "Verdana",
    },
    COLOR_MODE_LABELS: {
        AUTO: "Auto",
        LIGHT: "Light",
        DARK: "Dark",
    },
    BUTTON_LABEL: "Button label",
    CONTACT_INFO: "Contact Info",
    CONTACT_INFO_PLACEHOLDERS: {
        TITLE: "Get in Touch",
        SUBTITLE:
            "We'd love to hear from you! Whether you have a question, need support, or just want to say hello -- reach out anytime.",
        ADDRESS: "1234 Maplewood Lane, Brooklyn, NY 11215",
        SHORT_ADDRESS: "Brooklyn, NY",
        PHONE_NUMBER: "+19995551234",
        EMAIL: "info@example.com",
    },
    LINK_TYPE: "Link Type",
    SHARE_FORM: "Share Form",
    SHARE_FORM_URL: "Share Form",
    SHARE_FORM_TITLE: "Check out this form on Mallard Bay",
    FAILED_TO_COPY_TO_CLIPBOARD: "Failed to copy to clipboard",
    ENTER_A_NAME_FOR_YOUR_FORM: "Enter a name for your form.",
    ADD_ANY_SUPPORTING_TEXT_OR_NOTES:
        "Add any supporting text or notes for this form. This can describe its purpose, usage instructions, or any relevant details.",
    IF_NOT_SELECTED_WE_WILL_ONLY_CREATE_THIS_FORM_FOR_THE_HOST:
        "Leave this unchecked to require only the host to fill out the form if attached to a booking. Select it if every group member should complete their own copy.",
    TEMPLATE: "Template (Optional)",
    TEMPLATE_WITH_COLON: "Template:",
    TEMPLATE_DESCRIPTION:
        "Select a pre-made template to quickly set up your form. The custom fields will be auto-filled based on your selection.",
    LIABILITY_WAIVER_TEMPLATE: "Liability Waiver",
    HUNTING_LICENSE_TEMPLATE: "Hunting License",
    CONTACT_TEMPLATE: "Contact",
    ENTER_YOUR_FULL_NAME: "Enter your full name",
    SIGN_HERE: "Sign here",
    ENTER_YOUR_LICENSE_NUMBER: "Enter your license number",
    UPLOAD_LICENSE_SCAN: "Upload a scan or photo of your license",
    DATE_PLACEHOLDER: "mm/dd/yyyy",
    SELECT_A_TEMPLATE: "Select a template",
    FULL_NAME: "Full Name",
    DATE_TODAY: "Date Today",
    CURRENT_BILLING_OWNER: "Current Billing Owner",
    VIEW_QUICK_PAY: "View Quick Pay",
    EMBED_CODE_INSTRUCTIONS: "Embed code & instructions",
    EMBED_CODE_INSTRUCTIONS_DESCRIPTION:
        "Easily view step-by-step instructions and copy the embed code to integrate it seamlessly into your site or app.",
    ADD_TRACKING_SCRIPT: "Add Tracking Script",
    SHOW_INSTRUCTIONS: "Show instructions",
    WHAT_KIND_OF_WEBSITE_DO_YOU_HAVE: "What kind of website do you have?",
    PLEASE_CONTACT_A_MALLARD_BAY_REPRESENTATIVE:
        "Please contact a Mallard Bay representative if you have any questions or require assistance.",
    COPY_YOUR_WIDGET_CODE: "Copy your widget code",
    IMPORTANT_NOTES_AND_CONSIDERATIONS: "Important notes and considerations",
    WEBSITE_TYPE_STEP: {
        TITLE: "What kind of website do you have?",
        CUSTOM: "Custom",
        WIX: "Wix",
        WORDPRESS: "WordPress",
        CONTACT_INSTRUCTIONS:
            "For any other website types, please contact a Mallard Bay representative for instructions.",
    },
    WEBSITE_BUILDER: "Website Builder",
    SELECT_IMAGE: "Select Image",
    SELECT_IMAGES: "Select Images",
    SRC: "Src",
    ALT: "Alt",
    IMAGE_GALLERY: "Image Gallery",
    VIEW_MORE: "View More",
    SHOW_NON_LISTING_EVENTS: "Show non-listing events",
    BADGES: "Badges",
    BADGE_CREATED_SUCCESSFULLY: "Badge created successfully",
    ENTER_BADGE_NAME: "Enter badge name",
    BADGE_NAME: "Badge Name",
    IMAGE_URL: "Image Url",
    CREATE_BADGE: "Create a Badge",
    NO_BADGES_YET: "No badges yet",
    START_BY_CREATING_A_BADGE: "Start by creating a badge",
    CREATE_A_BADGE: "Create a badge",
    THIS_OUTFITTER_IS: "This outfitter is",
    ADD_NEW_BADGE: "Add New Badge",
    BADGE_UPDATED_SUCCESSFULLY: "Badge updated successfully",
    BADGES_ADDED_TO_OUTFITTER_SUCCESSFULLY: "Badges successfully added",
    ASSIGN_A_BADGE: "Assign a badge",
    NO_BADGES_FOUND: "No badges found",
    VIEW_OUTFITTERS: "View Outfitters",
    NO_OUTFITTERS_FOUND: "No outfitters found",
    THEME_PREVIEW: {
        PREVIEW: "Preview",
        YOU_ARE_VIEWING: "You are viewing",
        LIGHT_MODE: "Light Mode",
        DARK_MODE: "Dark Mode",
        TITLE: "Heading",
        PARAGRAPH:
            "This is a sample paragraph demonstrating how your chosen font family and content color work together. The typography should feel consistent across all text elements.",
        BUTTON: "Button",
        BRAND_BUTTON: "Brand Button",
        BORDER: "This card shows how content appears with border.",
        SECONDARY_CONTENT_COLOR: "Secondary content color.",
        TERTIARY_CONTENT_COLOR: "Tertiary content color.",
        SECONDARY_BACKGROUND_COLOR: "Secondary background color.",
        TERTIARY_BACKGROUND_COLOR: "Tertiary background color.",
    },
    COLORS_DARK_MODE: "Colors - Dark Mode",
    COLORS_LIGHT_MODE: "Colors - Light Mode",
    ADD_ON_ORDERS_SUCCESSFULLY_UPDATED: "Add-on orders successfully updated",
    GALLERY: "Gallery",
    CONTACT_US: "Contact Us",
    START_FROM_SCRATCH: "Start From Scratch",
    BASIC_PAGE: "Basic Page",
    BLOG: "Blog",
    BLOG_INDEX: "Blog Index",
    BLOG_PREVIEW_CARD: "Blog Preview Card",
    BLOG_PREVIEW_PAGE_SECTION: "Blog Preview",
    READ_MORE: "Read More",
    CHOOSE_A_TEMPLATE: "Choose a template",
    PAGE_TITLE_PLACEHOLDER: "Enter a title for your page...",
    WIDTH: "Width",
    HEIGHT: "Height",
    MIN_WIDTH: "Min Width",
    MIN_HEIGHT: "Min Height",
    MAX_WIDTH: "Max Width",
    MAX_HEIGHT: "Max Height",
    TOP: "Top",
    BOTTOM: "Bottom",
    LEFT: "Left",
    RIGHT: "Right",
    HORIZONTAL: "Horizontal",
    VERTICAL: "Vertical",
    FONT_SIZE: "Font Size",
    FONT_WEIGHT: "Font Weight",
    LINE_HEIGHT: "Line Height",
    LETTER_SPACING: "Letter Spacing",
    TEXT_ALIGN: "Text Align",
    NORMAL: "Normal",
    SEMI_BOLD: "Semi-Bold",
    BOLD: "Bold",
    AUTO: "Auto",
    BACKGROUND: "Background",
    BORDER: "Border",
    DISPLAY: "Display",
    FLEX_DIRECTION: "Flex Direction",
    JUSTIFY_CONTENT: "Justify Content",
    ALIGN_ITEMS: "Align Items",
    FLEX_WRAP: "Flex Wrap",
    ALIGN_SELF: "Align Self",
    FLEX_GROW: "Flex Grow",
    FLEX_SHRINK: "Flex Shrink",
    COLOR: "Color",
    SIZE: "Size",
    RADIUS: "Radius",
    REPEAT: "Repeat",
    ATTACHMENT: "Attachment",
    POSITION: "Position",
    TOP_LEFT: "Top Left",
    TOP_RIGHT: "Top Right",
    BOTTOM_LEFT: "Bottom Left",
    BOTTOM_RIGHT: "Bottom Right",
    CENTER: "Center",
    STRETCH: "Stretch",
    BASELINE: "Baseline",
    REPEAT_X: "Repeat X",
    REPEAT_Y: "Repeat Y",
    NO_REPEAT: "No Repeat",
    SOLID: "Solid",
    DASHED: "Dashed",
    DOTTED: "Dotted",
    DOUBLE: "Double",
    GROOVE: "Groove",
    RIDGE: "Ridge",
    INSET: "Inset",
    OUTSET: "Outset",
    ROW: "Row",
    FLEX_START: "Flex Start",
    FLEX_END: "Flex End",
    SPACE_BETWEEN: "Space Between",
    SPACE_AROUND: "Space Around",
    SPACE_EVENLY: "Space Evenly",
    BLOCK: "Block",
    INLINE: "Inline",
    INLINE_BLOCK: "Inline-Block",
    FLEX: "Flex",
    WRAP: "Wrap",
    NO_WRAP: "No Wrap",
    COVER: "Cover",
    CONTAIN: "Contain",
    SCROLL: "Scroll",
    FIXED: "Fixed",
    STATIC: "Static",
    RELATIVE: "Relative",
    ABSOLUTE: "Absolute",
    STICKY: "Sticky",
    CHOOSE_A_FORM_IN_SETTINGS: "Choose a form in settings",
    SEARCH_FORMS: "Search forms",
    SELECT_A_FORM: "Select a form",
    SELECT_A_DOCUMENT: "Select a document",
    META_TAGS: "Meta Tags",
    FOCUS_KEYPHRASE: "Focus Keyphrase",
    TITLE_HELPER_TEXT: "Recommended: 50-60 characters",
    META_DESCRIPTION_HELPER_TEXT: "Recommended: 120-160 characters",
    OG_URL: "OG URL",
    OG_URL_PLACEHOLDER: "Auto-generated from page URL",
    OG_TYPE: "OG Type",
    OG_SITE_NAME: "OG Site Name",
    NO_INDEX: "Hide from search engines (noindex)",
    ICON: "Icon",
    PHONE: "Phone",
    LOCATION: "Location",
    FACEBOOK: "Facebook",
    INSTAGRAM: "Instagram",
    TWITTER: "Twitter",
    YOUTUBE: "YouTube",
    TIKTOK: "TikTok",
    X_SMALL: "X-Small",
    SMALL: "Small",
    MEDIUM: "Medium",
    LARGE: "Large",
    X_LARGE: "X-Large",
    TWO_X_LARGE: "2X Large",
    THREE_X_LARGE: "3X Large",
    FOUR_X_LARGE: "4X Large",
    LINK_WITH_ICON: "Link with Icon",
    TEXT_LINK_WITH_ICON: "Text Link with Icon",
    EXTERNAL_TEXT_LINK_WITH_ICON: "External Text Link with Icon",
    BUTTON_LINK_WITH_ICON: "Button Link with Icon",
    EXTERNAL_BUTTON_LINK_WITH_ICON: "External Button Link with Icon",
    CONTACT_INFO_COMPACT: "Contact Info Compact",
    WHERE_WE_ARE: "Where We Are",
    GIVE_US_A_CALL: "Give Us a Call",
    SEND_AN_EMAIL: "Send an Email",
    CONNECT_ONLINE: "Connect Online",
    LOCATION_SUBTITLE: "Feel free to swing by if you're nearby!",
    PHONE_SUBTITLE: "We're happy to chat, anytime during business hours.",
    EMAIL_SUBTITLE:
        "Drop us a note -- we'll get back to you as soon as we can.",
    CONNECT_ONLINE_SUBTITLE:
        "Follow along for updates, stories, and a sprinkle of fun.",
    ICON_LINK: "Icon Link",
    SOCIAL_MEDIA_LINKS: "Social Media Links",
    IMAGES_UPLOADING: {
        UPLOAD_IMAGE: "Upload Image",
        UPLOAD_IMAGES: "Upload Images",
    },
    CUSTOM: "Custom",
    URL: "Url",
    SAVE_CUSTOM_FONT: "Save Custom Font",
    FONT_NAME_PLACEHOLDER: "Libertinus Serif",
    FONT_FAMILY_PLACEHOLDER: `"Libertinus Serif", serif`,
    FONT_URL_PLACEHOLDER: "https://fonts.googleapis.com/...",
    FONT_FAMILY_HELPER_TEXT: "font-family value for CSS",
    GAP: "Gap",
    OBJECT_FIT: "Object Fit",
    OBJECT_POSITION: "Object Position",
    FILL: "Fill",
    SCALE_DOWN: "Scale Down",
    SCALE_UP: "Scale Up",
    GRID: "Grid",
    X_SMALL_SCREEN_COLUMNS: "X-small screen columns",
    SMALL_SCREEN_COLUMNS: "Small screen columns",
    MEDIUM_SCREEN_COLUMNS: "Medium screen columns",
    LARGE_SCREEN_COLUMNS: "Large screen columns",
    X_LARGE_SCREEN_COLUMNS: "X-large screen columns",
    HTML: "HTML",
    CUSTOM_HTML: "Custom HTML",
    SCRIPT: "Script",
    BACKGROUND_IMAGE_BLOCK_LABEL: "Background Image",
    BRIGHTNESS: "Brightness",
    BLUR: "Blur",
    BACKGROUND_COLOR_INVERSE: "Background Color Inverse",
    CONTENT_COLOR_INVERSE: "Content Color Inverse",
    BORDER_COLOR_INVERSE: "Border Color Inverse",
    BRAND_COLOR_INVERSE: "Brand Color Inverse",
    BRAND_CONTENT_COLOR_INVERSE: "Brand Content Color Inverse",
    BUTTON_BACKGROUND_COLOR_INVERSE: "Button Background Color Inverse",
    BUTTON_CONTENT_COLOR_INVERSE: "Button Content Color Inverse",
    DIVIDER: "Divider",
    UNORDERED_LIST: "Unordered List",
    ORDERED_LIST: "Ordered List",
    LIST_ITEM: "List Item",
    FLEX_COLUMNS: "Flex Columns",
    STARTING_AT: "Starting at",
    LISTING_REVERSED: "Listing (Reversed)",
    LISTING_PREVIEW: "Listing Preview",
    LISTING_PREVIEW_REVERSED: "Listing Preview (Reversed)",
    ALL_LISTINGS_PREVIEW: "All Listings Preview",
    VIEW_PACKAGES: "View Packages",
    UPDATE_INFO: "Update Info",
    REFRESH: "Refresh",
    POWERED_BY: "| Powered by",
    FAQ: "FAQ",
    EXPANDABLE: "Expandable",
    EXPANDABLE_TITLE_PLACEHOLDER: "Title for expandable content",
    EXPANDABLE_CONTENT_PLACEHOLDER: "Expandable content",
    SECONDARY_BACKGROUND_COLOR: "Secondary Background Color",
    SECONDARY_BACKGROUND_COLOR_INVERSE: "Secondary Background Color Inverse",
    TERTIARY_BACKGROUND_COLOR: "Tertiary Background Color",
    TERTIARY_BACKGROUND_COLOR_INVERSE: "Tertiary Background Color Inverse",
    FAQ_TITLE_PLACEHOLDER: "Frequently Asked Questions",
    SECONDARY_CONTENT_COLOR: "Secondary Content Color",
    SECONDARY_CONTENT_COLOR_INVERSE: "Secondary Content Color Inverse",
    TERTIARY_CONTENT_COLOR: "Tertiary Content Color",
    TERTIARY_CONTENT_COLOR_INVERSE: "Tertiary Content Color Inverse",
    BUTTON_BACKGROUND_HOVER_COLOR: "Button Background Hover Color",
    BUTTON_BACKGROUND_HOVER_COLOR_INVERSE:
        "Button Background Hover Color Inverse",
    BUTTON_CONTENT_HOVER_COLOR: "Button Content Hover Color",
    BUTTON_CONTENT_HOVER_COLOR_INVERSE: "Button Content Hover Color Inverse",
    BRAND_HOVER_COLOR: "Brand Hover Color",
    BRAND_HOVER_COLOR_INVERSE: "Brand Hover Color Inverse",
    BRAND_CONTENT_HOVER_COLOR: "Brand Content Hover Color",
    BRAND_CONTENT_HOVER_COLOR_INVERSE: "Brand Content Hover Color Inverse",
    BUTTON: "Button",
    CARD_BORDER_RADIUS: "Card Border Radius",
    BUTTON_BORDER_RADIUS: "Button Border Radius",
    LINK_COLOR: "Link Color",
    LINK_COLOR_INVERSE: "Link Color Inverse",
    LINK_HOVER_COLOR: "Link Hover Color",
    LINK_HOVER_COLOR_INVERSE: "Link Hover Color Inverse",
    BRANDS_WE_TRUST: "Brands We Trust",
    IMAGE_LINK: "Image Link",
    DISABLE_LINK: "Disable link",
    DROPDOWN_MENU: "Dropdown Menu",
    LINKS: "Links",
    SELECT_A_PAGE: "Select a page",
    ADD_LINK: "Add Link",
    LABEL: "Label",
    HREF: "Href",
    VIDEO: "Video",
    AUTOPLAY: "Autoplay",
    LOOP: "Loop",
    MUTED: "Muted",
    CONTROLS: "Controls",
    VIDEO_URL_PLACEHOLDER: "https://www.example.com/video.mp4",
    BACKGROUND_VIDEO: "Background Video",
    CURSOR: "Cursor",
    POINTER: "Pointer",
    WAIT: "Wait",
    MOVE: "Move",
    NOT_ALLOWED: "Not Allowed",
    CROSSHAIR: "Crosshair",
    HELP: "Help",
    MALLARD_BAY_FOR_GUIDES: "Mallard Bay for Guides",
    UPDATE_IMAGES: "Update Images",
    BOOKED_ON: "Booked on",
    FORMAT: "Format",
    JPEG: "JPEG",
    PNG: "PNG",
    ABOUT_OUTFITTER: "About Outfitter",
    PHOTOS: "Photos",
    CLICK_TO_ADD_CAPTION: "Click to add caption",
    EDIT_PHOTOS: "Edit photos",
    EDIT_ADD_ONS: "Edit Add-ons",
    IMAGE_GRID: "Image Grid",
    NUMBER_TO_SHOW: "# of images to show",
    HORIZONTAL_PADDING: "Horizontal Padding",
    VERTICAL_PADDING: "Vertical Padding",
    EDIT_SYNCED_CALENDAR_BANNER: {
        TITLE: "Changes Will Re-Sync All Events",
        MESSAGE:
            "Updating the settings for this synced calendar will apply your changes to all events — both new ones we fetch from your third-party calendar and the events we’ve already imported. Availability adjustments for your selected resources will be updated accordingly.",
    },
    COPY_INVITE_LINK: "Copy invite link",
    RESEND_INVITE: "Resend invite",
    WEB_PERFORMANCE: "Web Performance",
    TRAFFIC_METRICS: "Traffic Metrics",
    USERS: "Users",
    SESSIONS: "Sessions",
    PAGE_VIEWS: "Page Views",
    TRAFFIC_METRICS_DESCRIPTION: "Daily performance over selected time period",
    AGGREGATED_DATA: "Aggregated Data",
    KEY_SESSION_METRICS: "Key Session Metrics",
    AVG_SESSION_DURATION: "Avg. Session Duration",
    NEW_USERS: "New Users",
    TOP_PAGES: "Top Pages",
    TOP_TRAFFIC_SOURCES: "Top Traffic Sources",
    DEVICE_TYPE_BREAKDOWN: "Device Type Breakdown",
    USERS_LOWERCASE: "users",
    FEATURE_PERFORMANCE: "Feature Performance",
    TOTAL_BOOKINGS: "Total Bookings",
    TOTAL_QUOTE_SUBMISSIONS: "Total Quote Submissions",
    AVG_CONVERSION_RATE: "Avg. Conversion Rate",
    QUOTE_SUBMISSIONS: "Quote Submissions",
    BOOKINGS_BY_SOURCE: "Bookings by Source",
    DETAILED_PERFORMANCE_METRICS: "Detailed Performance Metrics",
    DISTRIBUTION_OF_BOOKINGS:
        "Distribution of bookings across different sources",
    SOURCE_SPECIFIC_CONVERSION: "Source-specific conversion data",
    SUBMISSIONS: "Submissions",
    CONVERSION: "Conversion",
    SESSION_DURATION: "Session Duration (minutes)",
    SESSION: "Session",
    TABLET: "Tablet",
    WINDOWS: "Windows",
    MACOS: "MacOS",
    IOS: "iOS",
    ANDROID: "Android",
    NEED_HELP_UNDERSTANDING_YOUR_WEB_PERFORMANCE:
        "Need help understanding your web performance?",
    DISCOVER_INSIGHTS_SOLUTIONS_AND_TIPS:
        "Discover insights, solutions, and tips to help optimize your website's speed, reliability, and overall performance. ",
    MESSAGE_TEMPLATES: "Message Templates",
    AUTOMATION_CENTER: "Automation Center",
    REQUEST_AUTOMATION: "Request Automation",
    CHANNEL: "Channel",
    NO_TEMPLATES_FOUND: "No templates found",
    TEMPLATE_SEARCH_PLACEHOLDER: "Search templates",
    TEMPLATE_FILTERS: "Template Filters",
    ALL_CHANNELS: "All channels",
    ALL_TYPES: "All types",
    SYSTEM_TEMPLATES: "System templates",
    CREATE_TEMPLATE: "Create Template",
    TEMPLATE_NOT_FOUND: "Template not found",
    PAGE_NOT_FOUND: "This page could not be found.",
    PAGE_NOT_FOUND_DESCRIPTION:
        "You just hit a route that doesn't exist... the sadness.",
    TOP_TRAFFIC_SOURCES_DESCRIPTION: "Sources driving the most traffic",
    EDIT_SMS_TEMPLATE: "Edit SMS Template",
    TEMPLATE_NAME_PLACEHOLDER: "Template name...",
    MESSAGE_CONTENT: "Message Content",
    TEMPLATE_VARIABLES_BANNER: {
        TITLE: "Template Variables",
        DESCRIPTION: `You can use template variables to have relevant content
                    inserted into your message when sending. To insert a template variable, type "{{" and select the item you want from the dropdown. You can also continue typing when the options appear to narrow down the results. Example: "{{Booking Start" to help find "Booking Start Date".`,
    },
    DELETE_TEMPLATE: "Delete Template",
    DELETE_TEMPLATE_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this template?",
    RESTORE_TEMPLATE_TO_DEFAULT: "Restore to Default",
    RESTORE_TEMPLATE_TO_DEFAULT_CONFIRMATION_MESSAGE:
        "Are you sure you want to restore this template to its default state? All customizations will be lost.",
    UNSET_PROPERTY: "Unset Property",
    UNSET_PROPERTY_CONFIRMATION_MESSAGE:
        "Are you sure you want to unset this property?",
    DUPLICATE_TEMPLATE: "Duplicate Template",
    DUPLICATE_TEMPLATE_CONFIRMATION_MESSAGE:
        "Are you sure you want to duplicate this template?",
    MONTH_SELECTOR: {
        JANUARY: "January",
        FEBRUARY: "February",
        MARCH: "March",
        APRIL: "April",
        MAY: "May",
        JUNE: "June",
        JULY: "July",
        AUGUST: "August",
        SEPTEMBER: "September",
        OCTOBER: "October",
        NOVEMBER: "November",
        DECEMBER: "December",
    },
    TABLE: "Table",
    TABLE_BODY: "Table Body",
    TABLE_ROW: "Table Row",
    TABLE_CELL: "Table Cell",
    ONE_COLUMN: "Column",
    THREE_COLUMNS: "3 Columns",
    TEMPLATE_VARIABLE: "Template Variable",
    TEMPLATE_VARIABLE_HREF_PLACEHOLDER: "Select a variable for href...",
    VARIABLES: "Variables",
    EMAIL_SETTINGS: "Email Settings",

    SUBJECT: "Subject",
    BACKDROP_COLOR: "Backdrop Color",
    MESSAGE: "Message",
    SEND_MESSAGE: "Send Message",
    SELECT_A_TEMPLATE_PLACEHOLDER: "Select a template...",
    SMS_LABEL: "SMS",
    TEMPLATE_LABEL: "Template",
    NO_EMAIL_OR_PHONE: "Unable to find email or phone number for recipient.",
    SENDING_TO: "Sending to",
    USE_TEMPLATE: "Use Template",
    CUSTOM_MESSAGE: "Custom Message",
    MESSAGE_TYPE: "Message type",
    MESSAGE_BODY: "Message Body",
    ENTER_SUBJECT: "Enter subject...",
    ENTER_MESSAGE_BODY: "Enter message body...",
    COMPOSE: "Compose",
    TEMPLATE_PREVIEW_HINT: getTemplatePreviewHint,
    TEMPLATE_PREVIEW_IFRAME_TITLE: getTemplatePreviewIframeTitle,
    ADD_WEBSITE_TRACKING_SCRIPT: "Add Website Tracking Script",
    PAYMENT_TITLE_DESCRIPTION: "Payment Title/Description",
    WHAT_IS_THE_CHARGE_FOR: "What is the charge for?",
    PAYMENT_AMOUNT: "Payment Amount",
    DELETE_BOOKING: "Delete Booking",
    ARE_YOU_SURE_TO_DELETE_THIS_BOOKING:
        "Are you sure you want to delete this booking? You can't undo this action afterwards.",
    BOOKING_DELETED_SUCCESS: "Booking deleted successfully",
    BOOKING_DELETED_ERROR: "Failed to delete booking",
    EDIT_DROPDOWN: "Edit Dropdown",
    MOVE_UP: "Move Up",
    MOVE_DOWN: "Move Down",
    SORT_LINKS: "Sort Links",
    REARRANGE_LINKS_BANNER: "Rearrange links by dragging and dropping.",
    INHERITED: "Inherited",
    RESIZE_METHOD: "Resize Method",
    SMART_CROP: "Smart Crop",
    SELECT_A_SIZE: "Select a size",
    ORIGINAL: "Original",
    SCALE: "Scale",
    SCALE_AND_CROP: "Scale & Crop",
    SMART: "Smart",
    SMART_FACES: "Smart Faces",
    SMART_OBJECTS: "Smart Objects",
    TARGET_SPECIES: "Target species",
    HERO_BLOCK_TEXT: {
        HEADING: "Your Catchy Headline Here",
        TEXT: "A short supporting subheading or tagline that explains the value proposition of your product or service.",
    },
    EMAIL_TEMPLATE: {
        HI: "Hi ",
        COMMA: ",",
        SINCERELY: "Sincerely,",
        BEST: "Best,",
    },
    EMAIL_SUBJECT: {
        TRIP_APPROACHING: "Your upcoming trip",
        QUOTE_FOLLOW_UP: "Following up on your quote",
        BAD_WEATHER: "Important update about your upcoming trip",
        REVIEW_REQUEST: "Share your experience with us",
        REFERRAL_PROMPT: "Invite a friend to join the adventure",
    },
    TEMPLATE_NAMES: {
        TRIP_APPROACHING: "Trip Approaching",
        QUOTE_FOLLOW_UP: "Quote Follow Up",
        BAD_WEATHER: "Bad Weather",
        REVIEW_REQUEST: "Review Request",
        BOOKING_REVIEW_REQUEST: "Booking Review Request",
        REFERRAL_PROMPT: "Referral Prompt",
    },
    GLOBAL_TEMPLATE_NAMES: {
        FAILED_PAYMENT: "AUTOMATION: Failed Payment Contact",
        REFUND_INITIATED: "AUTOMATION: Refund Initiated Contact",
        QUICK_PAY_RECEIPT: "AUTOMATION: Quick Pay Receipt Contact",
        BOOKING_DECLINED: "AUTOMATION: Booking Declined Contact",
        PAYMENT_REQUEST_RECEIPT: "AUTOMATION: Payment Request Receipt Contact",
        PAYMENT_REQUEST_URGENT_REMINDER:
            "AUTOMATION: Payment Request Urgent Reminder Contact",
        PAYMENT_REQUEST_REMINDER:
            "AUTOMATION: Payment Request Reminder Contact",
        PAYMENT_REQUEST_CREATED: "AUTOMATION: Payment Request Created Contact",
        BOOKING_INVITE_INVOICE: "AUTOMATION: Booking Invite Invoice Contact",
        BOOKING_INVITE: "AUTOMATION: Booking Invite Contact",
        BOOKING_UPDATE: "AUTOMATION: Booking Update Contact",
        BOOKING_RECEIPT: "AUTOMATION: Booking Receipt Contact",
        BOOKING_CANCELLED: "AUTOMATION: Booking Cancelled Contact",
        BOOKING_REQUESTED: "AUTOMATION: Booking Requested Contact",
        BOOKING_APPROVED: "AUTOMATION: Booking Approved Contact",
        REVIEW_REQUEST_CONTACT: "AUTOMATION: Review Request Contact",
        FORM_SUBMISSION: "AUTOMATION: Form Submission Contact",
        PRE_TRIP_REMINDER: "AUTOMATION: Pre-Trip Reminder Contact",
        TRIP_DETAIL_REMINDER: "AUTOMATION: Trip Detail Reminder Contact",
        PROSPECTIVE_CONTACT_REMINDER:
            "AUTOMATION: Prospective Contact Reminder Contact",
        GEAR_LIST_CONTACT: "AUTOMATION: Gear List Contact",
    },
    GLOBAL_EMAIL_SUBJECT: {
        FAILED_PAYMENT: "Action Required: Payment Failure",
        REFUND_INITIATED: "Refund Initiated",
        QUICK_PAY_RECEIPT: "Payment Received",
        PAYMENT_REQUEST_RECEIPT: "Payment Received - Receipt Attached",
        PAYMENT_REQUEST_URGENT_REMINDER:
            "Reminder: Outstanding Payment for Your Recent Trip at {{outfitter_name}}",
        BOOKING_DECLINED: "Reservation Declined",
        PAYMENT_REQUEST_REMINDER:
            "Reminder: Outstanding Payment for Your Recent Trip at {{outfitter_name}}",
        PAYMENT_REQUEST_CREATED:
            "Final Settlement Request for Your Recent Trip at {{outfitter_name}}",
        BOOKING_INVITE: "Your Requested Quote for {{outfitter_name}} Trip",
        BOOKING_INVITE_INVOICE:
            "Your Requested Invoice for {{outfitter_name}} Trip",
        BOOKING_UPDATE: "Changes to your reservation",
        BOOKING_RECEIPT: "Payment Received - Receipt Attached",
        BOOKING_CANCELLED:
            "Cancellation of Your Trip on {{booking_start_date}}",
        BOOKING_REQUESTED: "Your booking request has been submitted!",
        BOOKING_APPROVED: "Your trip is confirmed with {{outfitter_name}}!",
        REVIEW_REQUEST_CONTACT: "Share your experience with us",
        FORM_SUBMISSION: "Your form submission has been completed",
        PRE_TRIP_REMINDER:
            "Get Ready for Your Upcoming Trip with {{outfitter_name}}!",
        TRIP_DETAIL_REMINDER: "Your Trip Is Almost Here — Review Your Details",
        PROSPECTIVE_CONTACT_REMINDER: "Quick Reminder About Your Trip Quote",
        GEAR_LIST_CONTACT: "What to Pack — Your Recommended Gear List",
    },
    REVIEW_REQUEST_TEMPLATE: {
        LINE_ONE:
            "Thank you again for booking with us — we hope you had a great time on your trip! If you wouldn't mind, we'd love it if you could leave a quick review. It only takes a minute and helps other guests know what to expect.",
        LINE_TWO_PREFIX: "You can leave your review here: ",
        LINE_THREE: "Thanks again, and we hope to see you soon!",
        YOU_CAN_VIEW_YOUR_BOOKING_HERE: "You can view your booking here: ",
    },

    BAD_WEATHER_TEMPLATE: {
        LINE_ONE_PREFIX:
            "We wanted to let you know that the forecasted conditions for your trip on ",
        LINE_ONE_SUFFIX:
            " are not favorable. For your safety and enjoyment, we recommend rescheduling.",
        LINE_TWO:
            "We'd be happy to work with you to find another date that fits your schedule. Please reply here and we'll get that set up right away.",
        LINE_THREE:
            "Thank you for your understanding, and we look forward to hosting you under better conditions.",
    },
    QUOTE_FOLLOW_UP_TEMPLATE: {
        LINE_ONE:
            "I wanted to follow up to see if you had a chance to review the quote we sent over. If anything needs to be adjusted or if you have questions, please don't hesitate to reach out.",
        LINE_TWO: "Looking forward to helping plan your trip.",
    },
    REFERRAL_PROMPT_TEMPLATE: {
        LINE_ONE:
            "We're glad you joined us and hope you had a great trip! If you know friends or family who might enjoy an outing like this, we'd love for you to share your experience with them.",
        LINE_TWO:
            "Thanks again for choosing us — we look forward to hosting you again in the future.",
    },
    BOOKING_APPROVED_CONTACT_TEMPLATE: {
        YOUR_RESERVATION_WITH_SEGMENT: "Your reservation with ",
        HAS_BEEN_CONFIRMED_FOR_SEGMENT: " has been confirmed for ",
        THANK_YOU:
            "Thank you for booking with us, and feel free to reach out to us if you have any other questions regarding your trip.",
        BOOKING_DETAILS_PLACEHOLDER:
            "Booking details will be displayed here...",
        SENT_BY: "Sent by,",
    },
    BOOKING_REQUESTED_CONTACT_TEMPLATE: {
        YOUR_BOOKING_REQUEST_SEGMENT:
            "Your booking request has been received. We will let you know as soon as it has been accepted and approved by ",
        PLEASE_NOTE:
            "Please note that you will not be charged until your booking has been approved by the outfitter.",
    },
    BOOKING_CANCELLED_CONTACT_TEMPLATE: {
        TITLE_PREFIX: "Cancellation of Your Trip on ",
        REGRET_TO_INFORM_SEGMENT:
            "We regret to inform you that your trip with ",
        ON_SEGMENT: " on ",
        HAS_BEEN_CANCELLED_SEGMENT:
            " has been canceled. We have already initiated a refund for all previously completed payments.",
        REBOOKING_ASSISTANCE_SEGMENT:
            "Our team is here to assist you with rebooking. Please contact us at ",
        FOR_RECOMMENDATIONS_SEGMENT: " for recommendations and support.",
    },
    BOOKING_DECLINED_CONTACT_TEMPLATE: {
        TITLE: "Reservation Declined",
        BODY_PREFIX: "We're sorry, but we won't be able to host your trip on ",
        BODY_MIDDLE:
            ". We'd like to get you rescheduled for another date. Feel free to request another booking, or reach out to us at ",
        CONTACT_CONNECTOR: " or ",
    },
    QUICK_PAY_RECEIPT_CONTACT_TEMPLATE: {
        BODY: "We have received your payment of ",
    },
    REFUND_INITIATED_CONTACT_TEMPLATE: {
        REFUND_PREFIX: "We have issued a refund of ",
        PAYMENT_SEGMENT: " for your payment of ",
        FUNDS_APPEARANCE_MESSAGE:
            "Please allow 5-10 business days for the funds to appear on your statement.",
        QUESTIONS_SEGMENT: "If you have any questions please contact us at ",
    },
    FAILED_PAYMENT_CONTACT_TEMPLATE: {
        FAILED_PAYMENT_PREFIX:
            "We regret to inform you that your recent payment of ",
        ON_SEGMENT: " on ",
        FAILED_SUFFIX: " has failed. ",
        BANK_APPROVAL_MESSAGE:
            "Please contact your bank to approve the charge so our team can reprocess your payment.",
        PROMPT_ATTENTION_MESSAGE:
            "Thank you for your prompt attention to this matter.",
    },
    PAYMENT_REQUEST_RECEIPT_CONTACT_TEMPLATE: {
        THANK_YOU_MESSAGE:
            "Thank you for submitting your payment. Attached is your receipt.",
        QUESTIONS_SEGMENT:
            "If you have any questions about your payment, please contact us at ",
    },
    BOOKING_RECEIPT_CONTACT_TEMPLATE: {
        THANK_YOU_MESSAGE:
            "Thank you for submitting your payment. Attached is your receipt.",
        QUESTIONS_SEGMENT:
            "If you have any questions about your trip, please contact us at ",
    },
    BOOKING_UPDATE_CONTACT_TEMPLATE: {
        TITLE: "Changes to your reservation",
        BOOKING_CHANGED_MESSAGE: "Your booking has changed.",
        BOOKING_CHANGES_PLACEHOLDER:
            "Booking changes will be displayed here...",
    },
    BOOKING_INVITE_INVOICE_CONTACT_TEMPLATE: {
        TITLE_PREFIX: "Your Requested Invoice for ",
        TITLE_SUFFIX: " Trip",
        INVOICE_ATTACHED_FRAGMENT:
            "Attached is the invoice for the trip you'd like to book with ",
        USE_LINK_MESSAGE:
            "You can use the link below to accept the trip details and provide your payment information.",
        CHANGES_MESSAGE:
            "If you need to make any changes to the trip, please reply to this email.",
        LOOKING_FORWARD: "We are looking forward to serving you.",
    },
    BOOKING_INVITE_CONTACT_TEMPLATE: {
        TITLE_PREFIX: "Your Requested Quote for ",
        TITLE_SUFFIX: " Trip",
        BODY: "You can use the link below to review final trip details, choose add ons, and provide your payment information.",
    },
    FORM_SUBMISSION_CONTACT_TEMPLATE: {
        TITLE: "Your form submission has been completed",
        BODY_PREFIX: 'Your form submission for "',
        BODY_MIDDLE: '" with ',
        BODY_SUFFIX:
            '" has been completed successfully. Please find the completed form attached to this email.',
        THANK_YOU: "Thank you for your submission!",
    },
    PRE_TRIP_REMINDER_CONTACT_TEMPLATE: {
        INTRO: "Welcome! Your trip is officially confirmed — we're excited to have you join us. Please take a moment to review your trip details below.",
        CLOSING:
            "We're looking forward to sharing this experience with you. Safe travels and happy hunting!",
    },
    TRIP_DETAIL_REMINDER_CONTACT_TEMPLATE: {
        INTRO: "Your trip is just around the corner! Take a moment to review your booking details and make sure everything looks good before your trip date.",
        CLOSING:
            "We can't wait to see you out there. If you have any last-minute questions, don't hesitate to reach out!",
    },
    PROSPECTIVE_CONTACT_REMINDER_CONTACT_TEMPLATE: {
        BODY: "Just checking in on the quote we sent over. We'd love to have you join us — if you have any questions or need help deciding, feel free to reach out. You can review your trip details and book using the link below.",
        CLOSING: "Hope to see you out there!",
    },
    GEAR_LIST_CONTACT_TEMPLATE: {
        INTRO_PREFIX: "Your upcoming",
        INTRO_MIDDLE: "with",
        INTRO_SUFFIX:
            "is getting closer — now's a great time to start preparing your gear. Below is our recommended packing list to help you stay comfortable, safe, and fully prepared for the experience.",
        CLOSING:
            "If you're unsure about any item on the list or want recommendations, feel free to reply to this email — we're happy to help you get ready.",
        SIGN_OFF: "We're looking forward to an amazing trip with you.",
    },
    PAYMENT_REQUEST_CREATED_CONTACT_TEMPLATE: {
        BODY: "An additional payment request has been submitted for your trip with us. Please click below to review the details.",
    },
    PAYMENT_REQUEST_REMINDER_CONTACT_TEMPLATE: {
        PREFIX: "Reminder: ",
        BODY: "An additional payment request has been submitted for your trip with us. Please click below to review the details.",
    },
    PAYMENT_REQUEST_TEMPLATE: {
        QUESTIONS: "If you have any questions, please reach out to us at ",
        THANK_YOU_PREFIX: "Thank you for booking with ",
    },
    TRIP_APPROACHING_TEMPLATE: {
        LINE_ONE:
            "Your trip is coming up soon and we're excited to host you. To help you prepare, here are a few general tips:",
        LIST_ITEM_ONE:
            "Plan to arrive a little early so everything starts smoothly.",
        LIST_ITEM_TWO:
            "Bring weather-appropriate clothing and any personal items you may need for comfort.",
        LIST_ITEM_THREE:
            "Don't forget essentials like sun protection, snacks, or drinks if you'd like.",
        LINE_TWO:
            "If you have any questions before the trip, just reply here. We're looking forward to a great experience together.",
    },
    TEMPLATE_FOOTER: {
        POWERED_BY: "Powered by ",
    },
    GOOGLE: "Google",
    REVERSE: "Reverse",
    NO_PADDING: "No Padding",
    TOPIC: "Topic",
    SENT: "Sent",
    NO_MESSAGES_FOUND: "No messages found.",
    NO_PREVIEW_AVAILABLE: "No preview available",
    COMMUNICATION_ACTIVITY: "Communication Activity",
    SELECT_FORM_IN_SETTINGS: "Select form in settings",
    SELECT_DOCUMENT_IN_SETTINGS: "Select document in settings",
    FORM_LINK: "Form Link",
    DOCUMENT_LINK: "Document Link",
    OPACITY: "Opacity",
    ARCHIVE_CALENDAR_EVENT_SUCCESS: "Successfully deleted calendar event!",
    DELETE_OFFLINE_PAYMENT_SUCCESS: "Successfully deleted offline payment!",
    MARK_NOTE_THREAD_AS_RESOLVED_SUCCESS:
        "Successfully marked thread as resolved!",
    MARK_NOTE_THREAD_AS_UNRESOLVED_SUCCESS:
        "Successfully marked thread as unresolved!",
    DELETE_NOTE_THREAD_SUCCESS: "Successfully deleted thread!",
    DELETE_NOTE_SUCCESS: "Successfully deleted note!",
    DELETE_EVENT_CONFIRMATION: {
        TITLE: "Delete Event",
        MESSAGE: "Are you sure you want to delete this event?",
    },
    DELETE_OFFLINE_PAYMENT_CONFIRMATION: {
        TITLE: "Delete Offline Payment",
        MESSAGE: "Are you sure you want to delete this offline payment?",
    },
    LISTING_AND_PRICING_PACKAGE_SELECTION:
        "Listing and Pricing Package Selection",
    SHOULD_ALLOW_SELECTING_PRICING_PACKAGES:
        "Should allow selecting pricing packages?",
    UPDATE_AVAILABILITY_CONFIRMATION: {
        TITLE: "Single use resource",
        MESSAGE:
            "This resource is configured to be single use per time slot and is scheduled to be used on one or more of the selected dates. Are you sure you want to mark these dates as available?",
    },
    ADDITIONAL: "Additional",
    FEEDBACK: "Feedback",
    ENTER_FEEDBACK_MODE: "Enter Feedback Mode",
    EXIT_FEEDBACK_MODE: "Exit Feedback Mode",
    STYLE_BACKGROUND_IMAGE: "Style background image",
    TERMS_DESCRIPTION: "The terms and conditions of your liability waiver",
    ENTER_DEPOSIT_AMOUNT: "Enter deposit amount",
    DO_YOU_WANT_TO_LOG_A_COLLECTED_PAYMENT:
        "Do you want to log a collected payment?",
    LOG_A_COLLECTED_PAYMENT_FOR_THIS_BOOKING:
        "Log a collected payment for this booking",
    AMOUNT_RECEIVED: "Amount received *",
    DATE_RECEIVED_INPUT_LABEL: "Date received *",
    LOG_A_PAYMENT_YOU_ALREADY_GOT: "Log a payment you've already received?",
    USE_THIS_FOR_DEPOSITS_CASH:
        "Use this for deposits, cash, checks, or any other money that’s already in hand.",
    QUOTE_PAYMENT_DUE_DATE_UPDATED_SUCCESSFULLY:
        "Successfully updated quote payment due date",
    EDIT_DUE_DATE: "Edit Due Date",
    SELECT_DUE_DATE: "Select Due Date",
    NO_FEEDBACK_YET: "No feedback yet",
    FILTER_BY_PAGE: "Filter by page",
    FILTER_BY_RESOLVED: "Filter by resolved",
    UNRESOLVED: "Unresolved",
    RESOLVED: "Resolved",
    ALL_PAGES: "All pages",
    MARK_AS_RESOLVED: "Mark as resolved",
    MARK_AS_UNRESOLVED: "Mark as unresolved",
    FEEDBACK_PLACEHOLDER: "Write your comment here...",
    FEEDBACK_FILTERS: "Feedback Filters",
    EMAIL_OR_LINK_QR: "Email or Link/QR",
    DO_YOU_WANT_TO_EMAIL_THE_PAYMENT_LINK:
        "Do you want to email the payment link?",
    YOU_CAN_SHARE_THE_PAYMENT:
        "You can share the payment details with the contact using a secure link or QR code.",
    DO_YOU_WANT_TO_COLLECT_A_PAYMENT: "Do you want to collect a payment?",
    COLLECT_PAYMENT_NOW_OR_SCHEDULE_FOR_LATER:
        "Collect payment now or schedule for later",
    CARD_OR_BANK: "Card or Bank",
    SHOULD_SEND_CONTACT_CONFIRMATION_NOTIFICATION_SUBTITLE:
        "If enabled, a confirmation email will be sent to the contact when the booking is created.",
    CASH_OR_CHECK: "Cash or Check",
    ADD_NOTES_FOR_THIS_PAYMENT: "Add notes for this payment",
    SHARE_PAYMENT_LINK: "Share payment link",
    FEEDBACK_UNSAVED_CHANGES_MESSAGE:
        "You have unsaved changes. Please save your changes before enabling feedback mode.",
    UNSAVED_CHANGES: "Unsaved Changes",
    UNSAVED_CHANGES_WARNING_MESSAGE:
        "You have unsaved changes. If you leave this page, your changes will be lost.",
    LEAVE_PAGE: "Leave Page",
    STAY_ON_PAGE: "Stay on Page",
    DELETE_THREAD: "Delete thread",
    DELETE_NOTE: "Delete note",
    MARK_AS_READ: "Mark as read",
    MARK_AS_UNREAD: "Mark as unread",
    DELETE_THREAD_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this thread? This will delete the note and all replies.",
    DELETE_NOTE_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this note?",
    PAYMENT_PLANS: "Payment plans",
    SEND_EMAIL_SUCCESS: "Successfully sent email!",
    RESEND_EMAIL: "Resend Email",
    RESEND_BOOKING_EMAIL: "Resend Booking Email",
    CONFIRMATION: "Confirmation",
    RECEIPT: "Receipt",
    EMAIL_TYPE: "Email type",
    RECIPIENT: "Recipient",
    CUSTOM_RECIPIENT_EMAIL: "Custom recipient email",
    CUSTOM_RECIPIENT_EMAIL_PLACEHOLDER: "assistant@example.com",
    CUSTOM_RECIPIENT_EMAIL_HELPER:
        "Optional. Sends this email to the custom address instead of the selected recipient's email address.",
    SHOW_QR_CODE_LINK: "Show QR Code / Link",
    PAYMENT_TYPE: "Payment type",
    PAYMENT_RECEIVED: "Payment received",
    PAYMENT_PLANS_HELPER_TEXT: "Choose when and how payments will be charged",
    EMAIL_WILL_BE_SENT_TO: "Email will be sent to",
    PLEASE_ENTER_A_VALID_EMAIL: "Please enter a valid email",
    NO_RESOURCES_YET: "No resources yet",
    TEAM_MEMBER: "Team member",
    NO_FAQS_YET: "No FAQs yet",
    FREQUENTLY_ASKED_QUESTIONS: "Frequently Asked Questions",
    EDIT_FAQ: "Edit FAQ",
    ADD_FAQ: "Add FAQ",
    REORDER_FAQS: "Reorder FAQs",
    QUESTION: "Question",
    ANSWER: "Answer",
    ANSWER_PLACEHOLDER: "Answer...",
    QUESTION_PLACEHOLDER: "Question...",
    DELETE_FAQ: "Delete FAQ",
    DELETE_FAQ_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this FAQ?",
    TAX_DEFINITIONS: "Tax Definitions",
    NO_TAX_DEFINITIONS_YET: "No tax definitions yet",
    ADD_TAX_DEFINITION: "Add tax definition",
    EDIT_TAX_DEFINITION: "Edit tax definition",
    DELETE_TAX_DEFINITION: "Delete tax definition",
    REORDER_TAX_DEFINITIONS: "Reorder tax definitions",
    DELETE_TAX_DEFINITION_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this tax definition?",
    TAX_DEFINITION_NAME: "Name",
    TAX_DEFINITION_NAME_PLACEHOLDER: "e.g. State Sales Tax",
    TAX_DEFINITION_RATE: "Rate",
    TAX_DEFINITION_CODE: "Code",
    TAX_DEFINITION_CODE_PLACEHOLDER: "Optional code",
    TAX_DEFINITION_IS_ACTIVE: "Active",
    APPLIED_TAXES: "Applied taxes",
    APPLIED_TAXES_DESCRIPTION:
        "Select which taxes apply to this pricing package.",
    GUIDE_ASSIGNED_SUCCESS: "Successfully assigned guide to booking!",
    SHOULD_UPDATE_AVAILABILITY_TITLE: "Should update availability?",
    UPDATE_AVAILABILITY_SUBTITLE:
        "If enabled, the availability will be updated for the selected dates.",
    RESOURCES_ASSIGNED_SUCCESS: "Successfully assigned resources to booking!",
    LODGINGS_ASSIGNED_SUCCESS: "Successfully assigned lodgings to booking!",
    ASSIGN_RESOURCES_TO_BOOKING: "Assign resources to booking",
    ASSIGN_RESOURCES: "Assign resources",
    NO_LODGINGS_AVAILABLE: "No lodgings available",
    ASSIGN_LODGINGS_TO_BOOKING: "Assign lodgings to booking",
    SELECT_LODGINGS: "Select lodgings",
    NO_RESOURCES_AVAILABLE: "No resources available",
    CHAT_WIDGET_ENABLED_LABEL: "Is website chat assistant enabled?",
    FEATURED_OUTFITTER_LABEL: "Is this a featured outfitter?",
    FEATURED_OUTFITTER: "Featured Outfitter",
    ADMIN_NOTES_LABEL: "Admin notes",
    ADMIN_NOTES_PLACEHOLDER: "Enter your notes",
    EDIT_FEATURES_AND_NOTES: "Edit Features & Notes",
    FEATURES_AND_NOTES: "Features & Notes",
    WEBSITE_AI_ASSISTANT: "Website AI Assistant",
    LISTING_DESCRIPTION: "Listing description",
    LISTING_PAGE_CONTENT: "Listing (Stacked)",
    NO_NOTES: "No notes",
    ADMIN_NOTES: "Admin Notes",
    REGISTER_FOR_SMS_SUCCESS: "Successfully registered for SMS!",
    SUSPENSION: {
        HEADING: "Suspension Warning",
        MESSAGE_PART_ONE: " is suspended. ",
        MESSAGE_PART_TWO_A:
            "Bookings can't be approved until the suspension is lifted.",
        MESSAGE_PART_TWO_B:
            "The contacts have been notified of the suspension, but the booking has not been invalidated.",
        CONTACT_EMAIL: "Please email ",
        CONTACT_PHONE: " or call ",
        CONTACT_INFO: " for more information.",
    },
    RETRY_TRIP_INSURANCE_SUCCESS: "Successfully purchased trip insurance!",
    PURCHASE_TRIP_INSURANCE: "Purchase Trip Insurance",
    RETRY_TRIP_INSURANCE: "Retry Trip Insurance",
    RETRY_TRIP_INSURANCE_MODAL_TITLE: "Retry Trip Insurance Purchase",
    SUCCESSFULLY_UPDATED_SETTING: "Successfully updated setting",
    IS_DISABLED: "is disabled",
    ACTIVITY_FEED: "Activity Feed",
    WORKFLOW_UPDATED: "Workflow updated",
    NOTIFICATION_FAILED: "Notification failed",
    NOTIFICATION_SENT: "Notification sent",
    AUTOMATION_IN_PROGRESS: "Automation in progress",
    NO_ACTIVITY_YET: "No activity yet.",
    CHANNEL_NOT_CONFIGURED: {
        SMS: {
            TITLE: "SMS is disabled",
            DESCRIPTION:
                "Complete your SMS configuration to enable SMS templates.",
            CTA: "Configure SMS",
        },
        EMAIL: {
            TITLE: "Upgrade your emails",
            DESCRIPTION:
                "Add a custom domain so emails come from your own address instead of a generic one.",
            CTA: "Configure Domain",
        },
    },
    MONTH: "Month",
    WEEK: "Week",
    DAY: "Day",
    MONTHS: {
        JANUARY: "January",
        FEBRUARY: "February",
        MARCH: "March",
        APRIL: "April",
        MAY: "May",
        JUNE: "June",
        JULY: "July",
        AUGUST: "August",
        SEPTEMBER: "September",
        OCTOBER: "October",
        NOVEMBER: "November",
        DECEMBER: "December",
    },
    NEW_ADD_ON: "New Add-on",
    IS_ADD_ONS_INCLUDED: "Does this package include any add-ons in the price?",
    PRICING_TAGS: {
        GROUP: "Group",
        PER_PERSON: "Per Person",
        SET_LENGTH: "Set Length",
        VARIABLE_LENGTH: "Variable Length",
        HIDDEN: "Hidden",
        GUEST: "guest",
        MAX: "max",
        DAY: "day",
    },
    LAST_PAYMENT_LABELS: {
        CONFIG_OPTION: "When should the last payment be charged?",
        BEFORE_START_DATE: "Before start date",
        LAST_DAY_OF_TRIP: "Last day of trip",
        SPECIFIC_DATE: "Specific date",
        BEFORE_TRIP_HELPER:
            "The number of days before the trip's start date that the final payments will be due.",
    },
    SELECT_AN: "Select an",
    SEARCH_ALL: "Search all",
    SWITCH_TO: "Switch to",
    DELETE_PRICING_PACKAGE_MESSAGE:
        "Are you sure you want to delete this pricing package?",
    AUCTION_FORM_LABELS: {
        SEARCH_TRIPS:
            "Enter a search and let AI find and notify matching outfitters.",
        NAME: "Auction name",
        LENGTH_OF_TRIP: "Length of trip (days)",
        NUMBER_OF_GUESTS: "Number of guests",
        QUANTITY_REQUESTED: "Quantity requested",
        AUCTION_ENDS_ON: "Auction ends on",
    },
    AUCTION_NAME_HELPER_TEXT:
        "Enter an optional name for your auction. If you do not provide one, the search phrase will be used.",
    SEARCH_TRIPS_PLACEHOLDER: "Search trips",
    SEARCH_TRIPS_HELPER_TEXT:
        'Try natural language, e.g. "duck hunting in Texas under $5,000"',
    CREATE_AUCTION: "Create auction",
    UPDATE_AUCTION: "Update auction",
    ENDED: "Ended",
    AUCTION_REQUESTS: "Auction Requests",
    SEARCH_AUCTION_REQUESTS: "Search auction requests",
    QUANTITY_AVAILABLE: "Qty. Available",
    BID: "Bid",
    SELECT_WINNERS: "Select Winners",
    CREATE_AUCTION_TRIPS: "Create Auction Trips",
    TAKE_QTY: "Take Qty",
    EDIT_AUCTION: "Edit Auction",
    COUNT_DOWN: "Countdown",
    QUANTITY_REQUESTED: "Quantity requested",
    ACTIONS: "Actions",
    SUBMIT_BID: "Submit Bid",
    BID_PRICE_HELPER: "Wholesale price for Regional Director",
    BID_QUANTITY_HELPER: "How many of this trip can you offer",
    BID_NOTES_PLACEHOLDER:
        "Optional details: dates available, inclusions, restrictions",
    AUCTION_TRIPS_BANNER: "Winners have 90 days to claim their trip.",
    SEND_TO_WINNER: "Send to Winner",
    AUCTION: "Auction",
    SET_DATES_AND_ADD_TO_CALENDAR: "Set Dates & Add to Calendar",
    TRIP_DATES_LABEL: "Trip Dates",
    TRIP_DATES_SUBLABEL: "Select the dates you'd like to book for this trip",
    SEND_CONFIRMATION_EMAIL_LABEL: "Send confirmation email to contact",
    CONTACT_CAPITALIZED: "Contact",
    ADD_TO_CALENDAR: "Add to Calendar",
    WINNERS_DETAILS: "Winner's Details",
    SPECIAL_REQUESTS: "Special Requests",
    DAYS_CAPITALIZED: "Days",
    CREATE_AUCTION_BOOKING_SUCCESS: "Successfully added to calendar",
    EVENT_ORGANIZER_SELF_ONBOARDING: {
        CONTACT_INFO: "Contact Information",
        CONTACT_INFO_DESCRIPTION:
            "Help outfitters connect with you directly to discuss partnership opportunities",
        PROFILE: "Profile and Impact Metrics",
        PROFILE_DESCRIPTION:
            "Demonstrate your experience and the scale of your member network",
        DOCUMENTS: "Supporting Documents",
        DOCUMENTS_DESCRIPTION:
            "Build credibility with certifications, testimonials, and proof of your track record",
    },
    ENTER_FULL_NAME: "Enter full name",
    EVENT_ORGANIZER_PROFILE_FORM: {
        BIO: "Bio",
        BIO_PLACEHOLDER:
            "Tell outfitters who you are, what you do, and the value you bring.",
        NUMBER_OF_ORGANIZED_EVENTS: "Number of Events Organized",
        NUMBER_OF_MEMBERS: "Number of Members",
    },
    AUCTION_ITEM: "Auction Item",
    TOTAL_PRICE: "Total price",
    ADMIN_ACTIONS: "Admin Actions",
    SOURCE_PLATFORM: "Source platform",
    AUCTION_REQUEST_DETAILS: "Auction Request Details",
    AUCTION_TRIP_DETAILS: "Auction Trip Details",
    AUCTION_TRIP_STATUS: "Auction trip status",
    SET_CUSTOM_TIME_WINDOW: "Set Custom Time Window",
    SET_CUSTOM_TIME_WINDOW_DESCRIPTION:
        "Turn on to set one or more custom time windows. Leave off to apply all day.",
    TIME_WINDOW: "Time Window",
    ADD_TIME_WINDOW: "Add Time Window",
    DELETE_ALL_CUSTOM_TIME_WINDOWS: "Delete all custom time windows",
    DELETE_ALL_CUSTOM_TIME_WINDOWS_DESCRIPTION:
        "Turn on to remove all custom time windows when you save.",
    TIME_WINDOWS_WILL_BE_CLEARED:
        "All custom time windows will be deleted when you save.",
    TIME_WINDOWS_OVERLAP_ERROR: "Time windows must not overlap",
    INVALID_TIME_WINDOW_SLOT_TOTALS:
        "Each time window must have a valid whole number of slots between 1 and 200",
    INVALID_TIME_INCREMENT_ERROR: "Time must be in 30-minute increments",
    END_TIME_MUST_BE_AFTER_START_TIME: "End time must be after start time",
    REMOVE_TIME_WINDOW: "Remove time window",
    ADDRESSES: "Addresses",
    MEETING_LOCATION: "Meeting Location",
    LISTING_LOCATION_SUBLABEL: "State and country to show on the listing",
    LISTING_MEETING_LOCATION_SUBLABEL:
        "Shown to contacts in booking confirmations",
    PRIMARY_ADDRESS: "Primary Address",
    MAILING_ADDRESS: "Mailing Address",
    PRIMARY_ADDRESS_SUBLABEL: "Used as your outfitter profile location",
    MAILING_ADDRESS_SUBLABEL: "Used on invoices and billing documents",
    SAME_AS_PRIMARY_ADDRESS: "Same as primary address",
    ONLY_STATE_AND_COUNTRY: "Only state and country are shown to contacts.",
    OUTFITTER_MEETING_BANNER: {
        TITLE: "Default Meeting Location",
        DESCRIPTION:
            "Applied to all listings by default. You can set a different meeting location on individual listings to override this.",
    },
    IN: "in",
    AI_ONBOARDING_NOTE:
        "Scanning typically takes 2-5 minutes for most websites. We'll show progress and let you know when it's ready. Sites with many pages may take up to 10 minutes.",
    AI_ONBOARDING_DOCUMENT_NOTE:
        "Upload documents (PDF, Word, Excel, and more) or add public file URLs. Scanning typically takes 2-5 minutes.",
    AI_ONBOARDING_DOCUMENT: {
        CHOOSE_FILES: "Choose Files",
        EMPTY: "No documents added yet",
        ADD_URL: "Add file URL",
        URL_PLACEHOLDER: "https://example.com/menu.pdf",
        REMOVE: "Remove",
        REQUIRED: "Add at least one document or public file URL.",
        MAX_FILES: "You've reached the maximum number of documents.",
        INVALID_URL:
            "Enter a valid public file URL starting with http or https.",
        FILE_TOO_LARGE: "This file is too large to upload.",
        UNSUPPORTED_TYPE: "This file type isn't supported.",
        UPLOAD_FAILED: "We couldn't upload this file. Please try again.",
    },
    MANUALLY: "Manually",
    IMPORT_FROM_WEBSITE: "Import from Website",
    IMPORT_FROM_DOCUMENT: "Import from documents",
    ONBOARDING_OPTIONS_LABEL: "How would you like to begin onboarding?",
    ONBOARDING_LOADING_TEXT: "Hang tight - this might take a while.",
    ONBOARDING_DOCUMENT_LOADING_TITLE: "Document import",
    ONBOARDING_DOCUMENT_LOADING_TEXT:
        "Hang tight - we're reading your documents.",
    AI_ONBOARDING_FAILED: "AI Onboarding Failed",
    AI_ONBOARDING_SUCCESS: "Success!",
    FORM_PREVIEW: "Form Preview",
    LEAD_GEN: "Lead Gen",
    INPUTS: "Inputs",
    DUPLICATE_LISTING: "Duplicate listing",
    TEMPLATE_TYPE_DESCRIPTION: {
        SPORTSMAN:
            "For messages to contacts or leads. Can be sent from booking, contact, contact list, and lead pages.",
        BOOKING:
            "For messages related to a booked trip. Can be sent from booking pages.",
    },
    NEW_EXPORT: "New export",
    ONE_PHOTO_REQUIRED: "At least one photo is required",
    ADDITIONAL_PAYMENT: "Additional Payment",
    ENABLE: "Enable",
    DISABLE: "Disable",
    CLIENTS_PAGE_TITLE: "Clients Have Been Moved",
    CLIENTS_HAVE_BEEN_MOVED_TO_CONTACTS:
        "Clients have been moved to Contacts. Use the button below to head to the new page.",
    GO_TO_CONTACTS: "Go to Contacts",
    NO_REFERRAL_SOURCE: "No referral source",
    ONBOARDING_TASKS: {
        TITLE: "Onboarding Tasks",
        HEADING: "Let's get you set up",
        SUBHEADING:
            "A few quick steps and you'll be ready to hit the ground running. Check off each task below — it won't take long.",
        COMPLETED_SUFFIX: "Completed",
        EMPTY_STATE: "No tasks to complete",
    },
    CLIENTS: "Clients",
} as const

export default COPY_CONSTANTS
